/*
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function (b, c) {
  var $ = b.jQuery || b.Cowboy || (b.Cowboy = {}),
    a;
  $.throttle = a = function (e, f, j, i) {
    var h,
      d = 0;
    if (typeof f !== "boolean") {
      i = j;
      j = f;
      f = c;
    }
    function g() {
      var o = this,
        m = +new Date() - d,
        n = arguments;
      function l() {
        d = +new Date();
        j.apply(o, n);
      }
      function k() {
        h = c;
      }
      if (i && !h) {
        l();
      }
      h && clearTimeout(h);
      if (i === c && m > e) {
        l();
      } else {
        if (f !== true) {
          h = setTimeout(i ? k : l, i === c ? e - m : e);
        }
      }
    }
    if ($.guid) {
      g.guid = j.guid = j.guid || $.guid++;
    }
    return g;
  };
  $.debounce = function (d, e, f) {
    return f === c ? a(d, e, false) : a(d, f, e !== false);
  };
})(this);

/**
 * @license
 * Lodash lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 */
(function () {
  function n(n, t) {
    return n.set(t[0], t[1]), n;
  }
  function t(n, t) {
    return n.add(t), n;
  }
  function r(n, t, r) {
    switch (r.length) {
      case 0:
        return n.call(t);
      case 1:
        return n.call(t, r[0]);
      case 2:
        return n.call(t, r[0], r[1]);
      case 3:
        return n.call(t, r[0], r[1], r[2]);
    }
    return n.apply(t, r);
  }
  function e(n, t, r, e) {
    for (var u = -1, i = null == n ? 0 : n.length; ++u < i; ) {
      var o = n[u];
      t(e, o, r(o), n);
    }
    return e;
  }
  function u(n, t) {
    for (var r = -1, e = null == n ? 0 : n.length; ++r < e && false !== t(n[r], r, n); );
    return n;
  }
  function i(n, t) {
    for (var r = null == n ? 0 : n.length; r-- && false !== t(n[r], r, n); );
    return n;
  }
  function o(n, t) {
    for (var r = -1, e = null == n ? 0 : n.length; ++r < e; ) if (!t(n[r], r, n)) return false;
    return true;
  }
  function f(n, t) {
    for (var r = -1, e = null == n ? 0 : n.length, u = 0, i = []; ++r < e; ) {
      var o = n[r];
      t(o, r, n) && (i[u++] = o);
    }
    return i;
  }
  function c(n, t) {
    return !(null == n || !n.length) && -1 < d(n, t, 0);
  }
  function a(n, t, r) {
    for (var e = -1, u = null == n ? 0 : n.length; ++e < u; ) if (r(t, n[e])) return true;
    return false;
  }
  function l(n, t) {
    for (var r = -1, e = null == n ? 0 : n.length, u = Array(e); ++r < e; ) u[r] = t(n[r], r, n);
    return u;
  }
  function s(n, t) {
    for (var r = -1, e = t.length, u = n.length; ++r < e; ) n[u + r] = t[r];
    return n;
  }
  function h(n, t, r, e) {
    var u = -1,
      i = null == n ? 0 : n.length;
    for (e && i && (r = n[++u]); ++u < i; ) r = t(r, n[u], u, n);
    return r;
  }
  function p(n, t, r, e) {
    var u = null == n ? 0 : n.length;
    for (e && u && (r = n[--u]); u--; ) r = t(r, n[u], u, n);
    return r;
  }
  function _(n, t) {
    for (var r = -1, e = null == n ? 0 : n.length; ++r < e; ) if (t(n[r], r, n)) return true;
    return false;
  }
  function v(n, t, r) {
    var e;
    return (
      r(n, function (n, r, u) {
        if (t(n, r, u)) return (e = r), false;
      }),
      e
    );
  }
  function g(n, t, r, e) {
    var u = n.length;
    for (r += e ? 1 : -1; e ? r-- : ++r < u; ) if (t(n[r], r, n)) return r;
    return -1;
  }
  function d(n, t, r) {
    if (t === t)
      n: {
        --r;
        for (var e = n.length; ++r < e; )
          if (n[r] === t) {
            n = r;
            break n;
          }
        n = -1;
      }
    else n = g(n, b, r);
    return n;
  }
  function y(n, t, r, e) {
    --r;
    for (var u = n.length; ++r < u; ) if (e(n[r], t)) return r;
    return -1;
  }
  function b(n) {
    return n !== n;
  }
  function x(n, t) {
    var r = null == n ? 0 : n.length;
    return r ? k(n, t) / r : P;
  }
  function j(n) {
    return function (t) {
      return null == t ? F : t[n];
    };
  }
  function w(n) {
    return function (t) {
      return null == n ? F : n[t];
    };
  }
  function m(n, t, r, e, u) {
    return (
      u(n, function (n, u, i) {
        r = e ? ((e = false), n) : t(r, n, u, i);
      }),
      r
    );
  }
  function A(n, t) {
    var r = n.length;
    for (n.sort(t); r--; ) n[r] = n[r].c;
    return n;
  }
  function k(n, t) {
    for (var r, e = -1, u = n.length; ++e < u; ) {
      var i = t(n[e]);
      i !== F && (r = r === F ? i : r + i);
    }
    return r;
  }
  function E(n, t) {
    for (var r = -1, e = Array(n); ++r < n; ) e[r] = t(r);
    return e;
  }
  function O(n, t) {
    return l(t, function (t) {
      return [t, n[t]];
    });
  }
  function S(n) {
    return function (t) {
      return n(t);
    };
  }
  function I(n, t) {
    return l(t, function (t) {
      return n[t];
    });
  }
  function R(n, t) {
    return n.has(t);
  }
  function z(n, t) {
    for (var r = -1, e = n.length; ++r < e && -1 < d(t, n[r], 0); );
    return r;
  }
  function W(n, t) {
    for (var r = n.length; r-- && -1 < d(t, n[r], 0); );
    return r;
  }
  function B(n) {
    return "\\" + Tn[n];
  }
  function L(n) {
    var t = -1,
      r = Array(n.size);
    return (
      n.forEach(function (n, e) {
        r[++t] = [e, n];
      }),
      r
    );
  }
  function U(n, t) {
    return function (r) {
      return n(t(r));
    };
  }
  function C(n, t) {
    for (var r = -1, e = n.length, u = 0, i = []; ++r < e; ) {
      var o = n[r];
      (o !== t && "__lodash_placeholder__" !== o) ||
        ((n[r] = "__lodash_placeholder__"), (i[u++] = r));
    }
    return i;
  }
  function D(n) {
    var t = -1,
      r = Array(n.size);
    return (
      n.forEach(function (n) {
        r[++t] = n;
      }),
      r
    );
  }
  function M(n) {
    var t = -1,
      r = Array(n.size);
    return (
      n.forEach(function (n) {
        r[++t] = [n, n];
      }),
      r
    );
  }
  function T(n) {
    if (Bn.test(n)) {
      for (var t = (zn.lastIndex = 0); zn.test(n); ) ++t;
      n = t;
    } else n = tt(n);
    return n;
  }
  function $(n) {
    return Bn.test(n) ? n.match(zn) || [] : n.split("");
  }
  var F,
    N = 1 / 0,
    P = NaN,
    Z = [
      ["ary", 128],
      ["bind", 1],
      ["bindKey", 2],
      ["curry", 8],
      ["curryRight", 16],
      ["flip", 512],
      ["partial", 32],
      ["partialRight", 64],
      ["rearg", 256],
    ],
    q = /\b__p\+='';/g,
    V = /\b(__p\+=)''\+/g,
    K = /(__e\(.*?\)|\b__t\))\+'';/g,
    G = /&(?:amp|lt|gt|quot|#39);/g,
    H = /[&<>"']/g,
    J = RegExp(G.source),
    Y = RegExp(H.source),
    Q = /<%-([\s\S]+?)%>/g,
    X = /<%([\s\S]+?)%>/g,
    nn = /<%=([\s\S]+?)%>/g,
    tn = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    rn = /^\w*$/,
    en = /^\./,
    un =
      /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
    on = /[\\^$.*+?()[\]{}|]/g,
    fn = RegExp(on.source),
    cn = /^\s+|\s+$/g,
    an = /^\s+/,
    ln = /\s+$/,
    sn = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
    hn = /\{\n\/\* \[wrapped with (.+)\] \*/,
    pn = /,? & /,
    _n = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
    vn = /\\(\\)?/g,
    gn = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
    dn = /\w*$/,
    yn = /^[-+]0x[0-9a-f]+$/i,
    bn = /^0b[01]+$/i,
    xn = /^\[object .+?Constructor\]$/,
    jn = /^0o[0-7]+$/i,
    wn = /^(?:0|[1-9]\d*)$/,
    mn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
    An = /($^)/,
    kn = /['\n\r\u2028\u2029\\]/g,
    En =
      "[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?(?:\\u200d(?:[^\\ud800-\\udfff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?)*",
    On =
      "(?:[\\u2700-\\u27bf]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])" +
      En,
    Sn =
      "(?:[^\\ud800-\\udfff][\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]?|[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff])",
    In = RegExp("['\u2019]", "g"),
    Rn = RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", "g"),
    zn = RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|" + Sn + En, "g"),
    Wn = RegExp(
      [
        "[A-Z\\xc0-\\xd6\\xd8-\\xde]?[a-z\\xdf-\\xf6\\xf8-\\xff]+(?:['\u2019](?:d|ll|m|re|s|t|ve))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde]|$)|(?:[A-Z\\xc0-\\xd6\\xd8-\\xde]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde](?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])|$)|[A-Z\\xc0-\\xd6\\xd8-\\xde]?(?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:d|ll|m|re|s|t|ve))?|[A-Z\\xc0-\\xd6\\xd8-\\xde]+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?|\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)|\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)|\\d+",
        On,
      ].join("|"),
      "g"
    ),
    Bn = RegExp(
      "[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"
    ),
    Ln = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
    Un =
      "Array Buffer DataView Date Error Float32Array Float64Array Function Int8Array Int16Array Int32Array Map Math Object Promise RegExp Set String Symbol TypeError Uint8Array Uint8ClampedArray Uint16Array Uint32Array WeakMap _ clearTimeout isFinite parseInt setTimeout".split(
        " "
      ),
    Cn = {};
  (Cn["[object Float32Array]"] =
    Cn["[object Float64Array]"] =
    Cn["[object Int8Array]"] =
    Cn["[object Int16Array]"] =
    Cn["[object Int32Array]"] =
    Cn["[object Uint8Array]"] =
    Cn["[object Uint8ClampedArray]"] =
    Cn["[object Uint16Array]"] =
    Cn["[object Uint32Array]"] =
      true),
    (Cn["[object Arguments]"] =
      Cn["[object Array]"] =
      Cn["[object ArrayBuffer]"] =
      Cn["[object Boolean]"] =
      Cn["[object DataView]"] =
      Cn["[object Date]"] =
      Cn["[object Error]"] =
      Cn["[object Function]"] =
      Cn["[object Map]"] =
      Cn["[object Number]"] =
      Cn["[object Object]"] =
      Cn["[object RegExp]"] =
      Cn["[object Set]"] =
      Cn["[object String]"] =
      Cn["[object WeakMap]"] =
        false);
  var Dn = {};
  (Dn["[object Arguments]"] =
    Dn["[object Array]"] =
    Dn["[object ArrayBuffer]"] =
    Dn["[object DataView]"] =
    Dn["[object Boolean]"] =
    Dn["[object Date]"] =
    Dn["[object Float32Array]"] =
    Dn["[object Float64Array]"] =
    Dn["[object Int8Array]"] =
    Dn["[object Int16Array]"] =
    Dn["[object Int32Array]"] =
    Dn["[object Map]"] =
    Dn["[object Number]"] =
    Dn["[object Object]"] =
    Dn["[object RegExp]"] =
    Dn["[object Set]"] =
    Dn["[object String]"] =
    Dn["[object Symbol]"] =
    Dn["[object Uint8Array]"] =
    Dn["[object Uint8ClampedArray]"] =
    Dn["[object Uint16Array]"] =
    Dn["[object Uint32Array]"] =
      true),
    (Dn["[object Error]"] = Dn["[object Function]"] = Dn["[object WeakMap]"] = false);
  var Mn,
    Tn = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" },
    $n = parseFloat,
    Fn = parseInt,
    Nn = typeof global == "object" && global && global.Object === Object && global,
    Pn = typeof self == "object" && self && self.Object === Object && self,
    Zn = Nn || Pn || Function("return this")(),
    qn = typeof exports == "object" && exports && !exports.nodeType && exports,
    Vn = qn && typeof module == "object" && module && !module.nodeType && module,
    Kn = Vn && Vn.exports === qn,
    Gn = Kn && Nn.process;
  n: {
    try {
      Mn = Gn && Gn.binding && Gn.binding("util");
      break n;
    } catch (n) {}
    Mn = void 0;
  }
  var Hn = Mn && Mn.isArrayBuffer,
    Jn = Mn && Mn.isDate,
    Yn = Mn && Mn.isMap,
    Qn = Mn && Mn.isRegExp,
    Xn = Mn && Mn.isSet,
    nt = Mn && Mn.isTypedArray,
    tt = j("length"),
    rt = w({
      "\xc0": "A",
      "\xc1": "A",
      "\xc2": "A",
      "\xc3": "A",
      "\xc4": "A",
      "\xc5": "A",
      "\xe0": "a",
      "\xe1": "a",
      "\xe2": "a",
      "\xe3": "a",
      "\xe4": "a",
      "\xe5": "a",
      "\xc7": "C",
      "\xe7": "c",
      "\xd0": "D",
      "\xf0": "d",
      "\xc8": "E",
      "\xc9": "E",
      "\xca": "E",
      "\xcb": "E",
      "\xe8": "e",
      "\xe9": "e",
      "\xea": "e",
      "\xeb": "e",
      "\xcc": "I",
      "\xcd": "I",
      "\xce": "I",
      "\xcf": "I",
      "\xec": "i",
      "\xed": "i",
      "\xee": "i",
      "\xef": "i",
      "\xd1": "N",
      "\xf1": "n",
      "\xd2": "O",
      "\xd3": "O",
      "\xd4": "O",
      "\xd5": "O",
      "\xd6": "O",
      "\xd8": "O",
      "\xf2": "o",
      "\xf3": "o",
      "\xf4": "o",
      "\xf5": "o",
      "\xf6": "o",
      "\xf8": "o",
      "\xd9": "U",
      "\xda": "U",
      "\xdb": "U",
      "\xdc": "U",
      "\xf9": "u",
      "\xfa": "u",
      "\xfb": "u",
      "\xfc": "u",
      "\xdd": "Y",
      "\xfd": "y",
      "\xff": "y",
      "\xc6": "Ae",
      "\xe6": "ae",
      "\xde": "Th",
      "\xfe": "th",
      "\xdf": "ss",
      "\u0100": "A",
      "\u0102": "A",
      "\u0104": "A",
      "\u0101": "a",
      "\u0103": "a",
      "\u0105": "a",
      "\u0106": "C",
      "\u0108": "C",
      "\u010a": "C",
      "\u010c": "C",
      "\u0107": "c",
      "\u0109": "c",
      "\u010b": "c",
      "\u010d": "c",
      "\u010e": "D",
      "\u0110": "D",
      "\u010f": "d",
      "\u0111": "d",
      "\u0112": "E",
      "\u0114": "E",
      "\u0116": "E",
      "\u0118": "E",
      "\u011a": "E",
      "\u0113": "e",
      "\u0115": "e",
      "\u0117": "e",
      "\u0119": "e",
      "\u011b": "e",
      "\u011c": "G",
      "\u011e": "G",
      "\u0120": "G",
      "\u0122": "G",
      "\u011d": "g",
      "\u011f": "g",
      "\u0121": "g",
      "\u0123": "g",
      "\u0124": "H",
      "\u0126": "H",
      "\u0125": "h",
      "\u0127": "h",
      "\u0128": "I",
      "\u012a": "I",
      "\u012c": "I",
      "\u012e": "I",
      "\u0130": "I",
      "\u0129": "i",
      "\u012b": "i",
      "\u012d": "i",
      "\u012f": "i",
      "\u0131": "i",
      "\u0134": "J",
      "\u0135": "j",
      "\u0136": "K",
      "\u0137": "k",
      "\u0138": "k",
      "\u0139": "L",
      "\u013b": "L",
      "\u013d": "L",
      "\u013f": "L",
      "\u0141": "L",
      "\u013a": "l",
      "\u013c": "l",
      "\u013e": "l",
      "\u0140": "l",
      "\u0142": "l",
      "\u0143": "N",
      "\u0145": "N",
      "\u0147": "N",
      "\u014a": "N",
      "\u0144": "n",
      "\u0146": "n",
      "\u0148": "n",
      "\u014b": "n",
      "\u014c": "O",
      "\u014e": "O",
      "\u0150": "O",
      "\u014d": "o",
      "\u014f": "o",
      "\u0151": "o",
      "\u0154": "R",
      "\u0156": "R",
      "\u0158": "R",
      "\u0155": "r",
      "\u0157": "r",
      "\u0159": "r",
      "\u015a": "S",
      "\u015c": "S",
      "\u015e": "S",
      "\u0160": "S",
      "\u015b": "s",
      "\u015d": "s",
      "\u015f": "s",
      "\u0161": "s",
      "\u0162": "T",
      "\u0164": "T",
      "\u0166": "T",
      "\u0163": "t",
      "\u0165": "t",
      "\u0167": "t",
      "\u0168": "U",
      "\u016a": "U",
      "\u016c": "U",
      "\u016e": "U",
      "\u0170": "U",
      "\u0172": "U",
      "\u0169": "u",
      "\u016b": "u",
      "\u016d": "u",
      "\u016f": "u",
      "\u0171": "u",
      "\u0173": "u",
      "\u0174": "W",
      "\u0175": "w",
      "\u0176": "Y",
      "\u0177": "y",
      "\u0178": "Y",
      "\u0179": "Z",
      "\u017b": "Z",
      "\u017d": "Z",
      "\u017a": "z",
      "\u017c": "z",
      "\u017e": "z",
      "\u0132": "IJ",
      "\u0133": "ij",
      "\u0152": "Oe",
      "\u0153": "oe",
      "\u0149": "'n",
      "\u017f": "s",
    }),
    et = w({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }),
    ut = w({ "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" }),
    it = (function w(En) {
      function On(n) {
        if (xu(n) && !af(n) && !(n instanceof Mn)) {
          if (n instanceof zn) return n;
          if (ci.call(n, "__wrapped__")) return Pe(n);
        }
        return new zn(n);
      }
      function Sn() {}
      function zn(n, t) {
        (this.__wrapped__ = n),
          (this.__actions__ = []),
          (this.__chain__ = !!t),
          (this.__index__ = 0),
          (this.__values__ = F);
      }
      function Mn(n) {
        (this.__wrapped__ = n),
          (this.__actions__ = []),
          (this.__dir__ = 1),
          (this.__filtered__ = false),
          (this.__iteratees__ = []),
          (this.__takeCount__ = 4294967295),
          (this.__views__ = []);
      }
      function Tn(n) {
        var t = -1,
          r = null == n ? 0 : n.length;
        for (this.clear(); ++t < r; ) {
          var e = n[t];
          this.set(e[0], e[1]);
        }
      }
      function Nn(n) {
        var t = -1,
          r = null == n ? 0 : n.length;
        for (this.clear(); ++t < r; ) {
          var e = n[t];
          this.set(e[0], e[1]);
        }
      }
      function Pn(n) {
        var t = -1,
          r = null == n ? 0 : n.length;
        for (this.clear(); ++t < r; ) {
          var e = n[t];
          this.set(e[0], e[1]);
        }
      }
      function qn(n) {
        var t = -1,
          r = null == n ? 0 : n.length;
        for (this.__data__ = new Pn(); ++t < r; ) this.add(n[t]);
      }
      function Vn(n) {
        this.size = (this.__data__ = new Nn(n)).size;
      }
      function Gn(n, t) {
        var r,
          e = af(n),
          u = !e && cf(n),
          i = !e && !u && sf(n),
          o = !e && !u && !i && gf(n),
          u = (e = e || u || i || o) ? E(n.length, ri) : [],
          f = u.length;
        for (r in n)
          (!t && !ci.call(n, r)) ||
            (e &&
              ("length" == r ||
                (i && ("offset" == r || "parent" == r)) ||
                (o && ("buffer" == r || "byteLength" == r || "byteOffset" == r)) ||
                Re(r, f))) ||
            u.push(r);
        return u;
      }
      function tt(n) {
        var t = n.length;
        return t ? n[cr(0, t - 1)] : F;
      }
      function ot(n, t) {
        return Te(Mr(n), gt(t, 0, n.length));
      }
      function ft(n) {
        return Te(Mr(n));
      }
      function ct(n, t, r) {
        ((r === F || hu(n[t], r)) && (r !== F || t in n)) || _t(n, t, r);
      }
      function at(n, t, r) {
        var e = n[t];
        (ci.call(n, t) && hu(e, r) && (r !== F || t in n)) || _t(n, t, r);
      }
      function lt(n, t) {
        for (var r = n.length; r--; ) if (hu(n[r][0], t)) return r;
        return -1;
      }
      function st(n, t, r, e) {
        return (
          oo(n, function (n, u, i) {
            t(e, n, r(n), i);
          }),
          e
        );
      }
      function ht(n, t) {
        return n && Tr(t, Lu(t), n);
      }
      function pt(n, t) {
        return n && Tr(t, Uu(t), n);
      }
      function _t(n, t, r) {
        "__proto__" == t && Ei
          ? Ei(n, t, { configurable: true, enumerable: true, value: r, writable: true })
          : (n[t] = r);
      }
      function vt(n, t) {
        for (var r = -1, e = t.length, u = Hu(e), i = null == n; ++r < e; )
          u[r] = i ? F : Wu(n, t[r]);
        return u;
      }
      function gt(n, t, r) {
        return n === n && (r !== F && (n = n <= r ? n : r), t !== F && (n = n >= t ? n : t)), n;
      }
      function dt(n, t, r, e, i, o) {
        var f,
          c = 1 & t,
          a = 2 & t,
          l = 4 & t;
        if ((r && (f = i ? r(n, e, i, o) : r(n)), f !== F)) return f;
        if (!bu(n)) return n;
        if ((e = af(n))) {
          if (((f = Ee(n)), !c)) return Mr(n, f);
        } else {
          var s = yo(n),
            h = "[object Function]" == s || "[object GeneratorFunction]" == s;
          if (sf(n)) return Wr(n, c);
          if ("[object Object]" == s || "[object Arguments]" == s || (h && !i)) {
            if (((f = a || h ? {} : Oe(n)), !c)) return a ? Fr(n, pt(f, n)) : $r(n, ht(f, n));
          } else {
            if (!Dn[s]) return i ? n : {};
            f = Se(n, s, dt, c);
          }
        }
        if ((o || (o = new Vn()), (i = o.get(n)))) return i;
        o.set(n, f);
        var a = l ? (a ? ye : de) : a ? Uu : Lu,
          p = e ? F : a(n);
        return (
          u(p || n, function (e, u) {
            p && ((u = e), (e = n[u])), at(f, u, dt(e, t, r, u, n, o));
          }),
          f
        );
      }
      function yt(n) {
        var t = Lu(n);
        return function (r) {
          return bt(r, n, t);
        };
      }
      function bt(n, t, r) {
        var e = r.length;
        if (null == n) return !e;
        for (n = ni(n); e--; ) {
          var u = r[e],
            i = t[u],
            o = n[u];
          if ((o === F && !(u in n)) || !i(o)) return false;
        }
        return true;
      }
      function xt(n, t, r) {
        if (typeof n != "function") throw new ei("Expected a function");
        return jo(function () {
          n.apply(F, r);
        }, t);
      }
      function jt(n, t, r, e) {
        var u = -1,
          i = c,
          o = true,
          f = n.length,
          s = [],
          h = t.length;
        if (!f) return s;
        r && (t = l(t, S(r))),
          e ? ((i = a), (o = false)) : 200 <= t.length && ((i = R), (o = false), (t = new qn(t)));
        n: for (; ++u < f; ) {
          var p = n[u],
            _ = null == r ? p : r(p),
            p = e || 0 !== p ? p : 0;
          if (o && _ === _) {
            for (var v = h; v--; ) if (t[v] === _) continue n;
            s.push(p);
          } else i(t, _, e) || s.push(p);
        }
        return s;
      }
      function wt(n, t) {
        var r = true;
        return (
          oo(n, function (n, e, u) {
            return (r = !!t(n, e, u));
          }),
          r
        );
      }
      function mt(n, t, r) {
        for (var e = -1, u = n.length; ++e < u; ) {
          var i = n[e],
            o = t(i);
          if (null != o && (f === F ? o === o && !Au(o) : r(o, f)))
            var f = o,
              c = i;
        }
        return c;
      }
      function At(n, t) {
        var r = [];
        return (
          oo(n, function (n, e, u) {
            t(n, e, u) && r.push(n);
          }),
          r
        );
      }
      function kt(n, t, r, e, u) {
        var i = -1,
          o = n.length;
        for (r || (r = Ie), u || (u = []); ++i < o; ) {
          var f = n[i];
          0 < t && r(f) ? (1 < t ? kt(f, t - 1, r, e, u) : s(u, f)) : e || (u[u.length] = f);
        }
        return u;
      }
      function Et(n, t) {
        return n && co(n, t, Lu);
      }
      function Ot(n, t) {
        return n && ao(n, t, Lu);
      }
      function St(n, t) {
        return f(t, function (t) {
          return gu(n[t]);
        });
      }
      function It(n, t) {
        t = Rr(t, n);
        for (var r = 0, e = t.length; null != n && r < e; ) n = n[$e(t[r++])];
        return r && r == e ? n : F;
      }
      function Rt(n, t, r) {
        return (t = t(n)), af(n) ? t : s(t, r(n));
      }
      function zt(n) {
        if (null == n) n = n === F ? "[object Undefined]" : "[object Null]";
        else if (ki && ki in ni(n)) {
          var t = ci.call(n, ki),
            r = n[ki];
          try {
            n[ki] = F;
            var e = true;
          } catch (n) {}
          var u = si.call(n);
          e && (t ? (n[ki] = r) : delete n[ki]), (n = u);
        } else n = si.call(n);
        return n;
      }
      function Wt(n, t) {
        return n > t;
      }
      function Bt(n, t) {
        return null != n && ci.call(n, t);
      }
      function Lt(n, t) {
        return null != n && t in ni(n);
      }
      function Ut(n, t, r) {
        for (
          var e = r ? a : c, u = n[0].length, i = n.length, o = i, f = Hu(i), s = 1 / 0, h = [];
          o--;

        ) {
          var p = n[o];
          o && t && (p = l(p, S(t))),
            (s = Mi(p.length, s)),
            (f[o] = !r && (t || (120 <= u && 120 <= p.length)) ? new qn(o && p) : F);
        }
        var p = n[0],
          _ = -1,
          v = f[0];
        n: for (; ++_ < u && h.length < s; ) {
          var g = p[_],
            d = t ? t(g) : g,
            g = r || 0 !== g ? g : 0;
          if (v ? !R(v, d) : !e(h, d, r)) {
            for (o = i; --o; ) {
              var y = f[o];
              if (y ? !R(y, d) : !e(n[o], d, r)) continue n;
            }
            v && v.push(d), h.push(g);
          }
        }
        return h;
      }
      function Ct(n, t, r) {
        var e = {};
        return (
          Et(n, function (n, u, i) {
            t(e, r(n), u, i);
          }),
          e
        );
      }
      function Dt(n, t, e) {
        return (
          (t = Rr(t, n)),
          (n = 2 > t.length ? n : It(n, vr(t, 0, -1))),
          (t = null == n ? n : n[$e(Ge(t))]),
          null == t ? F : r(t, n, e)
        );
      }
      function Mt(n) {
        return xu(n) && "[object Arguments]" == zt(n);
      }
      function Tt(n) {
        return xu(n) && "[object ArrayBuffer]" == zt(n);
      }
      function $t(n) {
        return xu(n) && "[object Date]" == zt(n);
      }
      function Ft(n, t, r, e, u) {
        if (n === t) t = true;
        else if (null == n || null == t || (!xu(n) && !xu(t))) t = n !== n && t !== t;
        else
          n: {
            var i = af(n),
              o = af(t),
              f = i ? "[object Array]" : yo(n),
              c = o ? "[object Array]" : yo(t),
              f = "[object Arguments]" == f ? "[object Object]" : f,
              c = "[object Arguments]" == c ? "[object Object]" : c,
              a = "[object Object]" == f,
              o = "[object Object]" == c;
            if ((c = f == c) && sf(n)) {
              if (!sf(t)) {
                t = false;
                break n;
              }
              (i = true), (a = false);
            }
            if (c && !a)
              u || (u = new Vn()),
                (t = i || gf(n) ? _e(n, t, r, e, Ft, u) : ve(n, t, f, r, e, Ft, u));
            else {
              if (
                !(1 & r) &&
                ((i = a && ci.call(n, "__wrapped__")), (f = o && ci.call(t, "__wrapped__")), i || f)
              ) {
                (n = i ? n.value() : n),
                  (t = f ? t.value() : t),
                  u || (u = new Vn()),
                  (t = Ft(n, t, r, e, u));
                break n;
              }
              if (c)
                t: if (
                  (u || (u = new Vn()),
                  (i = 1 & r),
                  (f = de(n)),
                  (o = f.length),
                  (c = de(t).length),
                  o == c || i)
                ) {
                  for (a = o; a--; ) {
                    var l = f[a];
                    if (!(i ? l in t : ci.call(t, l))) {
                      t = false;
                      break t;
                    }
                  }
                  if ((c = u.get(n)) && u.get(t)) t = c == t;
                  else {
                    (c = true), u.set(n, t), u.set(t, n);
                    for (var s = i; ++a < o; ) {
                      var l = f[a],
                        h = n[l],
                        p = t[l];
                      if (e) var _ = i ? e(p, h, l, t, n, u) : e(h, p, l, n, t, u);
                      if (_ === F ? h !== p && !Ft(h, p, r, e, u) : !_) {
                        c = false;
                        break;
                      }
                      s || (s = "constructor" == l);
                    }
                    c &&
                      !s &&
                      ((r = n.constructor),
                      (e = t.constructor),
                      r != e &&
                        "constructor" in n &&
                        "constructor" in t &&
                        !(
                          typeof r == "function" &&
                          r instanceof r &&
                          typeof e == "function" &&
                          e instanceof e
                        ) &&
                        (c = false)),
                      u.delete(n),
                      u.delete(t),
                      (t = c);
                  }
                } else t = false;
              else t = false;
            }
          }
        return t;
      }
      function Nt(n) {
        return xu(n) && "[object Map]" == yo(n);
      }
      function Pt(n, t, r, e) {
        var u = r.length,
          i = u,
          o = !e;
        if (null == n) return !i;
        for (n = ni(n); u--; ) {
          var f = r[u];
          if (o && f[2] ? f[1] !== n[f[0]] : !(f[0] in n)) return false;
        }
        for (; ++u < i; ) {
          var f = r[u],
            c = f[0],
            a = n[c],
            l = f[1];
          if (o && f[2]) {
            if (a === F && !(c in n)) return false;
          } else {
            if (((f = new Vn()), e)) var s = e(a, l, c, n, t, f);
            if (s === F ? !Ft(l, a, 3, e, f) : !s) return false;
          }
        }
        return true;
      }
      function Zt(n) {
        return !(!bu(n) || (li && li in n)) && (gu(n) ? _i : xn).test(Fe(n));
      }
      function qt(n) {
        return xu(n) && "[object RegExp]" == zt(n);
      }
      function Vt(n) {
        return xu(n) && "[object Set]" == yo(n);
      }
      function Kt(n) {
        return xu(n) && yu(n.length) && !!Cn[zt(n)];
      }
      function Gt(n) {
        return typeof n == "function"
          ? n
          : null == n
          ? Nu
          : typeof n == "object"
          ? af(n)
            ? Xt(n[0], n[1])
            : Qt(n)
          : Vu(n);
      }
      function Ht(n) {
        if (!Le(n)) return Ci(n);
        var t,
          r = [];
        for (t in ni(n)) ci.call(n, t) && "constructor" != t && r.push(t);
        return r;
      }
      function Jt(n, t) {
        return n < t;
      }
      function Yt(n, t) {
        var r = -1,
          e = pu(n) ? Hu(n.length) : [];
        return (
          oo(n, function (n, u, i) {
            e[++r] = t(n, u, i);
          }),
          e
        );
      }
      function Qt(n) {
        var t = me(n);
        return 1 == t.length && t[0][2]
          ? Ue(t[0][0], t[0][1])
          : function (r) {
              return r === n || Pt(r, n, t);
            };
      }
      function Xt(n, t) {
        return We(n) && t === t && !bu(t)
          ? Ue($e(n), t)
          : function (r) {
              var e = Wu(r, n);
              return e === F && e === t ? Bu(r, n) : Ft(t, e, 3);
            };
      }
      function nr(n, t, r, e, u) {
        n !== t &&
          co(
            t,
            function (i, o) {
              if (bu(i)) {
                u || (u = new Vn());
                var f = u,
                  c = n[o],
                  a = t[o],
                  l = f.get(a);
                if (l) ct(n, o, l);
                else {
                  var l = e ? e(c, a, o + "", n, t, f) : F,
                    s = l === F;
                  if (s) {
                    var h = af(a),
                      p = !h && sf(a),
                      _ = !h && !p && gf(a),
                      l = a;
                    h || p || _
                      ? af(c)
                        ? (l = c)
                        : _u(c)
                        ? (l = Mr(c))
                        : p
                        ? ((s = false), (l = Wr(a, true)))
                        : _
                        ? ((s = false), (l = Lr(a, true)))
                        : (l = [])
                      : wu(a) || cf(a)
                      ? ((l = c), cf(c) ? (l = Ru(c)) : (!bu(c) || (r && gu(c))) && (l = Oe(a)))
                      : (s = false);
                  }
                  s && (f.set(a, l), nr(l, a, r, e, f), f.delete(a)), ct(n, o, l);
                }
              } else (f = e ? e(n[o], i, o + "", n, t, u) : F), f === F && (f = i), ct(n, o, f);
            },
            Uu
          );
      }
      function tr(n, t) {
        var r = n.length;
        if (r) return (t += 0 > t ? r : 0), Re(t, r) ? n[t] : F;
      }
      function rr(n, t, r) {
        var e = -1;
        return (
          (t = l(t.length ? t : [Nu], S(je()))),
          (n = Yt(n, function (n) {
            return {
              a: l(t, function (t) {
                return t(n);
              }),
              b: ++e,
              c: n,
            };
          })),
          A(n, function (n, t) {
            var e;
            n: {
              e = -1;
              for (var u = n.a, i = t.a, o = u.length, f = r.length; ++e < o; ) {
                var c = Ur(u[e], i[e]);
                if (c) {
                  e = e >= f ? c : c * ("desc" == r[e] ? -1 : 1);
                  break n;
                }
              }
              e = n.b - t.b;
            }
            return e;
          })
        );
      }
      function er(n, t) {
        return ur(n, t, function (t, r) {
          return Bu(n, r);
        });
      }
      function ur(n, t, r) {
        for (var e = -1, u = t.length, i = {}; ++e < u; ) {
          var o = t[e],
            f = It(n, o);
          r(f, o) && pr(i, Rr(o, n), f);
        }
        return i;
      }
      function ir(n) {
        return function (t) {
          return It(t, n);
        };
      }
      function or(n, t, r, e) {
        var u = e ? y : d,
          i = -1,
          o = t.length,
          f = n;
        for (n === t && (t = Mr(t)), r && (f = l(n, S(r))); ++i < o; )
          for (var c = 0, a = t[i], a = r ? r(a) : a; -1 < (c = u(f, a, c, e)); )
            f !== n && wi.call(f, c, 1), wi.call(n, c, 1);
        return n;
      }
      function fr(n, t) {
        for (var r = n ? t.length : 0, e = r - 1; r--; ) {
          var u = t[r];
          if (r == e || u !== i) {
            var i = u;
            Re(u) ? wi.call(n, u, 1) : mr(n, u);
          }
        }
      }
      function cr(n, t) {
        return n + zi(Fi() * (t - n + 1));
      }
      function ar(n, t) {
        var r = "";
        if (!n || 1 > t || 9007199254740991 < t) return r;
        do t % 2 && (r += n), (t = zi(t / 2)) && (n += n);
        while (t);
        return r;
      }
      function lr(n, t) {
        return wo(Ce(n, t, Nu), n + "");
      }
      function sr(n) {
        return tt(Du(n));
      }
      function hr(n, t) {
        var r = Du(n);
        return Te(r, gt(t, 0, r.length));
      }
      function pr(n, t, r, e) {
        if (!bu(n)) return n;
        t = Rr(t, n);
        for (var u = -1, i = t.length, o = i - 1, f = n; null != f && ++u < i; ) {
          var c = $e(t[u]),
            a = r;
          if (u != o) {
            var l = f[c],
              a = e ? e(l, c, f) : F;
            a === F && (a = bu(l) ? l : Re(t[u + 1]) ? [] : {});
          }
          at(f, c, a), (f = f[c]);
        }
        return n;
      }
      function _r(n) {
        return Te(Du(n));
      }
      function vr(n, t, r) {
        var e = -1,
          u = n.length;
        for (
          0 > t && (t = -t > u ? 0 : u + t),
            r = r > u ? u : r,
            0 > r && (r += u),
            u = t > r ? 0 : (r - t) >>> 0,
            t >>>= 0,
            r = Hu(u);
          ++e < u;

        )
          r[e] = n[e + t];
        return r;
      }
      function gr(n, t) {
        var r;
        return (
          oo(n, function (n, e, u) {
            return (r = t(n, e, u)), !r;
          }),
          !!r
        );
      }
      function dr(n, t, r) {
        var e = 0,
          u = null == n ? e : n.length;
        if (typeof t == "number" && t === t && 2147483647 >= u) {
          for (; e < u; ) {
            var i = (e + u) >>> 1,
              o = n[i];
            null !== o && !Au(o) && (r ? o <= t : o < t) ? (e = i + 1) : (u = i);
          }
          return u;
        }
        return yr(n, t, Nu, r);
      }
      function yr(n, t, r, e) {
        t = r(t);
        for (
          var u = 0,
            i = null == n ? 0 : n.length,
            o = t !== t,
            f = null === t,
            c = Au(t),
            a = t === F;
          u < i;

        ) {
          var l = zi((u + i) / 2),
            s = r(n[l]),
            h = s !== F,
            p = null === s,
            _ = s === s,
            v = Au(s);
          (
            o
              ? e || _
              : a
              ? _ && (e || h)
              : f
              ? _ && h && (e || !p)
              : c
              ? _ && h && !p && (e || !v)
              : p || v
              ? 0
              : e
              ? s <= t
              : s < t
          )
            ? (u = l + 1)
            : (i = l);
        }
        return Mi(i, 4294967294);
      }
      function br(n, t) {
        for (var r = -1, e = n.length, u = 0, i = []; ++r < e; ) {
          var o = n[r],
            f = t ? t(o) : o;
          if (!r || !hu(f, c)) {
            var c = f;
            i[u++] = 0 === o ? 0 : o;
          }
        }
        return i;
      }
      function xr(n) {
        return typeof n == "number" ? n : Au(n) ? P : +n;
      }
      function jr(n) {
        if (typeof n == "string") return n;
        if (af(n)) return l(n, jr) + "";
        if (Au(n)) return uo ? uo.call(n) : "";
        var t = n + "";
        return "0" == t && 1 / n == -N ? "-0" : t;
      }
      function wr(n, t, r) {
        var e = -1,
          u = c,
          i = n.length,
          o = true,
          f = [],
          l = f;
        if (r) (o = false), (u = a);
        else if (200 <= i) {
          if ((u = t ? null : po(n))) return D(u);
          (o = false), (u = R), (l = new qn());
        } else l = t ? [] : f;
        n: for (; ++e < i; ) {
          var s = n[e],
            h = t ? t(s) : s,
            s = r || 0 !== s ? s : 0;
          if (o && h === h) {
            for (var p = l.length; p--; ) if (l[p] === h) continue n;
            t && l.push(h), f.push(s);
          } else u(l, h, r) || (l !== f && l.push(h), f.push(s));
        }
        return f;
      }
      function mr(n, t) {
        return (
          (t = Rr(t, n)),
          (n = 2 > t.length ? n : It(n, vr(t, 0, -1))),
          null == n || delete n[$e(Ge(t))]
        );
      }
      function Ar(n, t, r, e) {
        for (var u = n.length, i = e ? u : -1; (e ? i-- : ++i < u) && t(n[i], i, n); );
        return r ? vr(n, e ? 0 : i, e ? i + 1 : u) : vr(n, e ? i + 1 : 0, e ? u : i);
      }
      function kr(n, t) {
        var r = n;
        return (
          r instanceof Mn && (r = r.value()),
          h(
            t,
            function (n, t) {
              return t.func.apply(t.thisArg, s([n], t.args));
            },
            r
          )
        );
      }
      function Er(n, t, r) {
        var e = n.length;
        if (2 > e) return e ? wr(n[0]) : [];
        for (var u = -1, i = Hu(e); ++u < e; )
          for (var o = n[u], f = -1; ++f < e; ) f != u && (i[u] = jt(i[u] || o, n[f], t, r));
        return wr(kt(i, 1), t, r);
      }
      function Or(n, t, r) {
        for (var e = -1, u = n.length, i = t.length, o = {}; ++e < u; )
          r(o, n[e], e < i ? t[e] : F);
        return o;
      }
      function Sr(n) {
        return _u(n) ? n : [];
      }
      function Ir(n) {
        return typeof n == "function" ? n : Nu;
      }
      function Rr(n, t) {
        return af(n) ? n : We(n, t) ? [n] : mo(zu(n));
      }
      function zr(n, t, r) {
        var e = n.length;
        return (r = r === F ? e : r), !t && r >= e ? n : vr(n, t, r);
      }
      function Wr(n, t) {
        if (t) return n.slice();
        var r = n.length,
          r = yi ? yi(r) : new n.constructor(r);
        return n.copy(r), r;
      }
      function Br(n) {
        var t = new n.constructor(n.byteLength);
        return new di(t).set(new di(n)), t;
      }
      function Lr(n, t) {
        return new n.constructor(t ? Br(n.buffer) : n.buffer, n.byteOffset, n.length);
      }
      function Ur(n, t) {
        if (n !== t) {
          var r = n !== F,
            e = null === n,
            u = n === n,
            i = Au(n),
            o = t !== F,
            f = null === t,
            c = t === t,
            a = Au(t);
          if (
            (!f && !a && !i && n > t) ||
            (i && o && c && !f && !a) ||
            (e && o && c) ||
            (!r && c) ||
            !u
          )
            return 1;
          if (
            (!e && !i && !a && n < t) ||
            (a && r && u && !e && !i) ||
            (f && r && u) ||
            (!o && u) ||
            !c
          )
            return -1;
        }
        return 0;
      }
      function Cr(n, t, r, e) {
        var u = -1,
          i = n.length,
          o = r.length,
          f = -1,
          c = t.length,
          a = Di(i - o, 0),
          l = Hu(c + a);
        for (e = !e; ++f < c; ) l[f] = t[f];
        for (; ++u < o; ) (e || u < i) && (l[r[u]] = n[u]);
        for (; a--; ) l[f++] = n[u++];
        return l;
      }
      function Dr(n, t, r, e) {
        var u = -1,
          i = n.length,
          o = -1,
          f = r.length,
          c = -1,
          a = t.length,
          l = Di(i - f, 0),
          s = Hu(l + a);
        for (e = !e; ++u < l; ) s[u] = n[u];
        for (l = u; ++c < a; ) s[l + c] = t[c];
        for (; ++o < f; ) (e || u < i) && (s[l + r[o]] = n[u++]);
        return s;
      }
      function Mr(n, t) {
        var r = -1,
          e = n.length;
        for (t || (t = Hu(e)); ++r < e; ) t[r] = n[r];
        return t;
      }
      function Tr(n, t, r, e) {
        var u = !r;
        r || (r = {});
        for (var i = -1, o = t.length; ++i < o; ) {
          var f = t[i],
            c = e ? e(r[f], n[f], f, r, n) : F;
          c === F && (c = n[f]), u ? _t(r, f, c) : at(r, f, c);
        }
        return r;
      }
      function $r(n, t) {
        return Tr(n, vo(n), t);
      }
      function Fr(n, t) {
        return Tr(n, go(n), t);
      }
      function Nr(n, t) {
        return function (r, u) {
          var i = af(r) ? e : st,
            o = t ? t() : {};
          return i(r, n, je(u, 2), o);
        };
      }
      function Pr(n) {
        return lr(function (t, r) {
          var e = -1,
            u = r.length,
            i = 1 < u ? r[u - 1] : F,
            o = 2 < u ? r[2] : F,
            i = 3 < n.length && typeof i == "function" ? (u--, i) : F;
          for (o && ze(r[0], r[1], o) && ((i = 3 > u ? F : i), (u = 1)), t = ni(t); ++e < u; )
            (o = r[e]) && n(t, o, e, i);
          return t;
        });
      }
      function Zr(n, t) {
        return function (r, e) {
          if (null == r) return r;
          if (!pu(r)) return n(r, e);
          for (
            var u = r.length, i = t ? u : -1, o = ni(r);
            (t ? i-- : ++i < u) && false !== e(o[i], i, o);

          );
          return r;
        };
      }
      function qr(n) {
        return function (t, r, e) {
          var u = -1,
            i = ni(t);
          e = e(t);
          for (var o = e.length; o--; ) {
            var f = e[n ? o : ++u];
            if (false === r(i[f], f, i)) break;
          }
          return t;
        };
      }
      function Vr(n, t, r) {
        function e() {
          return (this && this !== Zn && this instanceof e ? i : n).apply(u ? r : this, arguments);
        }
        var u = 1 & t,
          i = Hr(n);
        return e;
      }
      function Kr(n) {
        return function (t) {
          t = zu(t);
          var r = Bn.test(t) ? $(t) : F,
            e = r ? r[0] : t.charAt(0);
          return (t = r ? zr(r, 1).join("") : t.slice(1)), e[n]() + t;
        };
      }
      function Gr(n) {
        return function (t) {
          return h($u(Tu(t).replace(In, "")), n, "");
        };
      }
      function Hr(n) {
        return function () {
          var t = arguments;
          switch (t.length) {
            case 0:
              return new n();
            case 1:
              return new n(t[0]);
            case 2:
              return new n(t[0], t[1]);
            case 3:
              return new n(t[0], t[1], t[2]);
            case 4:
              return new n(t[0], t[1], t[2], t[3]);
            case 5:
              return new n(t[0], t[1], t[2], t[3], t[4]);
            case 6:
              return new n(t[0], t[1], t[2], t[3], t[4], t[5]);
            case 7:
              return new n(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
          }
          var r = io(n.prototype),
            t = n.apply(r, t);
          return bu(t) ? t : r;
        };
      }
      function Jr(n, t, e) {
        function u() {
          for (var o = arguments.length, f = Hu(o), c = o, a = xe(u); c--; ) f[c] = arguments[c];
          return (
            (c = 3 > o && f[0] !== a && f[o - 1] !== a ? [] : C(f, a)),
            (o -= c.length),
            o < e
              ? fe(n, t, Xr, u.placeholder, F, f, c, F, F, e - o)
              : r(this && this !== Zn && this instanceof u ? i : n, this, f)
          );
        }
        var i = Hr(n);
        return u;
      }
      function Yr(n) {
        return function (t, r, e) {
          var u = ni(t);
          if (!pu(t)) {
            var i = je(r, 3);
            (t = Lu(t)),
              (r = function (n) {
                return i(u[n], n, u);
              });
          }
          return (r = n(t, r, e)), -1 < r ? u[i ? t[r] : r] : F;
        };
      }
      function Qr(n) {
        return ge(function (t) {
          var r = t.length,
            e = r,
            u = zn.prototype.thru;
          for (n && t.reverse(); e--; ) {
            var i = t[e];
            if (typeof i != "function") throw new ei("Expected a function");
            if (u && !o && "wrapper" == be(i)) var o = new zn([], true);
          }
          for (e = o ? e : r; ++e < r; )
            var i = t[e],
              u = be(i),
              f = "wrapper" == u ? _o(i) : F,
              o =
                f && Be(f[0]) && 424 == f[1] && !f[4].length && 1 == f[9]
                  ? o[be(f[0])].apply(o, f[3])
                  : 1 == i.length && Be(i)
                  ? o[u]()
                  : o.thru(i);
          return function () {
            var n = arguments,
              e = n[0];
            if (o && 1 == n.length && af(e)) return o.plant(e).value();
            for (var u = 0, n = r ? t[u].apply(this, n) : e; ++u < r; ) n = t[u].call(this, n);
            return n;
          };
        });
      }
      function Xr(n, t, r, e, u, i, o, f, c, a) {
        function l() {
          for (var d = arguments.length, y = Hu(d), b = d; b--; ) y[b] = arguments[b];
          if (_) {
            var x,
              j = xe(l),
              b = y.length;
            for (x = 0; b--; ) y[b] === j && ++x;
          }
          if ((e && (y = Cr(y, e, u, _)), i && (y = Dr(y, i, o, _)), (d -= x), _ && d < a))
            return (j = C(y, j)), fe(n, t, Xr, l.placeholder, r, y, j, f, c, a - d);
          if (((j = h ? r : this), (b = p ? j[n] : n), (d = y.length), f)) {
            x = y.length;
            for (var w = Mi(f.length, x), m = Mr(y); w--; ) {
              var A = f[w];
              y[w] = Re(A, x) ? m[A] : F;
            }
          } else v && 1 < d && y.reverse();
          return (
            s && c < d && (y.length = c),
            this && this !== Zn && this instanceof l && (b = g || Hr(b)),
            b.apply(j, y)
          );
        }
        var s = 128 & t,
          h = 1 & t,
          p = 2 & t,
          _ = 24 & t,
          v = 512 & t,
          g = p ? F : Hr(n);
        return l;
      }
      function ne(n, t) {
        return function (r, e) {
          return Ct(r, n, t(e));
        };
      }
      function te(n, t) {
        return function (r, e) {
          var u;
          if (r === F && e === F) return t;
          if ((r !== F && (u = r), e !== F)) {
            if (u === F) return e;
            typeof r == "string" || typeof e == "string"
              ? ((r = jr(r)), (e = jr(e)))
              : ((r = xr(r)), (e = xr(e))),
              (u = n(r, e));
          }
          return u;
        };
      }
      function re(n) {
        return ge(function (t) {
          return (
            (t = l(t, S(je()))),
            lr(function (e) {
              var u = this;
              return n(t, function (n) {
                return r(n, u, e);
              });
            })
          );
        });
      }
      function ee(n, t) {
        t = t === F ? " " : jr(t);
        var r = t.length;
        return 2 > r
          ? r
            ? ar(t, n)
            : t
          : ((r = ar(t, Ri(n / T(t)))), Bn.test(t) ? zr($(r), 0, n).join("") : r.slice(0, n));
      }
      function ue(n, t, e, u) {
        function i() {
          for (
            var t = -1,
              c = arguments.length,
              a = -1,
              l = u.length,
              s = Hu(l + c),
              h = this && this !== Zn && this instanceof i ? f : n;
            ++a < l;

          )
            s[a] = u[a];
          for (; c--; ) s[a++] = arguments[++t];
          return r(h, o ? e : this, s);
        }
        var o = 1 & t,
          f = Hr(n);
        return i;
      }
      function ie(n) {
        return function (t, r, e) {
          e && typeof e != "number" && ze(t, r, e) && (r = e = F),
            (t = Eu(t)),
            r === F ? ((r = t), (t = 0)) : (r = Eu(r)),
            (e = e === F ? (t < r ? 1 : -1) : Eu(e));
          var u = -1;
          r = Di(Ri((r - t) / (e || 1)), 0);
          for (var i = Hu(r); r--; ) (i[n ? r : ++u] = t), (t += e);
          return i;
        };
      }
      function oe(n) {
        return function (t, r) {
          return (
            (typeof t == "string" && typeof r == "string") || ((t = Iu(t)), (r = Iu(r))), n(t, r)
          );
        };
      }
      function fe(n, t, r, e, u, i, o, f, c, a) {
        var l = 8 & t,
          s = l ? o : F;
        o = l ? F : o;
        var h = l ? i : F;
        return (
          (i = l ? F : i),
          (t = (t | (l ? 32 : 64)) & ~(l ? 64 : 32)),
          4 & t || (t &= -4),
          (u = [n, t, u, h, s, i, o, f, c, a]),
          (r = r.apply(F, u)),
          Be(n) && xo(r, u),
          (r.placeholder = e),
          De(r, n, t)
        );
      }
      function ce(n) {
        var t = Xu[n];
        return function (n, r) {
          if (((n = Iu(n)), (r = null == r ? 0 : Mi(Ou(r), 292)))) {
            var e = (zu(n) + "e").split("e"),
              e = t(e[0] + "e" + (+e[1] + r)),
              e = (zu(e) + "e").split("e");
            return +(e[0] + "e" + (+e[1] - r));
          }
          return t(n);
        };
      }
      function ae(n) {
        return function (t) {
          var r = yo(t);
          return "[object Map]" == r ? L(t) : "[object Set]" == r ? M(t) : O(t, n(t));
        };
      }
      function le(n, t, r, e, u, i, o, f) {
        var c = 2 & t;
        if (!c && typeof n != "function") throw new ei("Expected a function");
        var a = e ? e.length : 0;
        if (
          (a || ((t &= -97), (e = u = F)),
          (o = o === F ? o : Di(Ou(o), 0)),
          (f = f === F ? f : Ou(f)),
          (a -= u ? u.length : 0),
          64 & t)
        ) {
          var l = e,
            s = u;
          e = u = F;
        }
        var h = c ? F : _o(n);
        return (
          (i = [n, t, r, e, u, l, s, i, o, f]),
          h &&
            ((r = i[1]),
            (n = h[1]),
            (t = r | n),
            (e =
              (128 == n && 8 == r) ||
              (128 == n && 256 == r && i[7].length <= h[8]) ||
              (384 == n && h[7].length <= h[8] && 8 == r)),
            131 > t || e) &&
            (1 & n && ((i[2] = h[2]), (t |= 1 & r ? 0 : 4)),
            (r = h[3]) &&
              ((e = i[3]),
              (i[3] = e ? Cr(e, r, h[4]) : r),
              (i[4] = e ? C(i[3], "__lodash_placeholder__") : h[4])),
            (r = h[5]) &&
              ((e = i[5]),
              (i[5] = e ? Dr(e, r, h[6]) : r),
              (i[6] = e ? C(i[5], "__lodash_placeholder__") : h[6])),
            (r = h[7]) && (i[7] = r),
            128 & n && (i[8] = null == i[8] ? h[8] : Mi(i[8], h[8])),
            null == i[9] && (i[9] = h[9]),
            (i[0] = h[0]),
            (i[1] = t)),
          (n = i[0]),
          (t = i[1]),
          (r = i[2]),
          (e = i[3]),
          (u = i[4]),
          (f = i[9] = i[9] === F ? (c ? 0 : n.length) : Di(i[9] - a, 0)),
          !f && 24 & t && (t &= -25),
          De(
            (h ? lo : xo)(
              t && 1 != t
                ? 8 == t || 16 == t
                  ? Jr(n, t, f)
                  : (32 != t && 33 != t) || u.length
                  ? Xr.apply(F, i)
                  : ue(n, t, r, e)
                : Vr(n, t, r),
              i
            ),
            n,
            t
          )
        );
      }
      function se(n, t, r, e) {
        return n === F || (hu(n, ii[r]) && !ci.call(e, r)) ? t : n;
      }
      function he(n, t, r, e, u, i) {
        return bu(n) && bu(t) && (i.set(t, n), nr(n, t, F, he, i), i.delete(t)), n;
      }
      function pe(n) {
        return wu(n) ? F : n;
      }
      function _e(n, t, r, e, u, i) {
        var o = 1 & r,
          f = n.length,
          c = t.length;
        if (f != c && !(o && c > f)) return false;
        if ((c = i.get(n)) && i.get(t)) return c == t;
        var c = -1,
          a = true,
          l = 2 & r ? new qn() : F;
        for (i.set(n, t), i.set(t, n); ++c < f; ) {
          var s = n[c],
            h = t[c];
          if (e) var p = o ? e(h, s, c, t, n, i) : e(s, h, c, n, t, i);
          if (p !== F) {
            if (p) continue;
            a = false;
            break;
          }
          if (l) {
            if (
              !_(t, function (n, t) {
                if (!R(l, t) && (s === n || u(s, n, r, e, i))) return l.push(t);
              })
            ) {
              a = false;
              break;
            }
          } else if (s !== h && !u(s, h, r, e, i)) {
            a = false;
            break;
          }
        }
        return i.delete(n), i.delete(t), a;
      }
      function ve(n, t, r, e, u, i, o) {
        switch (r) {
          case "[object DataView]":
            if (n.byteLength != t.byteLength || n.byteOffset != t.byteOffset) break;
            (n = n.buffer), (t = t.buffer);
          case "[object ArrayBuffer]":
            if (n.byteLength != t.byteLength || !i(new di(n), new di(t))) break;
            return true;
          case "[object Boolean]":
          case "[object Date]":
          case "[object Number]":
            return hu(+n, +t);
          case "[object Error]":
            return n.name == t.name && n.message == t.message;
          case "[object RegExp]":
          case "[object String]":
            return n == t + "";
          case "[object Map]":
            var f = L;
          case "[object Set]":
            if ((f || (f = D), n.size != t.size && !(1 & e))) break;
            return (r = o.get(n))
              ? r == t
              : ((e |= 2), o.set(n, t), (t = _e(f(n), f(t), e, u, i, o)), o.delete(n), t);
          case "[object Symbol]":
            if (eo) return eo.call(n) == eo.call(t);
        }
        return false;
      }
      function ge(n) {
        return wo(Ce(n, F, Ve), n + "");
      }
      function de(n) {
        return Rt(n, Lu, vo);
      }
      function ye(n) {
        return Rt(n, Uu, go);
      }
      function be(n) {
        for (var t = n.name + "", r = Ji[t], e = ci.call(Ji, t) ? r.length : 0; e--; ) {
          var u = r[e],
            i = u.func;
          if (null == i || i == n) return u.name;
        }
        return t;
      }
      function xe(n) {
        return (ci.call(On, "placeholder") ? On : n).placeholder;
      }
      function je() {
        var n = On.iteratee || Pu,
          n = n === Pu ? Gt : n;
        return arguments.length ? n(arguments[0], arguments[1]) : n;
      }
      function we(n, t) {
        var r = n.__data__,
          e = typeof t;
        return (
          "string" == e || "number" == e || "symbol" == e || "boolean" == e
            ? "__proto__" !== t
            : null === t
        )
          ? r[typeof t == "string" ? "string" : "hash"]
          : r.map;
      }
      function me(n) {
        for (var t = Lu(n), r = t.length; r--; ) {
          var e = t[r],
            u = n[e];
          t[r] = [e, u, u === u && !bu(u)];
        }
        return t;
      }
      function Ae(n, t) {
        var r = null == n ? F : n[t];
        return Zt(r) ? r : F;
      }
      function ke(n, t, r) {
        t = Rr(t, n);
        for (var e = -1, u = t.length, i = false; ++e < u; ) {
          var o = $e(t[e]);
          if (!(i = null != n && r(n, o))) break;
          n = n[o];
        }
        return i || ++e != u
          ? i
          : ((u = null == n ? 0 : n.length), !!u && yu(u) && Re(o, u) && (af(n) || cf(n)));
      }
      function Ee(n) {
        var t = n.length,
          r = n.constructor(t);
        return (
          t &&
            "string" == typeof n[0] &&
            ci.call(n, "index") &&
            ((r.index = n.index), (r.input = n.input)),
          r
        );
      }
      function Oe(n) {
        return typeof n.constructor != "function" || Le(n) ? {} : io(bi(n));
      }
      function Se(r, e, u, i) {
        var o = r.constructor;
        switch (e) {
          case "[object ArrayBuffer]":
            return Br(r);
          case "[object Boolean]":
          case "[object Date]":
            return new o(+r);
          case "[object DataView]":
            return (
              (e = i ? Br(r.buffer) : r.buffer), new r.constructor(e, r.byteOffset, r.byteLength)
            );
          case "[object Float32Array]":
          case "[object Float64Array]":
          case "[object Int8Array]":
          case "[object Int16Array]":
          case "[object Int32Array]":
          case "[object Uint8Array]":
          case "[object Uint8ClampedArray]":
          case "[object Uint16Array]":
          case "[object Uint32Array]":
            return Lr(r, i);
          case "[object Map]":
            return (e = i ? u(L(r), 1) : L(r)), h(e, n, new r.constructor());
          case "[object Number]":
          case "[object String]":
            return new o(r);
          case "[object RegExp]":
            return (e = new r.constructor(r.source, dn.exec(r))), (e.lastIndex = r.lastIndex), e;
          case "[object Set]":
            return (e = i ? u(D(r), 1) : D(r)), h(e, t, new r.constructor());
          case "[object Symbol]":
            return eo ? ni(eo.call(r)) : {};
        }
      }
      function Ie(n) {
        return af(n) || cf(n) || !!(mi && n && n[mi]);
      }
      function Re(n, t) {
        return (
          (t = null == t ? 9007199254740991 : t),
          !!t && (typeof n == "number" || wn.test(n)) && -1 < n && 0 == n % 1 && n < t
        );
      }
      function ze(n, t, r) {
        if (!bu(r)) return false;
        var e = typeof t;
        return (
          !!("number" == e ? pu(r) && Re(t, r.length) : "string" == e && t in r) && hu(r[t], n)
        );
      }
      function We(n, t) {
        if (af(n)) return false;
        var r = typeof n;
        return (
          !("number" != r && "symbol" != r && "boolean" != r && null != n && !Au(n)) ||
          rn.test(n) ||
          !tn.test(n) ||
          (null != t && n in ni(t))
        );
      }
      function Be(n) {
        var t = be(n),
          r = On[t];
        return (
          typeof r == "function" &&
          t in Mn.prototype &&
          (n === r || ((t = _o(r)), !!t && n === t[0]))
        );
      }
      function Le(n) {
        var t = n && n.constructor;
        return n === ((typeof t == "function" && t.prototype) || ii);
      }
      function Ue(n, t) {
        return function (r) {
          return null != r && r[n] === t && (t !== F || n in ni(r));
        };
      }
      function Ce(n, t, e) {
        return (
          (t = Di(t === F ? n.length - 1 : t, 0)),
          function () {
            for (var u = arguments, i = -1, o = Di(u.length - t, 0), f = Hu(o); ++i < o; )
              f[i] = u[t + i];
            for (i = -1, o = Hu(t + 1); ++i < t; ) o[i] = u[i];
            return (o[t] = e(f)), r(n, this, o);
          }
        );
      }
      function De(n, t, r) {
        var e = t + "";
        t = wo;
        var u,
          i = Ne;
        return (
          (u = (u = e.match(hn)) ? u[1].split(pn) : []),
          (r = i(u, r)),
          (i = r.length) &&
            ((u = i - 1),
            (r[u] = (1 < i ? "& " : "") + r[u]),
            (r = r.join(2 < i ? ", " : " ")),
            (e = e.replace(sn, "{\n/* [wrapped with " + r + "] */\n"))),
          t(n, e)
        );
      }
      function Me(n) {
        var t = 0,
          r = 0;
        return function () {
          var e = Ti(),
            u = 16 - (e - r);
          if (((r = e), 0 < u)) {
            if (800 <= ++t) return arguments[0];
          } else t = 0;
          return n.apply(F, arguments);
        };
      }
      function Te(n, t) {
        var r = -1,
          e = n.length,
          u = e - 1;
        for (t = t === F ? e : t; ++r < t; ) {
          var e = cr(r, u),
            i = n[e];
          (n[e] = n[r]), (n[r] = i);
        }
        return (n.length = t), n;
      }
      function $e(n) {
        if (typeof n == "string" || Au(n)) return n;
        var t = n + "";
        return "0" == t && 1 / n == -N ? "-0" : t;
      }
      function Fe(n) {
        if (null != n) {
          try {
            return fi.call(n);
          } catch (n) {}
          return n + "";
        }
        return "";
      }
      function Ne(n, t) {
        return (
          u(Z, function (r) {
            var e = "_." + r[0];
            t & r[1] && !c(n, e) && n.push(e);
          }),
          n.sort()
        );
      }
      function Pe(n) {
        if (n instanceof Mn) return n.clone();
        var t = new zn(n.__wrapped__, n.__chain__);
        return (
          (t.__actions__ = Mr(n.__actions__)),
          (t.__index__ = n.__index__),
          (t.__values__ = n.__values__),
          t
        );
      }
      function Ze(n, t, r) {
        var e = null == n ? 0 : n.length;
        return e
          ? ((r = null == r ? 0 : Ou(r)), 0 > r && (r = Di(e + r, 0)), g(n, je(t, 3), r))
          : -1;
      }
      function qe(n, t, r) {
        var e = null == n ? 0 : n.length;
        if (!e) return -1;
        var u = e - 1;
        return (
          r !== F && ((u = Ou(r)), (u = 0 > r ? Di(e + u, 0) : Mi(u, e - 1))),
          g(n, je(t, 3), u, true)
        );
      }
      function Ve(n) {
        return (null == n ? 0 : n.length) ? kt(n, 1) : [];
      }
      function Ke(n) {
        return n && n.length ? n[0] : F;
      }
      function Ge(n) {
        var t = null == n ? 0 : n.length;
        return t ? n[t - 1] : F;
      }
      function He(n, t) {
        return n && n.length && t && t.length ? or(n, t) : n;
      }
      function Je(n) {
        return null == n ? n : Ni.call(n);
      }
      function Ye(n) {
        if (!n || !n.length) return [];
        var t = 0;
        return (
          (n = f(n, function (n) {
            if (_u(n)) return (t = Di(n.length, t)), true;
          })),
          E(t, function (t) {
            return l(n, j(t));
          })
        );
      }
      function Qe(n, t) {
        if (!n || !n.length) return [];
        var e = Ye(n);
        return null == t
          ? e
          : l(e, function (n) {
              return r(t, F, n);
            });
      }
      function Xe(n) {
        return (n = On(n)), (n.__chain__ = true), n;
      }
      function nu(n, t) {
        return t(n);
      }
      function tu() {
        return this;
      }
      function ru(n, t) {
        return (af(n) ? u : oo)(n, je(t, 3));
      }
      function eu(n, t) {
        return (af(n) ? i : fo)(n, je(t, 3));
      }
      function uu(n, t) {
        return (af(n) ? l : Yt)(n, je(t, 3));
      }
      function iu(n, t, r) {
        return (t = r ? F : t), (t = n && null == t ? n.length : t), le(n, 128, F, F, F, F, t);
      }
      function ou(n, t) {
        var r;
        if (typeof t != "function") throw new ei("Expected a function");
        return (
          (n = Ou(n)),
          function () {
            return 0 < --n && (r = t.apply(this, arguments)), 1 >= n && (t = F), r;
          }
        );
      }
      function fu(n, t, r) {
        return (
          (t = r ? F : t), (n = le(n, 8, F, F, F, F, F, t)), (n.placeholder = fu.placeholder), n
        );
      }
      function cu(n, t, r) {
        return (
          (t = r ? F : t), (n = le(n, 16, F, F, F, F, F, t)), (n.placeholder = cu.placeholder), n
        );
      }
      function au(n, t, r) {
        function e(t) {
          var r = c,
            e = a;
          return (c = a = F), (_ = t), (s = n.apply(e, r));
        }
        function u(n) {
          var r = n - p;
          return (n -= _), p === F || r >= t || 0 > r || (g && n >= l);
        }
        function i() {
          var n = Jo();
          if (u(n)) return o(n);
          var r,
            e = jo;
          (r = n - _), (n = t - (n - p)), (r = g ? Mi(n, l - r) : n), (h = e(i, r));
        }
        function o(n) {
          return (h = F), d && c ? e(n) : ((c = a = F), s);
        }
        function f() {
          var n = Jo(),
            r = u(n);
          if (((c = arguments), (a = this), (p = n), r)) {
            if (h === F) return (_ = n = p), (h = jo(i, t)), v ? e(n) : s;
            if (g) return (h = jo(i, t)), e(p);
          }
          return h === F && (h = jo(i, t)), s;
        }
        var c,
          a,
          l,
          s,
          h,
          p,
          _ = 0,
          v = false,
          g = false,
          d = true;
        if (typeof n != "function") throw new ei("Expected a function");
        return (
          (t = Iu(t) || 0),
          bu(r) &&
            ((v = !!r.leading),
            (l = (g = "maxWait" in r) ? Di(Iu(r.maxWait) || 0, t) : l),
            (d = "trailing" in r ? !!r.trailing : d)),
          (f.cancel = function () {
            h !== F && ho(h), (_ = 0), (c = p = a = h = F);
          }),
          (f.flush = function () {
            return h === F ? s : o(Jo());
          }),
          f
        );
      }
      function lu(n, t) {
        function r() {
          var e = arguments,
            u = t ? t.apply(this, e) : e[0],
            i = r.cache;
          return i.has(u) ? i.get(u) : ((e = n.apply(this, e)), (r.cache = i.set(u, e) || i), e);
        }
        if (typeof n != "function" || (null != t && typeof t != "function"))
          throw new ei("Expected a function");
        return (r.cache = new (lu.Cache || Pn)()), r;
      }
      function su(n) {
        if (typeof n != "function") throw new ei("Expected a function");
        return function () {
          var t = arguments;
          switch (t.length) {
            case 0:
              return !n.call(this);
            case 1:
              return !n.call(this, t[0]);
            case 2:
              return !n.call(this, t[0], t[1]);
            case 3:
              return !n.call(this, t[0], t[1], t[2]);
          }
          return !n.apply(this, t);
        };
      }
      function hu(n, t) {
        return n === t || (n !== n && t !== t);
      }
      function pu(n) {
        return null != n && yu(n.length) && !gu(n);
      }
      function _u(n) {
        return xu(n) && pu(n);
      }
      function vu(n) {
        if (!xu(n)) return false;
        var t = zt(n);
        return (
          "[object Error]" == t ||
          "[object DOMException]" == t ||
          (typeof n.message == "string" && typeof n.name == "string" && !wu(n))
        );
      }
      function gu(n) {
        return (
          !!bu(n) &&
          ((n = zt(n)),
          "[object Function]" == n ||
            "[object GeneratorFunction]" == n ||
            "[object AsyncFunction]" == n ||
            "[object Proxy]" == n)
        );
      }
      function du(n) {
        return typeof n == "number" && n == Ou(n);
      }
      function yu(n) {
        return typeof n == "number" && -1 < n && 0 == n % 1 && 9007199254740991 >= n;
      }
      function bu(n) {
        var t = typeof n;
        return null != n && ("object" == t || "function" == t);
      }
      function xu(n) {
        return null != n && typeof n == "object";
      }
      function ju(n) {
        return typeof n == "number" || (xu(n) && "[object Number]" == zt(n));
      }
      function wu(n) {
        return (
          !(!xu(n) || "[object Object]" != zt(n)) &&
          ((n = bi(n)),
          null === n ||
            ((n = ci.call(n, "constructor") && n.constructor),
            typeof n == "function" && n instanceof n && fi.call(n) == hi))
        );
      }
      function mu(n) {
        return typeof n == "string" || (!af(n) && xu(n) && "[object String]" == zt(n));
      }
      function Au(n) {
        return typeof n == "symbol" || (xu(n) && "[object Symbol]" == zt(n));
      }
      function ku(n) {
        if (!n) return [];
        if (pu(n)) return mu(n) ? $(n) : Mr(n);
        if (Ai && n[Ai]) {
          n = n[Ai]();
          for (var t, r = []; !(t = n.next()).done; ) r.push(t.value);
          return r;
        }
        return (t = yo(n)), ("[object Map]" == t ? L : "[object Set]" == t ? D : Du)(n);
      }
      function Eu(n) {
        return n
          ? ((n = Iu(n)),
            n === N || n === -N ? 1.7976931348623157e308 * (0 > n ? -1 : 1) : n === n ? n : 0)
          : 0 === n
          ? n
          : 0;
      }
      function Ou(n) {
        n = Eu(n);
        var t = n % 1;
        return n === n ? (t ? n - t : n) : 0;
      }
      function Su(n) {
        return n ? gt(Ou(n), 0, 4294967295) : 0;
      }
      function Iu(n) {
        if (typeof n == "number") return n;
        if (Au(n)) return P;
        if (
          (bu(n) &&
            ((n = typeof n.valueOf == "function" ? n.valueOf() : n), (n = bu(n) ? n + "" : n)),
          typeof n != "string")
        )
          return 0 === n ? n : +n;
        n = n.replace(cn, "");
        var t = bn.test(n);
        return t || jn.test(n) ? Fn(n.slice(2), t ? 2 : 8) : yn.test(n) ? P : +n;
      }
      function Ru(n) {
        return Tr(n, Uu(n));
      }
      function zu(n) {
        return null == n ? "" : jr(n);
      }
      function Wu(n, t, r) {
        return (n = null == n ? F : It(n, t)), n === F ? r : n;
      }
      function Bu(n, t) {
        return null != n && ke(n, t, Lt);
      }
      function Lu(n) {
        return pu(n) ? Gn(n) : Ht(n);
      }
      function Uu(n) {
        if (pu(n)) n = Gn(n, true);
        else if (bu(n)) {
          var t,
            r = Le(n),
            e = [];
          for (t in n) ("constructor" != t || (!r && ci.call(n, t))) && e.push(t);
          n = e;
        } else {
          if (((t = []), null != n)) for (r in ni(n)) t.push(r);
          n = t;
        }
        return n;
      }
      function Cu(n, t) {
        if (null == n) return {};
        var r = l(ye(n), function (n) {
          return [n];
        });
        return (
          (t = je(t)),
          ur(n, r, function (n, r) {
            return t(n, r[0]);
          })
        );
      }
      function Du(n) {
        return null == n ? [] : I(n, Lu(n));
      }
      function Mu(n) {
        return Nf(zu(n).toLowerCase());
      }
      function Tu(n) {
        return (n = zu(n)) && n.replace(mn, rt).replace(Rn, "");
      }
      function $u(n, t, r) {
        return (
          (n = zu(n)),
          (t = r ? F : t),
          t === F ? (Ln.test(n) ? n.match(Wn) || [] : n.match(_n) || []) : n.match(t) || []
        );
      }
      function Fu(n) {
        return function () {
          return n;
        };
      }
      function Nu(n) {
        return n;
      }
      function Pu(n) {
        return Gt(typeof n == "function" ? n : dt(n, 1));
      }
      function Zu(n, t, r) {
        var e = Lu(t),
          i = St(t, e);
        null != r ||
          (bu(t) && (i.length || !e.length)) ||
          ((r = t), (t = n), (n = this), (i = St(t, Lu(t))));
        var o = !(bu(r) && "chain" in r && !r.chain),
          f = gu(n);
        return (
          u(i, function (r) {
            var e = t[r];
            (n[r] = e),
              f &&
                (n.prototype[r] = function () {
                  var t = this.__chain__;
                  if (o || t) {
                    var r = n(this.__wrapped__);
                    return (
                      (r.__actions__ = Mr(this.__actions__)).push({
                        func: e,
                        args: arguments,
                        thisArg: n,
                      }),
                      (r.__chain__ = t),
                      r
                    );
                  }
                  return e.apply(n, s([this.value()], arguments));
                });
          }),
          n
        );
      }
      function qu() {}
      function Vu(n) {
        return We(n) ? j($e(n)) : ir(n);
      }
      function Ku() {
        return [];
      }
      function Gu() {
        return false;
      }
      En = null == En ? Zn : it.defaults(Zn.Object(), En, it.pick(Zn, Un));
      var Hu = En.Array,
        Ju = En.Date,
        Yu = En.Error,
        Qu = En.Function,
        Xu = En.Math,
        ni = En.Object,
        ti = En.RegExp,
        ri = En.String,
        ei = En.TypeError,
        ui = Hu.prototype,
        ii = ni.prototype,
        oi = En["__core-js_shared__"],
        fi = Qu.prototype.toString,
        ci = ii.hasOwnProperty,
        ai = 0,
        li = (function () {
          var n = /[^.]+$/.exec((oi && oi.keys && oi.keys.IE_PROTO) || "");
          return n ? "Symbol(src)_1." + n : "";
        })(),
        si = ii.toString,
        hi = fi.call(ni),
        pi = Zn._,
        _i = ti(
          "^" +
            fi
              .call(ci)
              .replace(on, "\\$&")
              .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") +
            "$"
        ),
        vi = Kn ? En.Buffer : F,
        gi = En.Symbol,
        di = En.Uint8Array,
        yi = vi ? vi.f : F,
        bi = U(ni.getPrototypeOf, ni),
        xi = ni.create,
        ji = ii.propertyIsEnumerable,
        wi = ui.splice,
        mi = gi ? gi.isConcatSpreadable : F,
        Ai = gi ? gi.iterator : F,
        ki = gi ? gi.toStringTag : F,
        Ei = (function () {
          try {
            var n = Ae(ni, "defineProperty");
            return n({}, "", {}), n;
          } catch (n) {}
        })(),
        Oi = En.clearTimeout !== Zn.clearTimeout && En.clearTimeout,
        Si = Ju && Ju.now !== Zn.Date.now && Ju.now,
        Ii = En.setTimeout !== Zn.setTimeout && En.setTimeout,
        Ri = Xu.ceil,
        zi = Xu.floor,
        Wi = ni.getOwnPropertySymbols,
        Bi = vi ? vi.isBuffer : F,
        Li = En.isFinite,
        Ui = ui.join,
        Ci = U(ni.keys, ni),
        Di = Xu.max,
        Mi = Xu.min,
        Ti = Ju.now,
        $i = En.parseInt,
        Fi = Xu.random,
        Ni = ui.reverse,
        Pi = Ae(En, "DataView"),
        Zi = Ae(En, "Map"),
        qi = Ae(En, "Promise"),
        Vi = Ae(En, "Set"),
        Ki = Ae(En, "WeakMap"),
        Gi = Ae(ni, "create"),
        Hi = Ki && new Ki(),
        Ji = {},
        Yi = Fe(Pi),
        Qi = Fe(Zi),
        Xi = Fe(qi),
        no = Fe(Vi),
        to = Fe(Ki),
        ro = gi ? gi.prototype : F,
        eo = ro ? ro.valueOf : F,
        uo = ro ? ro.toString : F,
        io = (function () {
          function n() {}
          return function (t) {
            return bu(t)
              ? xi
                ? xi(t)
                : ((n.prototype = t), (t = new n()), (n.prototype = F), t)
              : {};
          };
        })();
      (On.templateSettings = {
        escape: Q,
        evaluate: X,
        interpolate: nn,
        variable: "",
        imports: { _: On },
      }),
        (On.prototype = Sn.prototype),
        (On.prototype.constructor = On),
        (zn.prototype = io(Sn.prototype)),
        (zn.prototype.constructor = zn),
        (Mn.prototype = io(Sn.prototype)),
        (Mn.prototype.constructor = Mn),
        (Tn.prototype.clear = function () {
          (this.__data__ = Gi ? Gi(null) : {}), (this.size = 0);
        }),
        (Tn.prototype.delete = function (n) {
          return (n = this.has(n) && delete this.__data__[n]), (this.size -= n ? 1 : 0), n;
        }),
        (Tn.prototype.get = function (n) {
          var t = this.__data__;
          return Gi
            ? ((n = t[n]), "__lodash_hash_undefined__" === n ? F : n)
            : ci.call(t, n)
            ? t[n]
            : F;
        }),
        (Tn.prototype.has = function (n) {
          var t = this.__data__;
          return Gi ? t[n] !== F : ci.call(t, n);
        }),
        (Tn.prototype.set = function (n, t) {
          var r = this.__data__;
          return (
            (this.size += this.has(n) ? 0 : 1),
            (r[n] = Gi && t === F ? "__lodash_hash_undefined__" : t),
            this
          );
        }),
        (Nn.prototype.clear = function () {
          (this.__data__ = []), (this.size = 0);
        }),
        (Nn.prototype.delete = function (n) {
          var t = this.__data__;
          return (
            (n = lt(t, n)),
            !(0 > n) && (n == t.length - 1 ? t.pop() : wi.call(t, n, 1), --this.size, true)
          );
        }),
        (Nn.prototype.get = function (n) {
          var t = this.__data__;
          return (n = lt(t, n)), 0 > n ? F : t[n][1];
        }),
        (Nn.prototype.has = function (n) {
          return -1 < lt(this.__data__, n);
        }),
        (Nn.prototype.set = function (n, t) {
          var r = this.__data__,
            e = lt(r, n);
          return 0 > e ? (++this.size, r.push([n, t])) : (r[e][1] = t), this;
        }),
        (Pn.prototype.clear = function () {
          (this.size = 0),
            (this.__data__ = { hash: new Tn(), map: new (Zi || Nn)(), string: new Tn() });
        }),
        (Pn.prototype.delete = function (n) {
          return (n = we(this, n).delete(n)), (this.size -= n ? 1 : 0), n;
        }),
        (Pn.prototype.get = function (n) {
          return we(this, n).get(n);
        }),
        (Pn.prototype.has = function (n) {
          return we(this, n).has(n);
        }),
        (Pn.prototype.set = function (n, t) {
          var r = we(this, n),
            e = r.size;
          return r.set(n, t), (this.size += r.size == e ? 0 : 1), this;
        }),
        (qn.prototype.add = qn.prototype.push =
          function (n) {
            return this.__data__.set(n, "__lodash_hash_undefined__"), this;
          }),
        (qn.prototype.has = function (n) {
          return this.__data__.has(n);
        }),
        (Vn.prototype.clear = function () {
          (this.__data__ = new Nn()), (this.size = 0);
        }),
        (Vn.prototype.delete = function (n) {
          var t = this.__data__;
          return (n = t.delete(n)), (this.size = t.size), n;
        }),
        (Vn.prototype.get = function (n) {
          return this.__data__.get(n);
        }),
        (Vn.prototype.has = function (n) {
          return this.__data__.has(n);
        }),
        (Vn.prototype.set = function (n, t) {
          var r = this.__data__;
          if (r instanceof Nn) {
            var e = r.__data__;
            if (!Zi || 199 > e.length) return e.push([n, t]), (this.size = ++r.size), this;
            r = this.__data__ = new Pn(e);
          }
          return r.set(n, t), (this.size = r.size), this;
        });
      var oo = Zr(Et),
        fo = Zr(Ot, true),
        co = qr(),
        ao = qr(true),
        lo = Hi
          ? function (n, t) {
              return Hi.set(n, t), n;
            }
          : Nu,
        so = Ei
          ? function (n, t) {
              return Ei(n, "toString", {
                configurable: true,
                enumerable: false,
                value: Fu(t),
                writable: true,
              });
            }
          : Nu,
        ho =
          Oi ||
          function (n) {
            return Zn.clearTimeout(n);
          },
        po =
          Vi && 1 / D(new Vi([, -0]))[1] == N
            ? function (n) {
                return new Vi(n);
              }
            : qu,
        _o = Hi
          ? function (n) {
              return Hi.get(n);
            }
          : qu,
        vo = Wi
          ? function (n) {
              return null == n
                ? []
                : ((n = ni(n)),
                  f(Wi(n), function (t) {
                    return ji.call(n, t);
                  }));
            }
          : Ku,
        go = Wi
          ? function (n) {
              for (var t = []; n; ) s(t, vo(n)), (n = bi(n));
              return t;
            }
          : Ku,
        yo = zt;
      ((Pi && "[object DataView]" != yo(new Pi(new ArrayBuffer(1)))) ||
        (Zi && "[object Map]" != yo(new Zi())) ||
        (qi && "[object Promise]" != yo(qi.resolve())) ||
        (Vi && "[object Set]" != yo(new Vi())) ||
        (Ki && "[object WeakMap]" != yo(new Ki()))) &&
        (yo = function (n) {
          var t = zt(n);
          if ((n = (n = "[object Object]" == t ? n.constructor : F) ? Fe(n) : ""))
            switch (n) {
              case Yi:
                return "[object DataView]";
              case Qi:
                return "[object Map]";
              case Xi:
                return "[object Promise]";
              case no:
                return "[object Set]";
              case to:
                return "[object WeakMap]";
            }
          return t;
        });
      var bo = oi ? gu : Gu,
        xo = Me(lo),
        jo =
          Ii ||
          function (n, t) {
            return Zn.setTimeout(n, t);
          },
        wo = Me(so),
        mo = (function (n) {
          n = lu(n, function (n) {
            return 500 === t.size && t.clear(), n;
          });
          var t = n.cache;
          return n;
        })(function (n) {
          var t = [];
          return (
            en.test(n) && t.push(""),
            n.replace(un, function (n, r, e, u) {
              t.push(e ? u.replace(vn, "$1") : r || n);
            }),
            t
          );
        }),
        Ao = lr(function (n, t) {
          return _u(n) ? jt(n, kt(t, 1, _u, true)) : [];
        }),
        ko = lr(function (n, t) {
          var r = Ge(t);
          return _u(r) && (r = F), _u(n) ? jt(n, kt(t, 1, _u, true), je(r, 2)) : [];
        }),
        Eo = lr(function (n, t) {
          var r = Ge(t);
          return _u(r) && (r = F), _u(n) ? jt(n, kt(t, 1, _u, true), F, r) : [];
        }),
        Oo = lr(function (n) {
          var t = l(n, Sr);
          return t.length && t[0] === n[0] ? Ut(t) : [];
        }),
        So = lr(function (n) {
          var t = Ge(n),
            r = l(n, Sr);
          return t === Ge(r) ? (t = F) : r.pop(), r.length && r[0] === n[0] ? Ut(r, je(t, 2)) : [];
        }),
        Io = lr(function (n) {
          var t = Ge(n),
            r = l(n, Sr);
          return (
            (t = typeof t == "function" ? t : F) && r.pop(),
            r.length && r[0] === n[0] ? Ut(r, F, t) : []
          );
        }),
        Ro = lr(He),
        zo = ge(function (n, t) {
          var r = null == n ? 0 : n.length,
            e = vt(n, t);
          return (
            fr(
              n,
              l(t, function (n) {
                return Re(n, r) ? +n : n;
              }).sort(Ur)
            ),
            e
          );
        }),
        Wo = lr(function (n) {
          return wr(kt(n, 1, _u, true));
        }),
        Bo = lr(function (n) {
          var t = Ge(n);
          return _u(t) && (t = F), wr(kt(n, 1, _u, true), je(t, 2));
        }),
        Lo = lr(function (n) {
          var t = Ge(n),
            t = typeof t == "function" ? t : F;
          return wr(kt(n, 1, _u, true), F, t);
        }),
        Uo = lr(function (n, t) {
          return _u(n) ? jt(n, t) : [];
        }),
        Co = lr(function (n) {
          return Er(f(n, _u));
        }),
        Do = lr(function (n) {
          var t = Ge(n);
          return _u(t) && (t = F), Er(f(n, _u), je(t, 2));
        }),
        Mo = lr(function (n) {
          var t = Ge(n),
            t = typeof t == "function" ? t : F;
          return Er(f(n, _u), F, t);
        }),
        To = lr(Ye),
        $o = lr(function (n) {
          var t = n.length,
            t = 1 < t ? n[t - 1] : F,
            t = typeof t == "function" ? (n.pop(), t) : F;
          return Qe(n, t);
        }),
        Fo = ge(function (n) {
          function t(t) {
            return vt(t, n);
          }
          var r = n.length,
            e = r ? n[0] : 0,
            u = this.__wrapped__;
          return !(1 < r || this.__actions__.length) && u instanceof Mn && Re(e)
            ? ((u = u.slice(e, +e + (r ? 1 : 0))),
              u.__actions__.push({ func: nu, args: [t], thisArg: F }),
              new zn(u, this.__chain__).thru(function (n) {
                return r && !n.length && n.push(F), n;
              }))
            : this.thru(t);
        }),
        No = Nr(function (n, t, r) {
          ci.call(n, r) ? ++n[r] : _t(n, r, 1);
        }),
        Po = Yr(Ze),
        Zo = Yr(qe),
        qo = Nr(function (n, t, r) {
          ci.call(n, r) ? n[r].push(t) : _t(n, r, [t]);
        }),
        Vo = lr(function (n, t, e) {
          var u = -1,
            i = typeof t == "function",
            o = pu(n) ? Hu(n.length) : [];
          return (
            oo(n, function (n) {
              o[++u] = i ? r(t, n, e) : Dt(n, t, e);
            }),
            o
          );
        }),
        Ko = Nr(function (n, t, r) {
          _t(n, r, t);
        }),
        Go = Nr(
          function (n, t, r) {
            n[r ? 0 : 1].push(t);
          },
          function () {
            return [[], []];
          }
        ),
        Ho = lr(function (n, t) {
          if (null == n) return [];
          var r = t.length;
          return (
            1 < r && ze(n, t[0], t[1]) ? (t = []) : 2 < r && ze(t[0], t[1], t[2]) && (t = [t[0]]),
            rr(n, kt(t, 1), [])
          );
        }),
        Jo =
          Si ||
          function () {
            return Zn.Date.now();
          },
        Yo = lr(function (n, t, r) {
          var e = 1;
          if (r.length)
            var u = C(r, xe(Yo)),
              e = 32 | e;
          return le(n, e, t, r, u);
        }),
        Qo = lr(function (n, t, r) {
          var e = 3;
          if (r.length)
            var u = C(r, xe(Qo)),
              e = 32 | e;
          return le(t, e, n, r, u);
        }),
        Xo = lr(function (n, t) {
          return xt(n, 1, t);
        }),
        nf = lr(function (n, t, r) {
          return xt(n, Iu(t) || 0, r);
        });
      lu.Cache = Pn;
      var tf = lr(function (n, t) {
          t = 1 == t.length && af(t[0]) ? l(t[0], S(je())) : l(kt(t, 1), S(je()));
          var e = t.length;
          return lr(function (u) {
            for (var i = -1, o = Mi(u.length, e); ++i < o; ) u[i] = t[i].call(this, u[i]);
            return r(n, this, u);
          });
        }),
        rf = lr(function (n, t) {
          return le(n, 32, F, t, C(t, xe(rf)));
        }),
        ef = lr(function (n, t) {
          return le(n, 64, F, t, C(t, xe(ef)));
        }),
        uf = ge(function (n, t) {
          return le(n, 256, F, F, F, t);
        }),
        of = oe(Wt),
        ff = oe(function (n, t) {
          return n >= t;
        }),
        cf = Mt(
          (function () {
            return arguments;
          })()
        )
          ? Mt
          : function (n) {
              return xu(n) && ci.call(n, "callee") && !ji.call(n, "callee");
            },
        af = Hu.isArray,
        lf = Hn ? S(Hn) : Tt,
        sf = Bi || Gu,
        hf = Jn ? S(Jn) : $t,
        pf = Yn ? S(Yn) : Nt,
        _f = Qn ? S(Qn) : qt,
        vf = Xn ? S(Xn) : Vt,
        gf = nt ? S(nt) : Kt,
        df = oe(Jt),
        yf = oe(function (n, t) {
          return n <= t;
        }),
        bf = Pr(function (n, t) {
          if (Le(t) || pu(t)) Tr(t, Lu(t), n);
          else for (var r in t) ci.call(t, r) && at(n, r, t[r]);
        }),
        xf = Pr(function (n, t) {
          Tr(t, Uu(t), n);
        }),
        jf = Pr(function (n, t, r, e) {
          Tr(t, Uu(t), n, e);
        }),
        wf = Pr(function (n, t, r, e) {
          Tr(t, Lu(t), n, e);
        }),
        mf = ge(vt),
        Af = lr(function (n) {
          return n.push(F, se), r(jf, F, n);
        }),
        kf = lr(function (n) {
          return n.push(F, he), r(Rf, F, n);
        }),
        Ef = ne(function (n, t, r) {
          n[t] = r;
        }, Fu(Nu)),
        Of = ne(function (n, t, r) {
          ci.call(n, t) ? n[t].push(r) : (n[t] = [r]);
        }, je),
        Sf = lr(Dt),
        If = Pr(function (n, t, r) {
          nr(n, t, r);
        }),
        Rf = Pr(function (n, t, r, e) {
          nr(n, t, r, e);
        }),
        zf = ge(function (n, t) {
          var r = {};
          if (null == n) return r;
          var e = false;
          (t = l(t, function (t) {
            return (t = Rr(t, n)), e || (e = 1 < t.length), t;
          })),
            Tr(n, ye(n), r),
            e && (r = dt(r, 7, pe));
          for (var u = t.length; u--; ) mr(r, t[u]);
          return r;
        }),
        Wf = ge(function (n, t) {
          return null == n ? {} : er(n, t);
        }),
        Bf = ae(Lu),
        Lf = ae(Uu),
        Uf = Gr(function (n, t, r) {
          return (t = t.toLowerCase()), n + (r ? Mu(t) : t);
        }),
        Cf = Gr(function (n, t, r) {
          return n + (r ? "-" : "") + t.toLowerCase();
        }),
        Df = Gr(function (n, t, r) {
          return n + (r ? " " : "") + t.toLowerCase();
        }),
        Mf = Kr("toLowerCase"),
        Tf = Gr(function (n, t, r) {
          return n + (r ? "_" : "") + t.toLowerCase();
        }),
        $f = Gr(function (n, t, r) {
          return n + (r ? " " : "") + Nf(t);
        }),
        Ff = Gr(function (n, t, r) {
          return n + (r ? " " : "") + t.toUpperCase();
        }),
        Nf = Kr("toUpperCase"),
        Pf = lr(function (n, t) {
          try {
            return r(n, F, t);
          } catch (n) {
            return vu(n) ? n : new Yu(n);
          }
        }),
        Zf = ge(function (n, t) {
          return (
            u(t, function (t) {
              (t = $e(t)), _t(n, t, Yo(n[t], n));
            }),
            n
          );
        }),
        qf = Qr(),
        Vf = Qr(true),
        Kf = lr(function (n, t) {
          return function (r) {
            return Dt(r, n, t);
          };
        }),
        Gf = lr(function (n, t) {
          return function (r) {
            return Dt(n, r, t);
          };
        }),
        Hf = re(l),
        Jf = re(o),
        Yf = re(_),
        Qf = ie(),
        Xf = ie(true),
        nc = te(function (n, t) {
          return n + t;
        }, 0),
        tc = ce("ceil"),
        rc = te(function (n, t) {
          return n / t;
        }, 1),
        ec = ce("floor"),
        uc = te(function (n, t) {
          return n * t;
        }, 1),
        ic = ce("round"),
        oc = te(function (n, t) {
          return n - t;
        }, 0);
      return (
        (On.after = function (n, t) {
          if (typeof t != "function") throw new ei("Expected a function");
          return (
            (n = Ou(n)),
            function () {
              if (1 > --n) return t.apply(this, arguments);
            }
          );
        }),
        (On.ary = iu),
        (On.assign = bf),
        (On.assignIn = xf),
        (On.assignInWith = jf),
        (On.assignWith = wf),
        (On.at = mf),
        (On.before = ou),
        (On.bind = Yo),
        (On.bindAll = Zf),
        (On.bindKey = Qo),
        (On.castArray = function () {
          if (!arguments.length) return [];
          var n = arguments[0];
          return af(n) ? n : [n];
        }),
        (On.chain = Xe),
        (On.chunk = function (n, t, r) {
          if (
            ((t = (r ? ze(n, t, r) : t === F) ? 1 : Di(Ou(t), 0)),
            (r = null == n ? 0 : n.length),
            !r || 1 > t)
          )
            return [];
          for (var e = 0, u = 0, i = Hu(Ri(r / t)); e < r; ) i[u++] = vr(n, e, (e += t));
          return i;
        }),
        (On.compact = function (n) {
          for (var t = -1, r = null == n ? 0 : n.length, e = 0, u = []; ++t < r; ) {
            var i = n[t];
            i && (u[e++] = i);
          }
          return u;
        }),
        (On.concat = function () {
          var n = arguments.length;
          if (!n) return [];
          for (var t = Hu(n - 1), r = arguments[0]; n--; ) t[n - 1] = arguments[n];
          return s(af(r) ? Mr(r) : [r], kt(t, 1));
        }),
        (On.cond = function (n) {
          var t = null == n ? 0 : n.length,
            e = je();
          return (
            (n = t
              ? l(n, function (n) {
                  if ("function" != typeof n[1]) throw new ei("Expected a function");
                  return [e(n[0]), n[1]];
                })
              : []),
            lr(function (e) {
              for (var u = -1; ++u < t; ) {
                var i = n[u];
                if (r(i[0], this, e)) return r(i[1], this, e);
              }
            })
          );
        }),
        (On.conforms = function (n) {
          return yt(dt(n, 1));
        }),
        (On.constant = Fu),
        (On.countBy = No),
        (On.create = function (n, t) {
          var r = io(n);
          return null == t ? r : ht(r, t);
        }),
        (On.curry = fu),
        (On.curryRight = cu),
        (On.debounce = au),
        (On.defaults = Af),
        (On.defaultsDeep = kf),
        (On.defer = Xo),
        (On.delay = nf),
        (On.difference = Ao),
        (On.differenceBy = ko),
        (On.differenceWith = Eo),
        (On.drop = function (n, t, r) {
          var e = null == n ? 0 : n.length;
          return e ? ((t = r || t === F ? 1 : Ou(t)), vr(n, 0 > t ? 0 : t, e)) : [];
        }),
        (On.dropRight = function (n, t, r) {
          var e = null == n ? 0 : n.length;
          return e ? ((t = r || t === F ? 1 : Ou(t)), (t = e - t), vr(n, 0, 0 > t ? 0 : t)) : [];
        }),
        (On.dropRightWhile = function (n, t) {
          return n && n.length ? Ar(n, je(t, 3), true, true) : [];
        }),
        (On.dropWhile = function (n, t) {
          return n && n.length ? Ar(n, je(t, 3), true) : [];
        }),
        (On.fill = function (n, t, r, e) {
          var u = null == n ? 0 : n.length;
          if (!u) return [];
          for (
            r && typeof r != "number" && ze(n, t, r) && ((r = 0), (e = u)),
              u = n.length,
              r = Ou(r),
              0 > r && (r = -r > u ? 0 : u + r),
              e = e === F || e > u ? u : Ou(e),
              0 > e && (e += u),
              e = r > e ? 0 : Su(e);
            r < e;

          )
            n[r++] = t;
          return n;
        }),
        (On.filter = function (n, t) {
          return (af(n) ? f : At)(n, je(t, 3));
        }),
        (On.flatMap = function (n, t) {
          return kt(uu(n, t), 1);
        }),
        (On.flatMapDeep = function (n, t) {
          return kt(uu(n, t), N);
        }),
        (On.flatMapDepth = function (n, t, r) {
          return (r = r === F ? 1 : Ou(r)), kt(uu(n, t), r);
        }),
        (On.flatten = Ve),
        (On.flattenDeep = function (n) {
          return (null == n ? 0 : n.length) ? kt(n, N) : [];
        }),
        (On.flattenDepth = function (n, t) {
          return null != n && n.length ? ((t = t === F ? 1 : Ou(t)), kt(n, t)) : [];
        }),
        (On.flip = function (n) {
          return le(n, 512);
        }),
        (On.flow = qf),
        (On.flowRight = Vf),
        (On.fromPairs = function (n) {
          for (var t = -1, r = null == n ? 0 : n.length, e = {}; ++t < r; ) {
            var u = n[t];
            e[u[0]] = u[1];
          }
          return e;
        }),
        (On.functions = function (n) {
          return null == n ? [] : St(n, Lu(n));
        }),
        (On.functionsIn = function (n) {
          return null == n ? [] : St(n, Uu(n));
        }),
        (On.groupBy = qo),
        (On.initial = function (n) {
          return (null == n ? 0 : n.length) ? vr(n, 0, -1) : [];
        }),
        (On.intersection = Oo),
        (On.intersectionBy = So),
        (On.intersectionWith = Io),
        (On.invert = Ef),
        (On.invertBy = Of),
        (On.invokeMap = Vo),
        (On.iteratee = Pu),
        (On.keyBy = Ko),
        (On.keys = Lu),
        (On.keysIn = Uu),
        (On.map = uu),
        (On.mapKeys = function (n, t) {
          var r = {};
          return (
            (t = je(t, 3)),
            Et(n, function (n, e, u) {
              _t(r, t(n, e, u), n);
            }),
            r
          );
        }),
        (On.mapValues = function (n, t) {
          var r = {};
          return (
            (t = je(t, 3)),
            Et(n, function (n, e, u) {
              _t(r, e, t(n, e, u));
            }),
            r
          );
        }),
        (On.matches = function (n) {
          return Qt(dt(n, 1));
        }),
        (On.matchesProperty = function (n, t) {
          return Xt(n, dt(t, 1));
        }),
        (On.memoize = lu),
        (On.merge = If),
        (On.mergeWith = Rf),
        (On.method = Kf),
        (On.methodOf = Gf),
        (On.mixin = Zu),
        (On.negate = su),
        (On.nthArg = function (n) {
          return (
            (n = Ou(n)),
            lr(function (t) {
              return tr(t, n);
            })
          );
        }),
        (On.omit = zf),
        (On.omitBy = function (n, t) {
          return Cu(n, su(je(t)));
        }),
        (On.once = function (n) {
          return ou(2, n);
        }),
        (On.orderBy = function (n, t, r, e) {
          return null == n
            ? []
            : (af(t) || (t = null == t ? [] : [t]),
              (r = e ? F : r),
              af(r) || (r = null == r ? [] : [r]),
              rr(n, t, r));
        }),
        (On.over = Hf),
        (On.overArgs = tf),
        (On.overEvery = Jf),
        (On.overSome = Yf),
        (On.partial = rf),
        (On.partialRight = ef),
        (On.partition = Go),
        (On.pick = Wf),
        (On.pickBy = Cu),
        (On.property = Vu),
        (On.propertyOf = function (n) {
          return function (t) {
            return null == n ? F : It(n, t);
          };
        }),
        (On.pull = Ro),
        (On.pullAll = He),
        (On.pullAllBy = function (n, t, r) {
          return n && n.length && t && t.length ? or(n, t, je(r, 2)) : n;
        }),
        (On.pullAllWith = function (n, t, r) {
          return n && n.length && t && t.length ? or(n, t, F, r) : n;
        }),
        (On.pullAt = zo),
        (On.range = Qf),
        (On.rangeRight = Xf),
        (On.rearg = uf),
        (On.reject = function (n, t) {
          return (af(n) ? f : At)(n, su(je(t, 3)));
        }),
        (On.remove = function (n, t) {
          var r = [];
          if (!n || !n.length) return r;
          var e = -1,
            u = [],
            i = n.length;
          for (t = je(t, 3); ++e < i; ) {
            var o = n[e];
            t(o, e, n) && (r.push(o), u.push(e));
          }
          return fr(n, u), r;
        }),
        (On.rest = function (n, t) {
          if (typeof n != "function") throw new ei("Expected a function");
          return (t = t === F ? t : Ou(t)), lr(n, t);
        }),
        (On.reverse = Je),
        (On.sampleSize = function (n, t, r) {
          return (t = (r ? ze(n, t, r) : t === F) ? 1 : Ou(t)), (af(n) ? ot : hr)(n, t);
        }),
        (On.set = function (n, t, r) {
          return null == n ? n : pr(n, t, r);
        }),
        (On.setWith = function (n, t, r, e) {
          return (e = typeof e == "function" ? e : F), null == n ? n : pr(n, t, r, e);
        }),
        (On.shuffle = function (n) {
          return (af(n) ? ft : _r)(n);
        }),
        (On.slice = function (n, t, r) {
          var e = null == n ? 0 : n.length;
          return e
            ? (r && typeof r != "number" && ze(n, t, r)
                ? ((t = 0), (r = e))
                : ((t = null == t ? 0 : Ou(t)), (r = r === F ? e : Ou(r))),
              vr(n, t, r))
            : [];
        }),
        (On.sortBy = Ho),
        (On.sortedUniq = function (n) {
          return n && n.length ? br(n) : [];
        }),
        (On.sortedUniqBy = function (n, t) {
          return n && n.length ? br(n, je(t, 2)) : [];
        }),
        (On.split = function (n, t, r) {
          return (
            r && typeof r != "number" && ze(n, t, r) && (t = r = F),
            (r = r === F ? 4294967295 : r >>> 0),
            r
              ? (n = zu(n)) &&
                (typeof t == "string" || (null != t && !_f(t))) &&
                ((t = jr(t)), !t && Bn.test(n))
                ? zr($(n), 0, r)
                : n.split(t, r)
              : []
          );
        }),
        (On.spread = function (n, t) {
          if (typeof n != "function") throw new ei("Expected a function");
          return (
            (t = null == t ? 0 : Di(Ou(t), 0)),
            lr(function (e) {
              var u = e[t];
              return (e = zr(e, 0, t)), u && s(e, u), r(n, this, e);
            })
          );
        }),
        (On.tail = function (n) {
          var t = null == n ? 0 : n.length;
          return t ? vr(n, 1, t) : [];
        }),
        (On.take = function (n, t, r) {
          return n && n.length ? ((t = r || t === F ? 1 : Ou(t)), vr(n, 0, 0 > t ? 0 : t)) : [];
        }),
        (On.takeRight = function (n, t, r) {
          var e = null == n ? 0 : n.length;
          return e ? ((t = r || t === F ? 1 : Ou(t)), (t = e - t), vr(n, 0 > t ? 0 : t, e)) : [];
        }),
        (On.takeRightWhile = function (n, t) {
          return n && n.length ? Ar(n, je(t, 3), false, true) : [];
        }),
        (On.takeWhile = function (n, t) {
          return n && n.length ? Ar(n, je(t, 3)) : [];
        }),
        (On.tap = function (n, t) {
          return t(n), n;
        }),
        (On.throttle = function (n, t, r) {
          var e = true,
            u = true;
          if (typeof n != "function") throw new ei("Expected a function");
          return (
            bu(r) &&
              ((e = "leading" in r ? !!r.leading : e), (u = "trailing" in r ? !!r.trailing : u)),
            au(n, t, { leading: e, maxWait: t, trailing: u })
          );
        }),
        (On.thru = nu),
        (On.toArray = ku),
        (On.toPairs = Bf),
        (On.toPairsIn = Lf),
        (On.toPath = function (n) {
          return af(n) ? l(n, $e) : Au(n) ? [n] : Mr(mo(zu(n)));
        }),
        (On.toPlainObject = Ru),
        (On.transform = function (n, t, r) {
          var e = af(n),
            i = e || sf(n) || gf(n);
          if (((t = je(t, 4)), null == r)) {
            var o = n && n.constructor;
            r = i ? (e ? new o() : []) : bu(n) && gu(o) ? io(bi(n)) : {};
          }
          return (
            (i ? u : Et)(n, function (n, e, u) {
              return t(r, n, e, u);
            }),
            r
          );
        }),
        (On.unary = function (n) {
          return iu(n, 1);
        }),
        (On.union = Wo),
        (On.unionBy = Bo),
        (On.unionWith = Lo),
        (On.uniq = function (n) {
          return n && n.length ? wr(n) : [];
        }),
        (On.uniqBy = function (n, t) {
          return n && n.length ? wr(n, je(t, 2)) : [];
        }),
        (On.uniqWith = function (n, t) {
          return (t = typeof t == "function" ? t : F), n && n.length ? wr(n, F, t) : [];
        }),
        (On.unset = function (n, t) {
          return null == n || mr(n, t);
        }),
        (On.unzip = Ye),
        (On.unzipWith = Qe),
        (On.update = function (n, t, r) {
          return null == n ? n : pr(n, t, Ir(r)(It(n, t)), void 0);
        }),
        (On.updateWith = function (n, t, r, e) {
          return (
            (e = typeof e == "function" ? e : F), null != n && (n = pr(n, t, Ir(r)(It(n, t)), e)), n
          );
        }),
        (On.values = Du),
        (On.valuesIn = function (n) {
          return null == n ? [] : I(n, Uu(n));
        }),
        (On.without = Uo),
        (On.words = $u),
        (On.wrap = function (n, t) {
          return rf(Ir(t), n);
        }),
        (On.xor = Co),
        (On.xorBy = Do),
        (On.xorWith = Mo),
        (On.zip = To),
        (On.zipObject = function (n, t) {
          return Or(n || [], t || [], at);
        }),
        (On.zipObjectDeep = function (n, t) {
          return Or(n || [], t || [], pr);
        }),
        (On.zipWith = $o),
        (On.entries = Bf),
        (On.entriesIn = Lf),
        (On.extend = xf),
        (On.extendWith = jf),
        Zu(On, On),
        (On.add = nc),
        (On.attempt = Pf),
        (On.camelCase = Uf),
        (On.capitalize = Mu),
        (On.ceil = tc),
        (On.clamp = function (n, t, r) {
          return (
            r === F && ((r = t), (t = F)),
            r !== F && ((r = Iu(r)), (r = r === r ? r : 0)),
            t !== F && ((t = Iu(t)), (t = t === t ? t : 0)),
            gt(Iu(n), t, r)
          );
        }),
        (On.clone = function (n) {
          return dt(n, 4);
        }),
        (On.cloneDeep = function (n) {
          return dt(n, 5);
        }),
        (On.cloneDeepWith = function (n, t) {
          return (t = typeof t == "function" ? t : F), dt(n, 5, t);
        }),
        (On.cloneWith = function (n, t) {
          return (t = typeof t == "function" ? t : F), dt(n, 4, t);
        }),
        (On.conformsTo = function (n, t) {
          return null == t || bt(n, t, Lu(t));
        }),
        (On.deburr = Tu),
        (On.defaultTo = function (n, t) {
          return null == n || n !== n ? t : n;
        }),
        (On.divide = rc),
        (On.endsWith = function (n, t, r) {
          (n = zu(n)), (t = jr(t));
          var e = n.length,
            e = (r = r === F ? e : gt(Ou(r), 0, e));
          return (r -= t.length), 0 <= r && n.slice(r, e) == t;
        }),
        (On.eq = hu),
        (On.escape = function (n) {
          return (n = zu(n)) && Y.test(n) ? n.replace(H, et) : n;
        }),
        (On.escapeRegExp = function (n) {
          return (n = zu(n)) && fn.test(n) ? n.replace(on, "\\$&") : n;
        }),
        (On.every = function (n, t, r) {
          var e = af(n) ? o : wt;
          return r && ze(n, t, r) && (t = F), e(n, je(t, 3));
        }),
        (On.find = Po),
        (On.findIndex = Ze),
        (On.findKey = function (n, t) {
          return v(n, je(t, 3), Et);
        }),
        (On.findLast = Zo),
        (On.findLastIndex = qe),
        (On.findLastKey = function (n, t) {
          return v(n, je(t, 3), Ot);
        }),
        (On.floor = ec),
        (On.forEach = ru),
        (On.forEachRight = eu),
        (On.forIn = function (n, t) {
          return null == n ? n : co(n, je(t, 3), Uu);
        }),
        (On.forInRight = function (n, t) {
          return null == n ? n : ao(n, je(t, 3), Uu);
        }),
        (On.forOwn = function (n, t) {
          return n && Et(n, je(t, 3));
        }),
        (On.forOwnRight = function (n, t) {
          return n && Ot(n, je(t, 3));
        }),
        (On.get = Wu),
        (On.gt = of),
        (On.gte = ff),
        (On.has = function (n, t) {
          return null != n && ke(n, t, Bt);
        }),
        (On.hasIn = Bu),
        (On.head = Ke),
        (On.identity = Nu),
        (On.includes = function (n, t, r, e) {
          return (
            (n = pu(n) ? n : Du(n)),
            (r = r && !e ? Ou(r) : 0),
            (e = n.length),
            0 > r && (r = Di(e + r, 0)),
            mu(n) ? r <= e && -1 < n.indexOf(t, r) : !!e && -1 < d(n, t, r)
          );
        }),
        (On.indexOf = function (n, t, r) {
          var e = null == n ? 0 : n.length;
          return e ? ((r = null == r ? 0 : Ou(r)), 0 > r && (r = Di(e + r, 0)), d(n, t, r)) : -1;
        }),
        (On.inRange = function (n, t, r) {
          return (
            (t = Eu(t)),
            r === F ? ((r = t), (t = 0)) : (r = Eu(r)),
            (n = Iu(n)),
            n >= Mi(t, r) && n < Di(t, r)
          );
        }),
        (On.invoke = Sf),
        (On.isArguments = cf),
        (On.isArray = af),
        (On.isArrayBuffer = lf),
        (On.isArrayLike = pu),
        (On.isArrayLikeObject = _u),
        (On.isBoolean = function (n) {
          return true === n || false === n || (xu(n) && "[object Boolean]" == zt(n));
        }),
        (On.isBuffer = sf),
        (On.isDate = hf),
        (On.isElement = function (n) {
          return xu(n) && 1 === n.nodeType && !wu(n);
        }),
        (On.isEmpty = function (n) {
          if (null == n) return true;
          if (
            pu(n) &&
            (af(n) ||
              typeof n == "string" ||
              typeof n.splice == "function" ||
              sf(n) ||
              gf(n) ||
              cf(n))
          )
            return !n.length;
          var t = yo(n);
          if ("[object Map]" == t || "[object Set]" == t) return !n.size;
          if (Le(n)) return !Ht(n).length;
          for (var r in n) if (ci.call(n, r)) return false;
          return true;
        }),
        (On.isEqual = function (n, t) {
          return Ft(n, t);
        }),
        (On.isEqualWith = function (n, t, r) {
          var e = (r = typeof r == "function" ? r : F) ? r(n, t) : F;
          return e === F ? Ft(n, t, F, r) : !!e;
        }),
        (On.isError = vu),
        (On.isFinite = function (n) {
          return typeof n == "number" && Li(n);
        }),
        (On.isFunction = gu),
        (On.isInteger = du),
        (On.isLength = yu),
        (On.isMap = pf),
        (On.isMatch = function (n, t) {
          return n === t || Pt(n, t, me(t));
        }),
        (On.isMatchWith = function (n, t, r) {
          return (r = typeof r == "function" ? r : F), Pt(n, t, me(t), r);
        }),
        (On.isNaN = function (n) {
          return ju(n) && n != +n;
        }),
        (On.isNative = function (n) {
          if (bo(n))
            throw new Yu("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
          return Zt(n);
        }),
        (On.isNil = function (n) {
          return null == n;
        }),
        (On.isNull = function (n) {
          return null === n;
        }),
        (On.isNumber = ju),
        (On.isObject = bu),
        (On.isObjectLike = xu),
        (On.isPlainObject = wu),
        (On.isRegExp = _f),
        (On.isSafeInteger = function (n) {
          return du(n) && -9007199254740991 <= n && 9007199254740991 >= n;
        }),
        (On.isSet = vf),
        (On.isString = mu),
        (On.isSymbol = Au),
        (On.isTypedArray = gf),
        (On.isUndefined = function (n) {
          return n === F;
        }),
        (On.isWeakMap = function (n) {
          return xu(n) && "[object WeakMap]" == yo(n);
        }),
        (On.isWeakSet = function (n) {
          return xu(n) && "[object WeakSet]" == zt(n);
        }),
        (On.join = function (n, t) {
          return null == n ? "" : Ui.call(n, t);
        }),
        (On.kebabCase = Cf),
        (On.last = Ge),
        (On.lastIndexOf = function (n, t, r) {
          var e = null == n ? 0 : n.length;
          if (!e) return -1;
          var u = e;
          if ((r !== F && ((u = Ou(r)), (u = 0 > u ? Di(e + u, 0) : Mi(u, e - 1))), t === t)) {
            for (r = u + 1; r-- && n[r] !== t; );
            n = r;
          } else n = g(n, b, u, true);
          return n;
        }),
        (On.lowerCase = Df),
        (On.lowerFirst = Mf),
        (On.lt = df),
        (On.lte = yf),
        (On.max = function (n) {
          return n && n.length ? mt(n, Nu, Wt) : F;
        }),
        (On.maxBy = function (n, t) {
          return n && n.length ? mt(n, je(t, 2), Wt) : F;
        }),
        (On.mean = function (n) {
          return x(n, Nu);
        }),
        (On.meanBy = function (n, t) {
          return x(n, je(t, 2));
        }),
        (On.min = function (n) {
          return n && n.length ? mt(n, Nu, Jt) : F;
        }),
        (On.minBy = function (n, t) {
          return n && n.length ? mt(n, je(t, 2), Jt) : F;
        }),
        (On.stubArray = Ku),
        (On.stubFalse = Gu),
        (On.stubObject = function () {
          return {};
        }),
        (On.stubString = function () {
          return "";
        }),
        (On.stubTrue = function () {
          return true;
        }),
        (On.multiply = uc),
        (On.nth = function (n, t) {
          return n && n.length ? tr(n, Ou(t)) : F;
        }),
        (On.noConflict = function () {
          return Zn._ === this && (Zn._ = pi), this;
        }),
        (On.noop = qu),
        (On.now = Jo),
        (On.pad = function (n, t, r) {
          n = zu(n);
          var e = (t = Ou(t)) ? T(n) : 0;
          return !t || e >= t ? n : ((t = (t - e) / 2), ee(zi(t), r) + n + ee(Ri(t), r));
        }),
        (On.padEnd = function (n, t, r) {
          n = zu(n);
          var e = (t = Ou(t)) ? T(n) : 0;
          return t && e < t ? n + ee(t - e, r) : n;
        }),
        (On.padStart = function (n, t, r) {
          n = zu(n);
          var e = (t = Ou(t)) ? T(n) : 0;
          return t && e < t ? ee(t - e, r) + n : n;
        }),
        (On.parseInt = function (n, t, r) {
          return r || null == t ? (t = 0) : t && (t = +t), $i(zu(n).replace(an, ""), t || 0);
        }),
        (On.random = function (n, t, r) {
          if (
            (r && typeof r != "boolean" && ze(n, t, r) && (t = r = F),
            r === F &&
              (typeof t == "boolean"
                ? ((r = t), (t = F))
                : typeof n == "boolean" && ((r = n), (n = F))),
            n === F && t === F
              ? ((n = 0), (t = 1))
              : ((n = Eu(n)), t === F ? ((t = n), (n = 0)) : (t = Eu(t))),
            n > t)
          ) {
            var e = n;
            (n = t), (t = e);
          }
          return r || n % 1 || t % 1
            ? ((r = Fi()), Mi(n + r * (t - n + $n("1e-" + ((r + "").length - 1))), t))
            : cr(n, t);
        }),
        (On.reduce = function (n, t, r) {
          var e = af(n) ? h : m,
            u = 3 > arguments.length;
          return e(n, je(t, 4), r, u, oo);
        }),
        (On.reduceRight = function (n, t, r) {
          var e = af(n) ? p : m,
            u = 3 > arguments.length;
          return e(n, je(t, 4), r, u, fo);
        }),
        (On.repeat = function (n, t, r) {
          return (t = (r ? ze(n, t, r) : t === F) ? 1 : Ou(t)), ar(zu(n), t);
        }),
        (On.replace = function () {
          var n = arguments,
            t = zu(n[0]);
          return 3 > n.length ? t : t.replace(n[1], n[2]);
        }),
        (On.result = function (n, t, r) {
          t = Rr(t, n);
          var e = -1,
            u = t.length;
          for (u || ((u = 1), (n = F)); ++e < u; ) {
            var i = null == n ? F : n[$e(t[e])];
            i === F && ((e = u), (i = r)), (n = gu(i) ? i.call(n) : i);
          }
          return n;
        }),
        (On.round = ic),
        (On.runInContext = w),
        (On.sample = function (n) {
          return (af(n) ? tt : sr)(n);
        }),
        (On.size = function (n) {
          if (null == n) return 0;
          if (pu(n)) return mu(n) ? T(n) : n.length;
          var t = yo(n);
          return "[object Map]" == t || "[object Set]" == t ? n.size : Ht(n).length;
        }),
        (On.snakeCase = Tf),
        (On.some = function (n, t, r) {
          var e = af(n) ? _ : gr;
          return r && ze(n, t, r) && (t = F), e(n, je(t, 3));
        }),
        (On.sortedIndex = function (n, t) {
          return dr(n, t);
        }),
        (On.sortedIndexBy = function (n, t, r) {
          return yr(n, t, je(r, 2));
        }),
        (On.sortedIndexOf = function (n, t) {
          var r = null == n ? 0 : n.length;
          if (r) {
            var e = dr(n, t);
            if (e < r && hu(n[e], t)) return e;
          }
          return -1;
        }),
        (On.sortedLastIndex = function (n, t) {
          return dr(n, t, true);
        }),
        (On.sortedLastIndexBy = function (n, t, r) {
          return yr(n, t, je(r, 2), true);
        }),
        (On.sortedLastIndexOf = function (n, t) {
          if (null == n ? 0 : n.length) {
            var r = dr(n, t, true) - 1;
            if (hu(n[r], t)) return r;
          }
          return -1;
        }),
        (On.startCase = $f),
        (On.startsWith = function (n, t, r) {
          return (
            (n = zu(n)),
            (r = null == r ? 0 : gt(Ou(r), 0, n.length)),
            (t = jr(t)),
            n.slice(r, r + t.length) == t
          );
        }),
        (On.subtract = oc),
        (On.sum = function (n) {
          return n && n.length ? k(n, Nu) : 0;
        }),
        (On.sumBy = function (n, t) {
          return n && n.length ? k(n, je(t, 2)) : 0;
        }),
        (On.template = function (n, t, r) {
          var e = On.templateSettings;
          r && ze(n, t, r) && (t = F),
            (n = zu(n)),
            (t = jf({}, t, e, se)),
            (r = jf({}, t.imports, e.imports, se));
          var u,
            i,
            o = Lu(r),
            f = I(r, o),
            c = 0;
          r = t.interpolate || An;
          var a = "__p+='";
          r = ti(
            (t.escape || An).source +
              "|" +
              r.source +
              "|" +
              (r === nn ? gn : An).source +
              "|" +
              (t.evaluate || An).source +
              "|$",
            "g"
          );
          var l = "sourceURL" in t ? "//# sourceURL=" + t.sourceURL + "\n" : "";
          if (
            (n.replace(r, function (t, r, e, o, f, l) {
              return (
                e || (e = o),
                (a += n.slice(c, l).replace(kn, B)),
                r && ((u = true), (a += "'+__e(" + r + ")+'")),
                f && ((i = true), (a += "';" + f + ";\n__p+='")),
                e && (a += "'+((__t=(" + e + "))==null?'':__t)+'"),
                (c = l + t.length),
                t
              );
            }),
            (a += "';"),
            (t = t.variable) || (a = "with(obj){" + a + "}"),
            (a = (i ? a.replace(q, "") : a).replace(V, "$1").replace(K, "$1;")),
            (a =
              "function(" +
              (t || "obj") +
              "){" +
              (t ? "" : "obj||(obj={});") +
              "var __t,__p=''" +
              (u ? ",__e=_.escape" : "") +
              (i
                ? ",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}"
                : ";") +
              a +
              "return __p}"),
            (t = Pf(function () {
              return Qu(o, l + "return " + a).apply(F, f);
            })),
            (t.source = a),
            vu(t))
          )
            throw t;
          return t;
        }),
        (On.times = function (n, t) {
          if (((n = Ou(n)), 1 > n || 9007199254740991 < n)) return [];
          var r = 4294967295,
            e = Mi(n, 4294967295);
          for (t = je(t), n -= 4294967295, e = E(e, t); ++r < n; ) t(r);
          return e;
        }),
        (On.toFinite = Eu),
        (On.toInteger = Ou),
        (On.toLength = Su),
        (On.toLower = function (n) {
          return zu(n).toLowerCase();
        }),
        (On.toNumber = Iu),
        (On.toSafeInteger = function (n) {
          return n ? gt(Ou(n), -9007199254740991, 9007199254740991) : 0 === n ? n : 0;
        }),
        (On.toString = zu),
        (On.toUpper = function (n) {
          return zu(n).toUpperCase();
        }),
        (On.trim = function (n, t, r) {
          return (n = zu(n)) && (r || t === F)
            ? n.replace(cn, "")
            : n && (t = jr(t))
            ? ((n = $(n)), (r = $(t)), (t = z(n, r)), (r = W(n, r) + 1), zr(n, t, r).join(""))
            : n;
        }),
        (On.trimEnd = function (n, t, r) {
          return (n = zu(n)) && (r || t === F)
            ? n.replace(ln, "")
            : n && (t = jr(t))
            ? ((n = $(n)), (t = W(n, $(t)) + 1), zr(n, 0, t).join(""))
            : n;
        }),
        (On.trimStart = function (n, t, r) {
          return (n = zu(n)) && (r || t === F)
            ? n.replace(an, "")
            : n && (t = jr(t))
            ? ((n = $(n)), (t = z(n, $(t))), zr(n, t).join(""))
            : n;
        }),
        (On.truncate = function (n, t) {
          var r = 30,
            e = "...";
          if (bu(t))
            var u = "separator" in t ? t.separator : u,
              r = "length" in t ? Ou(t.length) : r,
              e = "omission" in t ? jr(t.omission) : e;
          n = zu(n);
          var i = n.length;
          if (Bn.test(n))
            var o = $(n),
              i = o.length;
          if (r >= i) return n;
          if (((i = r - T(e)), 1 > i)) return e;
          if (((r = o ? zr(o, 0, i).join("") : n.slice(0, i)), u === F)) return r + e;
          if ((o && (i += r.length - i), _f(u))) {
            if (n.slice(i).search(u)) {
              var f = r;
              for (
                u.global || (u = ti(u.source, zu(dn.exec(u)) + "g")), u.lastIndex = 0;
                (o = u.exec(f));

              )
                var c = o.index;
              r = r.slice(0, c === F ? i : c);
            }
          } else
            n.indexOf(jr(u), i) != i && ((u = r.lastIndexOf(u)), -1 < u && (r = r.slice(0, u)));
          return r + e;
        }),
        (On.unescape = function (n) {
          return (n = zu(n)) && J.test(n) ? n.replace(G, ut) : n;
        }),
        (On.uniqueId = function (n) {
          var t = ++ai;
          return zu(n) + t;
        }),
        (On.upperCase = Ff),
        (On.upperFirst = Nf),
        (On.each = ru),
        (On.eachRight = eu),
        (On.first = Ke),
        Zu(
          On,
          (function () {
            var n = {};
            return (
              Et(On, function (t, r) {
                ci.call(On.prototype, r) || (n[r] = t);
              }),
              n
            );
          })(),
          { chain: false }
        ),
        (On.VERSION = "4.17.4"),
        u("bind bindKey curry curryRight partial partialRight".split(" "), function (n) {
          On[n].placeholder = On;
        }),
        u(["drop", "take"], function (n, t) {
          (Mn.prototype[n] = function (r) {
            r = r === F ? 1 : Di(Ou(r), 0);
            var e = this.__filtered__ && !t ? new Mn(this) : this.clone();
            return (
              e.__filtered__
                ? (e.__takeCount__ = Mi(r, e.__takeCount__))
                : e.__views__.push({
                    size: Mi(r, 4294967295),
                    type: n + (0 > e.__dir__ ? "Right" : ""),
                  }),
              e
            );
          }),
            (Mn.prototype[n + "Right"] = function (t) {
              return this.reverse()[n](t).reverse();
            });
        }),
        u(["filter", "map", "takeWhile"], function (n, t) {
          var r = t + 1,
            e = 1 == r || 3 == r;
          Mn.prototype[n] = function (n) {
            var t = this.clone();
            return (
              t.__iteratees__.push({ iteratee: je(n, 3), type: r }),
              (t.__filtered__ = t.__filtered__ || e),
              t
            );
          };
        }),
        u(["head", "last"], function (n, t) {
          var r = "take" + (t ? "Right" : "");
          Mn.prototype[n] = function () {
            return this[r](1).value()[0];
          };
        }),
        u(["initial", "tail"], function (n, t) {
          var r = "drop" + (t ? "" : "Right");
          Mn.prototype[n] = function () {
            return this.__filtered__ ? new Mn(this) : this[r](1);
          };
        }),
        (Mn.prototype.compact = function () {
          return this.filter(Nu);
        }),
        (Mn.prototype.find = function (n) {
          return this.filter(n).head();
        }),
        (Mn.prototype.findLast = function (n) {
          return this.reverse().find(n);
        }),
        (Mn.prototype.invokeMap = lr(function (n, t) {
          return typeof n == "function"
            ? new Mn(this)
            : this.map(function (r) {
                return Dt(r, n, t);
              });
        })),
        (Mn.prototype.reject = function (n) {
          return this.filter(su(je(n)));
        }),
        (Mn.prototype.slice = function (n, t) {
          n = Ou(n);
          var r = this;
          return r.__filtered__ && (0 < n || 0 > t)
            ? new Mn(r)
            : (0 > n ? (r = r.takeRight(-n)) : n && (r = r.drop(n)),
              t !== F && ((t = Ou(t)), (r = 0 > t ? r.dropRight(-t) : r.take(t - n))),
              r);
        }),
        (Mn.prototype.takeRightWhile = function (n) {
          return this.reverse().takeWhile(n).reverse();
        }),
        (Mn.prototype.toArray = function () {
          return this.take(4294967295);
        }),
        Et(Mn.prototype, function (n, t) {
          var r = /^(?:filter|find|map|reject)|While$/.test(t),
            e = /^(?:head|last)$/.test(t),
            u = On[e ? "take" + ("last" == t ? "Right" : "") : t],
            i = e || /^find/.test(t);
          u &&
            (On.prototype[t] = function () {
              function t(n) {
                return (n = u.apply(On, s([n], f))), e && h ? n[0] : n;
              }
              var o = this.__wrapped__,
                f = e ? [1] : arguments,
                c = o instanceof Mn,
                a = f[0],
                l = c || af(o);
              l && r && typeof a == "function" && 1 != a.length && (c = l = false);
              var h = this.__chain__,
                p = !!this.__actions__.length,
                a = i && !h,
                c = c && !p;
              return !i && l
                ? ((o = c ? o : new Mn(this)),
                  (o = n.apply(o, f)),
                  o.__actions__.push({ func: nu, args: [t], thisArg: F }),
                  new zn(o, h))
                : a && c
                ? n.apply(this, f)
                : ((o = this.thru(t)), a ? (e ? o.value()[0] : o.value()) : o);
            });
        }),
        u("pop push shift sort splice unshift".split(" "), function (n) {
          var t = ui[n],
            r = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru",
            e = /^(?:pop|shift)$/.test(n);
          On.prototype[n] = function () {
            var n = arguments;
            if (e && !this.__chain__) {
              var u = this.value();
              return t.apply(af(u) ? u : [], n);
            }
            return this[r](function (r) {
              return t.apply(af(r) ? r : [], n);
            });
          };
        }),
        Et(Mn.prototype, function (n, t) {
          var r = On[t];
          if (r) {
            var e = r.name + "";
            (Ji[e] || (Ji[e] = [])).push({ name: t, func: r });
          }
        }),
        (Ji[Xr(F, 2).name] = [{ name: "wrapper", func: F }]),
        (Mn.prototype.clone = function () {
          var n = new Mn(this.__wrapped__);
          return (
            (n.__actions__ = Mr(this.__actions__)),
            (n.__dir__ = this.__dir__),
            (n.__filtered__ = this.__filtered__),
            (n.__iteratees__ = Mr(this.__iteratees__)),
            (n.__takeCount__ = this.__takeCount__),
            (n.__views__ = Mr(this.__views__)),
            n
          );
        }),
        (Mn.prototype.reverse = function () {
          if (this.__filtered__) {
            var n = new Mn(this);
            (n.__dir__ = -1), (n.__filtered__ = true);
          } else (n = this.clone()), (n.__dir__ *= -1);
          return n;
        }),
        (Mn.prototype.value = function () {
          var n,
            t = this.__wrapped__.value(),
            r = this.__dir__,
            e = af(t),
            u = 0 > r,
            i = e ? t.length : 0;
          n = i;
          for (var o = this.__views__, f = 0, c = -1, a = o.length; ++c < a; ) {
            var l = o[c],
              s = l.size;
            switch (l.type) {
              case "drop":
                f += s;
                break;
              case "dropRight":
                n -= s;
                break;
              case "take":
                n = Mi(n, f + s);
                break;
              case "takeRight":
                f = Di(f, n - s);
            }
          }
          if (
            ((n = { start: f, end: n }),
            (o = n.start),
            (f = n.end),
            (n = f - o),
            (o = u ? f : o - 1),
            (f = this.__iteratees__),
            (c = f.length),
            (a = 0),
            (l = Mi(n, this.__takeCount__)),
            !e || (!u && i == n && l == n))
          )
            return kr(t, this.__actions__);
          e = [];
          n: for (; n-- && a < l; ) {
            for (o += r, u = -1, i = t[o]; ++u < c; ) {
              var h = f[u],
                s = h.type,
                h = (0, h.iteratee)(i);
              if (2 == s) i = h;
              else if (!h) {
                if (1 == s) continue n;
                break n;
              }
            }
            e[a++] = i;
          }
          return e;
        }),
        (On.prototype.at = Fo),
        (On.prototype.chain = function () {
          return Xe(this);
        }),
        (On.prototype.commit = function () {
          return new zn(this.value(), this.__chain__);
        }),
        (On.prototype.next = function () {
          this.__values__ === F && (this.__values__ = ku(this.value()));
          var n = this.__index__ >= this.__values__.length;
          return { done: n, value: n ? F : this.__values__[this.__index__++] };
        }),
        (On.prototype.plant = function (n) {
          for (var t, r = this; r instanceof Sn; ) {
            var e = Pe(r);
            (e.__index__ = 0), (e.__values__ = F), t ? (u.__wrapped__ = e) : (t = e);
            var u = e,
              r = r.__wrapped__;
          }
          return (u.__wrapped__ = n), t;
        }),
        (On.prototype.reverse = function () {
          var n = this.__wrapped__;
          return n instanceof Mn
            ? (this.__actions__.length && (n = new Mn(this)),
              (n = n.reverse()),
              n.__actions__.push({ func: nu, args: [Je], thisArg: F }),
              new zn(n, this.__chain__))
            : this.thru(Je);
        }),
        (On.prototype.toJSON =
          On.prototype.valueOf =
          On.prototype.value =
            function () {
              return kr(this.__wrapped__, this.__actions__);
            }),
        (On.prototype.first = On.prototype.head),
        Ai && (On.prototype[Ai] = tu),
        On
      );
    })();
  typeof define == "function" && typeof define.amd == "object" && define.amd
    ? ((Zn._ = it),
      define(function () {
        return it;
      }))
    : Vn
    ? (((Vn.exports = it)._ = it), (qn._ = it))
    : (Zn._ = it);
}).call(this);

/*!
Waypoints - 4.0.0
Copyright © 2011-2015 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!(function () {
  "use strict";
  function t(o) {
    if (!o) throw new Error("No options passed to Waypoint constructor");
    if (!o.element) throw new Error("No element option passed to Waypoint constructor");
    if (!o.handler) throw new Error("No handler option passed to Waypoint constructor");
    (this.key = "waypoint-" + e),
      (this.options = t.Adapter.extend({}, t.defaults, o)),
      (this.element = this.options.element),
      (this.adapter = new t.Adapter(this.element)),
      (this.callback = o.handler),
      (this.axis = this.options.horizontal ? "horizontal" : "vertical"),
      (this.enabled = this.options.enabled),
      (this.triggerPoint = null),
      (this.group = t.Group.findOrCreate({ name: this.options.group, axis: this.axis })),
      (this.context = t.Context.findOrCreateByElement(this.options.context)),
      t.offsetAliases[this.options.offset] &&
        (this.options.offset = t.offsetAliases[this.options.offset]),
      this.group.add(this),
      this.context.add(this),
      (i[this.key] = this),
      (e += 1);
  }
  var e = 0,
    i = {};
  (t.prototype.queueTrigger = function (t) {
    this.group.queueTrigger(this, t);
  }),
    (t.prototype.trigger = function (t) {
      this.enabled && this.callback && this.callback.apply(this, t);
    }),
    (t.prototype.destroy = function () {
      this.context.remove(this), this.group.remove(this), delete i[this.key];
    }),
    (t.prototype.disable = function () {
      return (this.enabled = !1), this;
    }),
    (t.prototype.enable = function () {
      return this.context.refresh(), (this.enabled = !0), this;
    }),
    (t.prototype.next = function () {
      return this.group.next(this);
    }),
    (t.prototype.previous = function () {
      return this.group.previous(this);
    }),
    (t.invokeAll = function (t) {
      var e = [];
      for (var o in i) e.push(i[o]);
      for (var n = 0, r = e.length; r > n; n++) e[n][t]();
    }),
    (t.destroyAll = function () {
      t.invokeAll("destroy");
    }),
    (t.disableAll = function () {
      t.invokeAll("disable");
    }),
    (t.enableAll = function () {
      t.invokeAll("enable");
    }),
    (t.refreshAll = function () {
      t.Context.refreshAll();
    }),
    (t.viewportHeight = function () {
      return window.innerHeight || document.documentElement.clientHeight;
    }),
    (t.viewportWidth = function () {
      return document.documentElement.clientWidth;
    }),
    (t.adapters = []),
    (t.defaults = {
      context: window,
      continuous: !0,
      enabled: !0,
      group: "default",
      horizontal: !1,
      offset: 0,
    }),
    (t.offsetAliases = {
      "bottom-in-view": function () {
        return this.context.innerHeight() - this.adapter.outerHeight();
      },
      "right-in-view": function () {
        return this.context.innerWidth() - this.adapter.outerWidth();
      },
    }),
    (window.Waypoint = t);
})(),
  (function () {
    "use strict";
    function t(t) {
      window.setTimeout(t, 1e3 / 60);
    }
    function e(t) {
      (this.element = t),
        (this.Adapter = n.Adapter),
        (this.adapter = new this.Adapter(t)),
        (this.key = "waypoint-context-" + i),
        (this.didScroll = !1),
        (this.didResize = !1),
        (this.oldScroll = { x: this.adapter.scrollLeft(), y: this.adapter.scrollTop() }),
        (this.waypoints = { vertical: {}, horizontal: {} }),
        (t.waypointContextKey = this.key),
        (o[t.waypointContextKey] = this),
        (i += 1),
        this.createThrottledScrollHandler(),
        this.createThrottledResizeHandler();
    }
    var i = 0,
      o = {},
      n = window.Waypoint,
      r = window.onload;
    (e.prototype.add = function (t) {
      var e = t.options.horizontal ? "horizontal" : "vertical";
      (this.waypoints[e][t.key] = t), this.refresh();
    }),
      (e.prototype.checkEmpty = function () {
        var t = this.Adapter.isEmptyObject(this.waypoints.horizontal),
          e = this.Adapter.isEmptyObject(this.waypoints.vertical);
        t && e && (this.adapter.off(".waypoints"), delete o[this.key]);
      }),
      (e.prototype.createThrottledResizeHandler = function () {
        function t() {
          e.handleResize(), (e.didResize = !1);
        }
        var e = this;
        this.adapter.on("resize.waypoints", function () {
          e.didResize || ((e.didResize = !0), n.requestAnimationFrame(t));
        });
      }),
      (e.prototype.createThrottledScrollHandler = function () {
        function t() {
          e.handleScroll(), (e.didScroll = !1);
        }
        var e = this;
        this.adapter.on("scroll.waypoints", function () {
          (!e.didScroll || n.isTouch) && ((e.didScroll = !0), n.requestAnimationFrame(t));
        });
      }),
      (e.prototype.handleResize = function () {
        n.Context.refreshAll();
      }),
      (e.prototype.handleScroll = function () {
        var t = {},
          e = {
            horizontal: {
              newScroll: this.adapter.scrollLeft(),
              oldScroll: this.oldScroll.x,
              forward: "right",
              backward: "left",
            },
            vertical: {
              newScroll: this.adapter.scrollTop(),
              oldScroll: this.oldScroll.y,
              forward: "down",
              backward: "up",
            },
          };
        for (var i in e) {
          var o = e[i],
            n = o.newScroll > o.oldScroll,
            r = n ? o.forward : o.backward;
          for (var s in this.waypoints[i]) {
            var a = this.waypoints[i][s],
              l = o.oldScroll < a.triggerPoint,
              h = o.newScroll >= a.triggerPoint,
              p = l && h,
              u = !l && !h;
            (p || u) && (a.queueTrigger(r), (t[a.group.id] = a.group));
          }
        }
        for (var c in t) t[c].flushTriggers();
        this.oldScroll = { x: e.horizontal.newScroll, y: e.vertical.newScroll };
      }),
      (e.prototype.innerHeight = function () {
        return this.element == this.element.window
          ? n.viewportHeight()
          : this.adapter.innerHeight();
      }),
      (e.prototype.remove = function (t) {
        delete this.waypoints[t.axis][t.key], this.checkEmpty();
      }),
      (e.prototype.innerWidth = function () {
        return this.element == this.element.window ? n.viewportWidth() : this.adapter.innerWidth();
      }),
      (e.prototype.destroy = function () {
        var t = [];
        for (var e in this.waypoints) for (var i in this.waypoints[e]) t.push(this.waypoints[e][i]);
        for (var o = 0, n = t.length; n > o; o++) t[o].destroy();
      }),
      (e.prototype.refresh = function () {
        var t,
          e = this.element == this.element.window,
          i = e ? void 0 : this.adapter.offset(),
          o = {};
        this.handleScroll(),
          (t = {
            horizontal: {
              contextOffset: e ? 0 : i.left,
              contextScroll: e ? 0 : this.oldScroll.x,
              contextDimension: this.innerWidth(),
              oldScroll: this.oldScroll.x,
              forward: "right",
              backward: "left",
              offsetProp: "left",
            },
            vertical: {
              contextOffset: e ? 0 : i.top,
              contextScroll: e ? 0 : this.oldScroll.y,
              contextDimension: this.innerHeight(),
              oldScroll: this.oldScroll.y,
              forward: "down",
              backward: "up",
              offsetProp: "top",
            },
          });
        for (var r in t) {
          var s = t[r];
          for (var a in this.waypoints[r]) {
            var l,
              h,
              p,
              u,
              c,
              d = this.waypoints[r][a],
              f = d.options.offset,
              w = d.triggerPoint,
              y = 0,
              g = null == w;
            d.element !== d.element.window && (y = d.adapter.offset()[s.offsetProp]),
              "function" == typeof f
                ? (f = f.apply(d))
                : "string" == typeof f &&
                  ((f = parseFloat(f)),
                  d.options.offset.indexOf("%") > -1 &&
                    (f = Math.ceil((s.contextDimension * f) / 100))),
              (l = s.contextScroll - s.contextOffset),
              (d.triggerPoint = y + l - f),
              (h = w < s.oldScroll),
              (p = d.triggerPoint >= s.oldScroll),
              (u = h && p),
              (c = !h && !p),
              !g && u
                ? (d.queueTrigger(s.backward), (o[d.group.id] = d.group))
                : !g && c
                ? (d.queueTrigger(s.forward), (o[d.group.id] = d.group))
                : g &&
                  s.oldScroll >= d.triggerPoint &&
                  (d.queueTrigger(s.forward), (o[d.group.id] = d.group));
          }
        }
        return (
          n.requestAnimationFrame(function () {
            for (var t in o) o[t].flushTriggers();
          }),
          this
        );
      }),
      (e.findOrCreateByElement = function (t) {
        return e.findByElement(t) || new e(t);
      }),
      (e.refreshAll = function () {
        for (var t in o) o[t].refresh();
      }),
      (e.findByElement = function (t) {
        return o[t.waypointContextKey];
      }),
      (window.onload = function () {
        r && r(), e.refreshAll();
      }),
      (n.requestAnimationFrame = function (e) {
        var i =
          window.requestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          t;
        i.call(window, e);
      }),
      (n.Context = e);
  })(),
  (function () {
    "use strict";
    function t(t, e) {
      return t.triggerPoint - e.triggerPoint;
    }
    function e(t, e) {
      return e.triggerPoint - t.triggerPoint;
    }
    function i(t) {
      (this.name = t.name),
        (this.axis = t.axis),
        (this.id = this.name + "-" + this.axis),
        (this.waypoints = []),
        this.clearTriggerQueues(),
        (o[this.axis][this.name] = this);
    }
    var o = { vertical: {}, horizontal: {} },
      n = window.Waypoint;
    (i.prototype.add = function (t) {
      this.waypoints.push(t);
    }),
      (i.prototype.clearTriggerQueues = function () {
        this.triggerQueues = { up: [], down: [], left: [], right: [] };
      }),
      (i.prototype.flushTriggers = function () {
        for (var i in this.triggerQueues) {
          var o = this.triggerQueues[i],
            n = "up" === i || "left" === i;
          o.sort(n ? e : t);
          for (var r = 0, s = o.length; s > r; r += 1) {
            var a = o[r];
            (a.options.continuous || r === o.length - 1) && a.trigger([i]);
          }
        }
        this.clearTriggerQueues();
      }),
      (i.prototype.next = function (e) {
        this.waypoints.sort(t);
        var i = n.Adapter.inArray(e, this.waypoints),
          o = i === this.waypoints.length - 1;
        return o ? null : this.waypoints[i + 1];
      }),
      (i.prototype.previous = function (e) {
        this.waypoints.sort(t);
        var i = n.Adapter.inArray(e, this.waypoints);
        return i ? this.waypoints[i - 1] : null;
      }),
      (i.prototype.queueTrigger = function (t, e) {
        this.triggerQueues[e].push(t);
      }),
      (i.prototype.remove = function (t) {
        var e = n.Adapter.inArray(t, this.waypoints);
        e > -1 && this.waypoints.splice(e, 1);
      }),
      (i.prototype.first = function () {
        return this.waypoints[0];
      }),
      (i.prototype.last = function () {
        return this.waypoints[this.waypoints.length - 1];
      }),
      (i.findOrCreate = function (t) {
        return o[t.axis][t.name] || new i(t);
      }),
      (n.Group = i);
  })(),
  (function () {
    "use strict";
    function t(t) {
      this.$element = e(t);
    }
    var e = window.jQuery,
      i = window.Waypoint;
    e.each(
      [
        "innerHeight",
        "innerWidth",
        "off",
        "offset",
        "on",
        "outerHeight",
        "outerWidth",
        "scrollLeft",
        "scrollTop",
      ],
      function (e, i) {
        t.prototype[i] = function () {
          var t = Array.prototype.slice.call(arguments);
          return this.$element[i].apply(this.$element, t);
        };
      }
    ),
      e.each(["extend", "inArray", "isEmptyObject"], function (i, o) {
        t[o] = e[o];
      }),
      i.adapters.push({ name: "jquery", Adapter: t }),
      (i.Adapter = t);
  })(),
  (function () {
    "use strict";
    function t(t) {
      return function () {
        var i = [],
          o = arguments[0];
        return (
          t.isFunction(arguments[0]) &&
            ((o = t.extend({}, arguments[1])), (o.handler = arguments[0])),
          this.each(function () {
            var n = t.extend({}, o, { element: this });
            "string" == typeof n.context && (n.context = t(this).closest(n.context)[0]),
              i.push(new e(n));
          }),
          i
        );
      };
    }
    var e = window.Waypoint;
    window.jQuery && (window.jQuery.fn.waypoint = t(window.jQuery)),
      window.Zepto && (window.Zepto.fn.waypoint = t(window.Zepto));
  })();

/*!
Waypoints Infinite Scroll Shortcut - 4.0.0
Copyright © 2011-2015 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!(function () {
  "use strict";
  function t(n) {
    (this.options = i.extend({}, t.defaults, n)),
      (this.container = this.options.element),
      "auto" !== this.options.container && (this.container = this.options.container),
      (this.$container = i(this.container)),
      (this.$more = i(this.options.more)),
      this.$more.length && (this.setupHandler(), (this.waypoint = new o(this.options)));
  }
  var i = window.jQuery,
    o = window.Waypoint;
  (t.prototype.setupHandler = function () {
    this.options.handler = i.proxy(function () {
      this.options.onBeforePageLoad(),
        this.destroy(),
        this.$container.addClass(this.options.loadingClass),
        i.get(
          i(this.options.more).attr("href"),
          i.proxy(function (t) {
            var n = i(i.parseHTML(t)),
              e = n.find(this.options.more),
              s = n.find(this.options.items);
            s.length || (s = n.filter(this.options.items)),
              this.$container.append(s),
              this.$container.removeClass(this.options.loadingClass),
              e.length || (e = n.filter(this.options.more)),
              e.length
                ? (this.$more.replaceWith(e),
                  (this.$more = e),
                  (this.waypoint = new o(this.options)))
                : this.$more.remove(),
              this.options.onAfterPageLoad(s);
          }, this)
        );
    }, this);
  }),
    (t.prototype.destroy = function () {
      this.waypoint && this.waypoint.destroy();
    }),
    (t.defaults = {
      container: "auto",
      items: ".infinite-item",
      more: ".infinite-more-link",
      offset: "bottom-in-view",
      loadingClass: "infinite-loading",
      onBeforePageLoad: i.noop,
      onAfterPageLoad: i.noop,
    }),
    (o.Infinite = t);
})();

/*!
 * instafeed.js v1.4.1 - A simple Instagram javascript plugin
 * http://instafeedjs.com
 * repo: https://github.com/stevenschobert/instafeed.js
 * License: MIT (https://github.com/stevenschobert/instafeed.js/blob/master/LICENSE)
 */

(function () {
  var a;
  (a = (function () {
    function a(a, b) {
      var c, d;
      if (
        ((this.options = {
          target: "instafeed",
          get: "popular",
          resolution: "thumbnail",
          sortBy: "none",
          links: !0,
          mock: !1,
          useHttp: !1,
        }),
        "object" == typeof a)
      )
        for (c in a) (d = a[c]), (this.options[c] = d);
      (this.context = null != b ? b : this), (this.unique = this._genKey());
    }
    return (
      (a.prototype.hasNext = function () {
        return "string" == typeof this.context.nextUrl && this.context.nextUrl.length > 0;
      }),
      (a.prototype.next = function () {
        return !!this.hasNext() && this.run(this.context.nextUrl);
      }),
      (a.prototype.run = function (b) {
        var c, d, e;
        if ("string" != typeof this.options.clientId && "string" != typeof this.options.accessToken)
          throw new Error("Missing clientId or accessToken.");
        if ("string" != typeof this.options.accessToken && "string" != typeof this.options.clientId)
          throw new Error("Missing clientId or accessToken.");
        return (
          null != this.options.before &&
            "function" == typeof this.options.before &&
            this.options.before.call(this),
          "undefined" != typeof document &&
            null !== document &&
            ((e = document.createElement("script")),
            (e.id = "instafeed-fetcher"),
            (e.src = b || this._buildUrl()),
            (c = document.getElementsByTagName("head")),
            c[0].appendChild(e),
            (d = "instafeedCache" + this.unique),
            (window[d] = new a(this.options, this)),
            (window[d].unique = this.unique)),
          !0
        );
      }),
      (a.prototype.parse = function (a) {
        var b,
          c,
          d,
          e,
          f,
          g,
          h,
          i,
          j,
          k,
          l,
          m,
          n,
          o,
          p,
          q,
          r,
          s,
          t,
          u,
          v,
          w,
          x,
          y,
          z,
          A,
          B,
          C,
          D,
          E,
          F,
          G,
          H;
        if ("object" != typeof a) {
          if (null != this.options.error && "function" == typeof this.options.error)
            return this.options.error.call(this, "Invalid JSON data"), !1;
          throw new Error("Invalid JSON response");
        }
        if (200 !== a.meta.code) {
          if (null != this.options.error && "function" == typeof this.options.error)
            return this.options.error.call(this, a.meta.error_message), !1;
          throw new Error("Error from Instagram: " + a.meta.error_message);
        }
        if (0 === a.data.length) {
          if (null != this.options.error && "function" == typeof this.options.error)
            return this.options.error.call(this, "No images were returned from Instagram"), !1;
          throw new Error("No images were returned from Instagram");
        }
        if (
          (null != this.options.success &&
            "function" == typeof this.options.success &&
            this.options.success.call(this, a),
          (this.context.nextUrl = ""),
          null != a.pagination && (this.context.nextUrl = a.pagination.next_url),
          "none" !== this.options.sortBy)
        )
          switch (
            ((F =
              "random" === this.options.sortBy ? ["", "random"] : this.options.sortBy.split("-")),
            (E = "least" === F[0]),
            F[1])
          ) {
            case "random":
              a.data.sort(function () {
                return 0.5 - Math.random();
              });
              break;
            case "recent":
              a.data = this._sortBy(a.data, "created_time", E);
              break;
            case "liked":
              a.data = this._sortBy(a.data, "likes.count", E);
              break;
            case "commented":
              a.data = this._sortBy(a.data, "comments.count", E);
              break;
            default:
              throw new Error("Invalid option for sortBy: '" + this.options.sortBy + "'.");
          }
        if ("undefined" != typeof document && null !== document && this.options.mock === !1) {
          if (
            ((q = a.data),
            (D = parseInt(this.options.limit, 10)),
            null != this.options.limit && q.length > D && (q = q.slice(0, D)),
            (h = document.createDocumentFragment()),
            null != this.options.filter &&
              "function" == typeof this.options.filter &&
              (q = this._filter(q, this.options.filter)),
            null != this.options.template && "string" == typeof this.options.template)
          ) {
            for (
              j = "", o = "", u = "", H = document.createElement("div"), l = 0, z = q.length;
              l < z;
              l++
            ) {
              if (((m = q[l]), (n = m.images[this.options.resolution]), "object" != typeof n))
                throw (
                  ((g = "No image found for resolution: " + this.options.resolution + "."),
                  new Error(g))
                );
              (v = n.width),
                (s = n.height),
                (t = "square"),
                v > s && (t = "landscape"),
                v < s && (t = "portrait"),
                (p = n.url),
                (k = window.location.protocol.indexOf("http") >= 0),
                k && !this.options.useHttp && (p = p.replace(/https?:\/\//, "//")),
                (o = this._makeTemplate(this.options.template, {
                  model: m,
                  id: m.id,
                  link: m.link,
                  type: m.type,
                  image: p,
                  width: v,
                  height: s,
                  orientation: t,
                  caption: this._getObjectProperty(m, "caption.text"),
                  likes: m.likes.count,
                  comments: m.comments.count,
                  location: this._getObjectProperty(m, "location.name"),
                })),
                (j += o);
            }
            for (H.innerHTML = j, e = [], d = 0, c = H.childNodes.length; d < c; )
              e.push(H.childNodes[d]), (d += 1);
            for (x = 0, A = e.length; x < A; x++) (C = e[x]), h.appendChild(C);
          } else
            for (y = 0, B = q.length; y < B; y++) {
              if (
                ((m = q[y]),
                (r = document.createElement("img")),
                (n = m.images[this.options.resolution]),
                "object" != typeof n)
              )
                throw (
                  ((g = "No image found for resolution: " + this.options.resolution + "."),
                  new Error(g))
                );
              (p = n.url),
                (k = window.location.protocol.indexOf("http") >= 0),
                k && !this.options.useHttp && (p = p.replace(/https?:\/\//, "//")),
                (r.src = p),
                this.options.links === !0
                  ? ((b = document.createElement("a")),
                    (b.href = m.link),
                    b.appendChild(r),
                    h.appendChild(b))
                  : h.appendChild(r);
            }
          if (
            ((G = this.options.target),
            "string" == typeof G && (G = document.getElementById(G)),
            null == G)
          )
            throw ((g = 'No element with id="' + this.options.target + '" on page.'), new Error(g));
          G.appendChild(h),
            (i = document.getElementsByTagName("head")[0]),
            i.removeChild(document.getElementById("instafeed-fetcher")),
            (w = "instafeedCache" + this.unique),
            (window[w] = void 0);
          try {
            delete window[w];
          } catch (a) {
            f = a;
          }
        }
        return (
          null != this.options.after &&
            "function" == typeof this.options.after &&
            this.options.after.call(this),
          !0
        );
      }),
      (a.prototype._buildUrl = function () {
        var a, b, c;
        switch (((a = "https://api.instagram.com/v1"), this.options.get)) {
          case "popular":
            b = "media/popular";
            break;
          case "tagged":
            if (!this.options.tagName)
              throw new Error("No tag name specified. Use the 'tagName' option.");
            b = "tags/" + this.options.tagName + "/media/recent";
            break;
          case "location":
            if (!this.options.locationId)
              throw new Error("No location specified. Use the 'locationId' option.");
            b = "locations/" + this.options.locationId + "/media/recent";
            break;
          case "user":
            if (!this.options.userId)
              throw new Error("No user specified. Use the 'userId' option.");
            b = "users/" + this.options.userId + "/media/recent";
            break;
          default:
            throw new Error("Invalid option for get: '" + this.options.get + "'.");
        }
        return (
          (c = a + "/" + b),
          (c +=
            null != this.options.accessToken
              ? "?access_token=" + this.options.accessToken
              : "?client_id=" + this.options.clientId),
          null != this.options.limit && (c += "&count=" + this.options.limit),
          (c += "&callback=instafeedCache" + this.unique + ".parse")
        );
      }),
      (a.prototype._genKey = function () {
        var a;
        return (
          (a = function () {
            return ((65536 * (1 + Math.random())) | 0).toString(16).substring(1);
          }),
          "" + a() + a() + a() + a()
        );
      }),
      (a.prototype._makeTemplate = function (a, b) {
        var c, d, e, f, g;
        for (d = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/, c = a; d.test(c); )
          (f = c.match(d)[1]),
            (g = null != (e = this._getObjectProperty(b, f)) ? e : ""),
            (c = c.replace(d, function () {
              return "" + g;
            }));
        return c;
      }),
      (a.prototype._getObjectProperty = function (a, b) {
        var c, d;
        for (b = b.replace(/\[(\w+)\]/g, ".$1"), d = b.split("."); d.length; ) {
          if (((c = d.shift()), !(null != a && c in a))) return null;
          a = a[c];
        }
        return a;
      }),
      (a.prototype._sortBy = function (a, b, c) {
        var d;
        return (
          (d = function (a, d) {
            var e, f;
            return (
              (e = this._getObjectProperty(a, b)),
              (f = this._getObjectProperty(d, b)),
              c ? (e > f ? 1 : -1) : e < f ? 1 : -1
            );
          }),
          a.sort(d.bind(this)),
          a
        );
      }),
      (a.prototype._filter = function (a, b) {
        var c, d, e, f, g;
        for (
          c = [],
            d = function (a) {
              if (b(a)) return c.push(a);
            },
            e = 0,
            g = a.length;
          e < g;
          e++
        )
          (f = a[e]), d(f);
        return c;
      }),
      a
    );
  })()),
    (function (a, b) {
      return "function" == typeof define && define.amd
        ? define([], b)
        : "object" == typeof module && module.exports
        ? (module.exports = b())
        : (a.Instafeed = b());
    })(this, function () {
      return a;
    });
}).call(this);

window.theme = window.theme || {};
window.flag = true;
theme.strings = {
  addressError: "Error looking up that address",
  addressNoResults: "No results for that address",
  addressQueryLimit:
    'You have exceeded the Google API usage limit. Consider upgrading to a \u003ca href="https://developers.google.com/maps/premium/usage-limits"\u003ePremium Plan\u003c/a\u003e.',
  authError: "There was a problem authenticating your Google Maps account.",
};
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = _.filter(this.instances, function (instance) {
      var isEventInstance = instance.id === evt.originalEvent.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;
    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.FeaturedProductsSection = {};

theme.FeaturedProductsSection = (function () {
  function FeaturedProductsSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var starsValue = (this.reviewsStars = $container.attr("data-reviews-stars"));

    initOwlCarousel(sectionId);
    $container.find('form[action*="/cart/add"]').submit(function (e) {});
    $(".main_box").matchHeight();
  }

  return FeaturedProductsSection;
})();

theme.FeaturedProductsSection.prototype = _.assignIn({}, theme.FeaturedProductsSection.prototype, {
  onSelect: function () {
    var sectionId = this.sectionId;
    var starsValue = this.reviewsStars;
    initOwlCarousel(sectionId);
    // Close pop-up if open //
    var magnificPopup = $.magnificPopup.instance;
    if (typeof magnificPopup !== "undefined") {
      magnificPopup.close();
    }
    // Build quick view //
    enabledQuickView();
    setTimeout(function () {
      $(".quick-view-panel").each(function () {
        var selectID = $(this).data("id");
        var select = "product-select-" + selectID;
        var product = $(this).data("name");
        var qvpData = $(this).find(".data-qvp").text();
        var qvpJson = JSON.parse(qvpData);

        $(".quick-view-selector-" + qvpJson.id).on("change", function () {
          var $form = $(this).closest("form"),
            productVariantObj = qvpJson.variants;

          var option1 = $form.find("#SingleOptionSelector-0").val() || null,
            option2 = $form.find("#SingleOptionSelector-1").val() || null,
            option3 = $form.find("#SingleOptionSelector-2").val() || null,
            flag = true;
          for (var i = 0, length = productVariantObj.length; i < length; i++) {
            var productVar = productVariantObj[i];
            if (productVar.option1 != null) {
              productVar.option1 = productVar.option1.replace(/\s{2,}/g, " ");
            }
            if (productVar.option2 != null) {
              productVar.option2 = productVar.option2.replace(/\s{2,}/g, " ");
            }
            if (productVar.option3 != null) {
              productVar.option3 = productVar.option3.replace(/\s{2,}/g, " ");
            }

            if (
              option1 == productVar.option1 &&
              option2 == productVar.option2 &&
              option3 == productVar.option3
            ) {
              flag = false;
              $("#product-select-" + qvpJson.id).val(productVar.id);
              app.selectCallback(productVar, qvpJson.id);
              break;
            }
          }
          if (flag) {
            app.selectCallback(null, qvpJson.id);
          }
        });

        for (var i = 0, length = qvpJson.variants.length; i < length; i++) {
          var productVariants = qvpJson.variants[i];

          if (productVariants.available) {
            for (var j = 0, optlength = productVariants.options.length; j < optlength; j++) {
              var variantOption = productVariants.options[j];
              variantOption = handleizeStr(variantOption);
              $(
                ".swatch-product-id-" +
                  qvpJson.id +
                  ' .swatch[data-option-index="' +
                  j +
                  '"] .' +
                  variantOption +
                  ""
              )
                .removeClass("soldout")
                .addClass("available")
                .find(":radio")
                .removeAttr("disabled");
            }
          }
        }
        // BEGIN SWATCHES
        var indexArray = [];
        var productVariantOptions = qvpJson.variants;
        $("[data-id=" + qvpJson.id + "] .single-option-selector option:selected").each(function () {
          indexArray.push($(this).index());
        });
        var form = jQuery("#product-select-" + qvpJson.id).closest("form");
        var variantIndex = jQuery("#product-select-" + qvpJson.id + " option:selected").index();
        if (variantIndex >= 0) {
          var variant = productVariantOptions[variantIndex];
          for (var i = 0, length = variant.options.length; i < length; i++) {
            var num = indexArray[i];
            var radioButtonDiv = form.find(
              '.swatch[data-option-index="' + i + '"] div.swatch-element'
            )[num];
            var radioButton = $(radioButtonDiv).find(":radio");
            if (radioButton.size()) {
              radioButton.get(0).checked = true;
            }
          }
        }

        // END SWATCHES
      });
    }, 1000);

    if (starsValue == "true") {
      SPR.$(document).ready(function () {
        return (
          SPR.registerCallbacks(),
          SPR.initRatingHandler(),
          SPR.initDomEls(),
          SPR.loadProducts(),
          SPR.loadBadges()
        );
      });
    }
  },
});

theme.InstagramFeedSection = {};

theme.InstagramFeedSection = (function () {
  function InstagramFeedSection(container) {
    var $container = (this.$container = $(container));
    var id = $container.attr("data-section-id");
    var instafeedEl = (this.instagram = $("#Instafeed-" + id));
    var instafeedId = (this.instagram = "Instafeed-" + id);

    var userFeed = new Instafeed({
      get: "user",
      userId: "self",
      target: instafeedId,
      accessToken: instafeedEl.attr("data-access-token"),
      sortBy: "most-recent",
      resolution: "standard_resolution",
      limit: instafeedEl.attr("data-count"),
      template:
        '<a href="{{link}}" target="_blank" style="background-image: url({{image}});" class="' +
        instafeedEl.attr("data-grid") +
        '"><i class="fa fa-instagram" aria-hidden="true"></i></a>',
    });
    if (!_.isUndefined(userFeed.options.accessToken)) {
      userFeed.run();
    }
  }

  return InstagramFeedSection;
})();

theme.InstagramFeedSection.prototype = _.assignIn({}, theme.InstagramFeedSection.prototype, {
  onSelect: function () {
    $(".animated").addClass("animation-done");
  },
});

theme.FeaturedCollectionsSection = {};

theme.FeaturedCollectionsSection = (function () {
  function FeaturedCollectionsSection(container) {
    var $container = (this.$container = $(container));
    var id = $container.attr("data-section-id");

    $(".main_box").matchHeight();
  }

  return FeaturedCollectionsSection;
})();

theme.FeaturedCollectionsSection.prototype = _.assignIn(
  {},
  theme.FeaturedCollectionsSection.prototype,
  {
    onSelect: function () {},
  }
);

theme.HeaderSection = {};

theme.HeaderSection = (function () {
  function HeaderSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));

    jQuery(document).ready(function () {
      /// Open modal by cart icon in header ///
      $(".cart-popup[data-href]").on("click", function () {
        var url = "/cart";
        $(location).attr("href", url);
      });

      $("[data-href='/cart']").on("click", function () {
        if (!document.querySelector(".STO-T35-Homepage")) {
          var url = "/cart";
          $(location).attr("href", url);
        }
      });

      /////////////////
      //  Mega Menu  //
      /////////////////
      $(function () {
        if (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          if (jQuery(window).width() >= 320 && jQuery(window).width() <= 1024) {
            $(".wsmenu-list > li > a.twin").click(function (e) {
              e.preventDefault();
              if (
                !$(this).hasClass("ws-activearrow") &&
                !$(this).prev(".wsmenu-click").hasClass("ws-activearrow")
              ) {
                $(this)
                  .toggleClass("ws-activearrow")
                  .parent()
                  .siblings()
                  .children()
                  .removeClass("ws-activearrow");
                $(this).prev(".wsmenu-click").toggleClass("ws-activearrow");
                $(".wsmenu-submenu, .megamenu")
                  .not($(this).siblings(".wsmenu-submenu, .megamenu"))
                  .slideUp("slow");

                if (jQuery(window).width() <= 768) {
                  $(this).siblings(".wsmenu-submenu").slideToggle("slow");
                  $(this).siblings(".megamenu").slideToggle("slow");
                }

                $(".wsmenu-list > li > a.twin").each(function () {
                  $(this).attr("aria-expanded", false);
                });
                $(this).attr("aria-expanded", true);
              } else {
                window.location = $(this).attr("href");
                return false;
              }
            });
            $(".wsmenu-sub-list > li > h5").click(function (e) {
              if (jQuery(window).width() <= 768) {
                e.preventDefault();
                if (!$(this).hasClass("menu-clicked")) {
                  $(this).children(".wsmenu-arrow").toggleClass("wsmenu-rotate");
                  $(this).siblings(".wsmenu-submenu-sub").slideToggle("slow");
                  $(this).siblings(".wsmenu-submenu-sub-sub").slideToggle("slow");
                  $(this).siblings(".wsmenu-sub-list ul").slideToggle("slow");
                  $(this).prev(".wsmenu-click02").children().toggleClass("wsmenu-rotate");
                  $(".wsmenu-sub-list > li > h5 > a").each(function () {
                    $(this).removeClass("menu-clicked");
                  });
                  $(".wsmenu-sub-list > li > h5 > a[aria-expanded='true']").each(function () {
                    $(this).attr("aria-expanded", false);
                  });

                  $(this).addClass("menu-clicked");
                  $(this).find("a").attr("aria-expanded", true);
                } else {
                  window.location = $(this).children("a").attr("href");
                  return false;
                }
              }
            });

            $(".wsmenu-list > li.mega_menu_container > .megamenu > ul > li > ul > li > a").click(
              function (e) {
                if ($(this).next().hasClass("level") && jQuery(window).width() <= 768) {
                  if (!$(this).hasClass("menu-clicked")) {
                    e.preventDefault();
                    $(this).children(".wsmenu-arrow").toggleClass("wsmenu-rotate");
                    $(this).siblings(".wsmenu-sub-list ul").slideToggle("slow");
                    $(this).prev(".wsmenu-click02").children().toggleClass("wsmenu-rotate");
                    $(".wsmenu-list > li > .megamenu > ul > li > ul > li > a").each(function () {
                      $(this).removeClass("menu-clicked");
                    });
                    $(
                      ".wsmenu-list > li > .megamenu > ul > li > ul > li > a[aria-expanded='true']"
                    ).each(function () {
                      $(this).attr("aria-expanded", false);
                    });

                    $(this).addClass("menu-clicked");
                    $(this).attr("aria-expanded", true);
                  } else {
                    window.location = $(this).children("a").attr("href");
                    return false;
                  }
                }
              }
            );

            $(".has-submenu > a").click(function (e) {
              e.preventDefault();
              if (!$(this).hasClass("menu-clicked")) {
                if (jQuery(window).width() <= 768) {
                  $(this).next(".wsmenu-submenu").slideToggle("slow");
                }

                $(this).prev(".wsmenu-click").toggleClass("ws-activearrow");
                $(".has-submenu > a").each(function () {
                  $(this).removeClass("menu-clicked");
                });
                $(".ws-activearrow").each(function () {
                  $(this).removeClass("ws-activearrow");
                });
                $(this).closest("li").siblings().removeClass("hover");

                $(".has-submenu > a[aria-expanded='true']").each(function () {
                  $(this).attr("aria-expanded", false);
                });
                $(this).addClass("menu-clicked");
                $(this).attr("aria-expanded", true);
              } else {
                window.location = $(this).attr("href");
                return false;
              }
            });

            $(".has-submenu-sub > a").click(function (e) {
              e.preventDefault();
              if (!$(this).hasClass("menu-clicked")) {
                if (jQuery(window).width() <= 768) {
                  $(this).next(".wsmenu-submenu-sub").slideToggle("slow");
                }
                $(this).prev(".wsmenu-click02").children("i").toggleClass("wsmenu-rotate");
                $(".has-submenu-sub > a").each(function () {
                  $(this).removeClass("menu-clicked");
                });
                $(".has-submenu-sub > a[aria-expanded='true']").each(function () {
                  $(this).attr("aria-expanded", false);
                });
                $(this).addClass("menu-clicked");
                $(this).attr("aria-expanded", true);
              } else {
                window.location = $(this).attr("href");
                return false;
              }
            });

            $(".has-submenu-sub-sub > a").click(function (e) {
              if (!$(this).hasClass("menu-clicked")) {
                e.preventDefault();
                if (jQuery(window).width() <= 768) {
                  $(this).next(".wsmenu-submenu-sub-sub").slideToggle("slow");
                }
                $(this).prev(".wsmenu-click02").children("i").toggleClass("wsmenu-rotate");
                $(".has-submenu-sub-sub > a").each(function () {
                  $(this).removeClass("menu-clicked");
                });
                $(".has-submenu-sub-sub > a[aria-expanded='true']").each(function () {
                  $(this).attr("aria-expanded", false);
                });
                $(this).addClass("menu-clicked");
                $(this).attr("aria-expanded", true);
              } else {
                window.location = $(this).attr("href");
                return false;
              }
            });

            $(window).on("touchend", function () {
              $("li").removeClass("hover");
              $("a[aria-expanded='true']").each(function () {
                $(this).attr("aria-expanded", false);
              });
              $(".ws-activearrow").each(function () {
                $(this).removeClass("ws-activearrow");
              });
              $(".menu-clicked").each(function () {
                $(this).removeClass("menu-clicked");
              });
            });

            $(".mega_menu > li.mega_menu_container").on("touchend", function (event) {
              event.stopPropagation();
              $(this).siblings().removeClass("hover");
              if (jQuery(window).width() >= 768) {
                $(".menu-clicked").each(function () {
                  $(this).removeClass("menu-clicked");
                });
              }

              $("a[aria-expanded='true']").each(function () {
                $(this).attr("aria-expanded", false);
              });
              $(this).addClass("hover");
              $(this).find(".twin").attr("aria-expanded", true);
            });

            $(".wsmenu-list > li.mega_menu_simple_container").on("touchend", function (event) {
              event.stopPropagation();
              $(this).siblings().removeClass("hover");
              $("a[aria-expanded='true']").each(function () {
                $(this).attr("aria-expanded", false);
              });
              $(this).addClass("hover");
              $(this).children("a").attr("aria-expanded", true);
            });
            $(".wsmenu-list > li.mega_menu_simple_container > ul > li").on(
              "touchend",
              function (event) {
                event.stopPropagation();
                $(this).siblings().removeClass("hover");
                $(this).addClass("hover");
                $(
                  ".wsmenu-list > li.mega_menu_simple_container > ul > li a[aria-expanded='true']"
                ).each(function () {
                  $(this).attr("aria-expanded", false);
                });
                $(this).children("a").attr("aria-expanded", true);
              }
            );
            $(".wsmenu-list > li.mega_menu_simple_container > ul > li > ul > li").on(
              "touchend",
              function (event) {
                event.stopPropagation();
                $(this).siblings().removeClass("hover");
                $(this).addClass("hover");
              }
            );

            $(".multi-drop > .wsmenu-list > li").on("touchend", function (event) {
              event.stopPropagation();
              $(this).siblings().removeClass("hover");
              $("a[aria-expanded='true']").each(function () {
                $(this).attr("aria-expanded", false);
              });
              $(this).addClass("hover");
              $(this).children("a").attr("aria-expanded", true);
            });
            $(".multi-drop > .wsmenu-list > li > ul > li").on("touchend", function (event) {
              event.stopPropagation();
              $(this).siblings().removeClass("hover");
              $(this).addClass("hover");
              $(".multi-drop > .wsmenu-list > li > ul > li a[aria-expanded='true']").each(
                function () {
                  $(this).attr("aria-expanded", false);
                }
              );
              $(this).children("a").attr("aria-expanded", true);
            });
            $(".multi-drop > .wsmenu-list > li > ul > li > ul > li").on(
              "touchend",
              function (event) {
                event.stopPropagation();
                $(this).siblings().removeClass("hover");
                $(this).addClass("hover");
              }
            );
          } else {
            $(".mega_menu > li.mega_menu_container").on("touchend", function (e) {
              if ($(this).hasClass("hover")) {
                $(this).removeClass("hover");
              } else {
                if ($(this).find(".wsmenu-click").length) {
                  e.preventDefault();
                }
                $(".mega_menu > li.mega_menu_container").each(function () {
                  $(this).removeClass("hover");
                });
                $("a[aria-expanded='true']").each(function () {
                  $(this).attr("aria-expanded", false);
                });
                $(this).addClass("hover");
                $(this).find(".twin").attr("aria-expanded", true);

                $("html").on("touchend", function (event) {
                  //check up the tree of the click target to check whether user has clicked outside of menu
                  if ($(event.target).parents(".mega_menu").length == 0) {
                    $(".mega_menu > li").each(function () {
                      $(this).removeClass("hover");
                    });
                    $(".menu-clicked").each(function () {
                      $(this).removeClass("menu-clicked");
                    });
                    $("a[aria-expanded='true']").each(function () {
                      $(this).attr("aria-expanded", false);
                    });

                    //this event listener has done its job so we can unbind it.
                    $(this).unbind(event);
                  }
                });
              }
            });
            $(".wsmenu-sub-list > li").on("touchend", function (e) {
              e.stopPropagation();
            });

            $(".wsmenu-list > li.mega_menu_simple_container").on("touchend", function (e) {
              if ($(this).hasClass("hover")) {
                $(this).removeClass("hover");
                $(this).find("li").removeClass("hover");
              } else {
                if ($(this).find(".wsmenu-submenu").length) {
                  e.preventDefault();
                }
                $(".wsmenu-list li.mega_menu_simple_container").each(function () {
                  $(this).removeClass("hover");
                });
                $("a[aria-expanded='true']").each(function () {
                  $(this).attr("aria-expanded", false);
                });
                $(this).addClass("hover");
                $(this).children("a").attr("aria-expanded", true);

                $("html").on("touchend", function (event) {
                  //check up the tree of the click target to check whether user has clicked outside of menu
                  if ($(event.target).parents(".wsmenu-list").length == 0) {
                    $(".wsmenu-list li").each(function () {
                      $(this).removeClass("hover");
                    });
                    $("a[aria-expanded='true']").each(function () {
                      $(this).attr("aria-expanded", false);
                    });

                    //this event listener has done its job so we can unbind it.
                    $(this).unbind(event);
                  }
                });
              }
            });

            $(".wsmenu-list > li.mega_menu_simple_container > ul > li").on(
              "touchend",
              function (e) {
                if ($(this).hasClass("hover")) {
                  $(this).removeClass("hover");
                  $(this).find("li").removeClass("hover");
                  e.stopPropagation();
                } else {
                  if ($(this).find(".wsmenu-submenu-sub").length) {
                    e.preventDefault();
                  }
                  e.stopPropagation();
                  $(".wsmenu-list > li.mega_menu_simple_container > ul > li").each(function () {
                    $(this).removeClass("hover");
                  });
                  $(
                    ".wsmenu-list > li.mega_menu_simple_container > ul > li a[aria-expanded='true']"
                  ).each(function () {
                    $(this).attr("aria-expanded", false);
                  });
                  $(this).addClass("hover");
                  $(this).children("a").attr("aria-expanded", true);
                }
              }
            );

            $(".wsmenu-list > li.mega_menu_simple_container > ul > li > ul > li").on(
              "touchend",
              function (e) {
                if ($(this).hasClass("hover")) {
                  $(this).removeClass("hover");
                  $(this).find("li").removeClass("hover");
                } else {
                  $(this).addClass("hover");
                }
                e.stopPropagation();
              }
            );

            $(".multi-drop > .wsmenu-list > li").on("touchend", function (e) {
              if ($(this).hasClass("hover")) {
                $(this).removeClass("hover");
                $(this).find("li").removeClass("hover");
              } else {
                if ($(this).find(".wsmenu-submenu").length) {
                  e.preventDefault();
                }
                $(".multi-drop > .wsmenu-list li").each(function () {
                  $(this).removeClass("hover");
                });
                $("a[aria-expanded='true']").each(function () {
                  $(this).attr("aria-expanded", false);
                });
                $(this).addClass("hover");
                $(this).children("a").attr("aria-expanded", true);

                $("html").on("touchend", function (event) {
                  //check up the tree of the click target to check whether user has clicked outside of menu
                  if ($(event.target).parents(".wsmenu-list").length == 0) {
                    $(".wsmenu-list li").each(function () {
                      $(this).removeClass("hover");
                    });
                    $("a[aria-expanded='true']").each(function () {
                      $(this).attr("aria-expanded", false);
                    });

                    //this event listener has done its job so we can unbind it.
                    $(this).unbind(event);
                  }
                });
              }
            });

            $(".multi-drop > .wsmenu-list > li > ul > li").on("touchend", function (e) {
              if ($(this).hasClass("hover")) {
                $(this).removeClass("hover");
                $(this).find("li").removeClass("hover");
                e.stopPropagation();
              } else {
                if ($(this).find(".wsmenu-submenu-sub").length) {
                  e.preventDefault();
                }
                e.stopPropagation();
                $(".multi-drop > .wsmenu-list > li > ul > li").each(function () {
                  $(this).removeClass("hover");
                });
                $(".multi-drop > .wsmenu-list > li > ul > li a[aria-expanded='true']").each(
                  function () {
                    $(this).attr("aria-expanded", false);
                  }
                );
                $(this).addClass("hover");
                $(this).children("a").attr("aria-expanded", true);
              }
            });

            $(".multi-drop > .wsmenu-list > li > ul > li > ul > li").on("touchend", function (e) {
              if ($(this).hasClass("hover")) {
                $(this).removeClass("hover");
                $(this).find("li").removeClass("hover");
              } else {
                $(this).addClass("hover");
              }
              e.stopPropagation();
            });
          }
        } else {
          $(".mega_menu > li.mega_menu_container").hoverIntent(
            function () {
              $(this).addClass("hover");
              $(this).find(".twin").attr("aria-expanded", true);
              $;
            },
            function () {
              $(this).removeClass("hover");
              $(this).find(".twin").attr("aria-expanded", false);
            }
          );

          $(".wsmenu-list > li.mega_menu_simple_container").hoverIntent(
            function () {
              $(this).addClass("hover");
              $(this).children("a").attr("aria-expanded", true);
            },
            function () {
              $(this).removeClass("hover");
              $(this).find("li").removeClass("hover");
              $(this).children("a").attr("aria-expanded", false);
            }
          );
          $(".wsmenu-list > li.mega_menu_simple_container > ul > li").hover(
            function () {
              $(this).addClass("hover");
              $(this).children("a").attr("aria-expanded", true);
            },
            function () {
              $(this).removeClass("hover");
              $(this).find("li").removeClass("hover");
              $(this).find("a").attr("aria-expanded", false);
            }
          );
          $(".wsmenu-list > li.mega_menu_simple_container > ul > li > ul > li").hover(
            function () {
              $(this).addClass("hover");
              $(this).children("a").attr("aria-expanded", true);
            },
            function () {
              $(this).removeClass("hover");
              $(this).find("li").removeClass("hover");
              $(this).find("a").attr("aria-expanded", false);
            }
          );

          $(".multi-drop > .wsmenu-list > li").hoverIntent(
            function () {
              $(this).addClass("hover");
              $(this).children("a").attr("aria-expanded", true);
            },
            function () {
              $(this).removeClass("hover");
              $(this).find("li").removeClass("hover");
              $(this).children("a").attr("aria-expanded", false);
            }
          );
          $(".multi-drop > .wsmenu-list > li > ul > li").hover(
            function () {
              $(this).addClass("hover");
              $(this).children("a").attr("aria-expanded", true);
            },
            function () {
              $(this).removeClass("hover");
              $(this).find("li").removeClass("hover");
              $(this).find("a").attr("aria-expanded", false);
            }
          );
          $(".multi-drop > .wsmenu-list > li > ul > li > ul > li").hover(
            function () {
              $(this).addClass("hover");
              $(this).children("a").attr("aria-expanded", true);
            },
            function () {
              $(this).removeClass("hover");
              $(this).find("li").removeClass("hover");
              $(this).find("a").attr("aria-expanded", false);
            }
          );
        }

        $("#wsnavtoggle").click(function () {
          $(".wsmenucontainer").toggleClass("wsoffcanvasopener");
        });
        $(".overlapblackbg").click(function () {
          $(".wsmenucontainer").removeClass("wsoffcanvasopener");
        });

        $(".wsmenu-list> li")
          .has(".wsmenu-submenu")
          .prepend(
            '<span class="wsmenu-click"><i class="wsmenu-arrow fa fa-caret-down"></i></span>'
          );
        $(".wsmenu-list > li")
          .has(".megamenu")
          .prepend(
            '<span class="wsmenu-click"><i class="wsmenu-arrow fa fa-caret-down"></i></span>'
          );

        $(".wsmenu-click").click(function () {
          $(this)
            .toggleClass("ws-activearrow")
            .parent()
            .siblings()
            .children()
            .removeClass("ws-activearrow");
          $(".wsmenu-submenu, .megamenu")
            .not($(this).siblings(".wsmenu-submenu, .megamenu"))
            .slideUp("slow");
          $(this).siblings(".wsmenu-submenu").slideToggle("slow");
          $(this).siblings(".megamenu").slideToggle("slow");

          if ($(this).hasClass("ws-activearrow")) {
            $(this)
              .siblings("a")
              .attr("aria-expanded", true)
              .addClass("ws-activearrow menu-clicked");
          } else {
            $(this)
              .siblings("a")
              .attr("aria-expanded", false)
              .removeClass("ws-activearrow menu-clicked");
          }
        });
        $(".wsmenu-list > li > ul > li")
          .has(".wsmenu-submenu-sub")
          .prepend(
            '<span class="wsmenu-click02"><i class="wsmenu-arrow fa fa-caret-down"></i></span>'
          );
        $(".wsmenu-list > li > ul > li > ul > li")
          .has(".wsmenu-submenu-sub-sub")
          .prepend(
            '<span class="wsmenu-click02"><i class="wsmenu-arrow fa fa-caret-down"></i></span>'
          );
        $(".wsmenu-sub-list > li")
          .not(".test-nav .link-list")
          .prepend(
            '<span class="wsmenu-click02"><i class="wsmenu-arrow fa fa-caret-down"></i></span>'
          );
        $(".test-nav-wrapper .wsmenu-sub-list > li").prepend(
          '<span class="wsmenu-click02">        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24"><defs><clipPath id="clip-path"><rect id="Mask" width="24" height="24" transform="translate(-0.402 -0.258)" fill="none"/></clipPath></defs><g id="arrow-icon" transform="translate(0.402 0.258)" clip-path="url(#clip-path)"><line id="Line" x2="18" transform="translate(2.598 11.742)" fill="none" stroke="#2e204d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/><path id="arrow" d="M14.286,10.714l5-5-5-5" transform="translate(1.312 6.028)" fill="none" stroke="#2e204d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/></g></svg></span>'
        );
        $(".wsmenu-sub-list > li > ul > li")
          .has(".level")
          .prepend(
            '<span class="wsmenu-click02"><i class="wsmenu-arrow fa fa-caret-down"></i></span>'
          );

        $(".mega_menu_simple_container .wsmenu-click02").click(function () {
          $(this).children(".wsmenu-arrow").toggleClass("wsmenu-rotate");
          $(this).siblings(".wsmenu-submenu-sub").slideToggle("slow");
          $(this).siblings(".wsmenu-submenu-sub-sub").slideToggle("slow");

          if ($(this).find("i").hasClass("wsmenu-rotate")) {
            $(this).siblings("h5").addClass("menu-clicked").find("a").attr("aria-expanded", true);
            $(this).siblings("a").addClass("menu-clicked").attr("aria-expanded", true);
          } else {
            $(this)
              .siblings("h5")
              .removeClass("menu-clicked")
              .find("a")
              .attr("aria-expanded", false);
            $(this).siblings("a").removeClass("menu-clicked").attr("aria-expanded", false);
          }
        });

        $(".mega_menu_container .wsmenu-click02").click(function () {
          if (jQuery(window).width() <= 768) {
            $(this).children(".wsmenu-arrow").toggleClass("wsmenu-rotate");
            $(this).siblings(".wsmenu-sub-list ul").slideToggle("slow");

            if ($(this).find("i").hasClass("wsmenu-rotate")) {
              $(this).siblings("h5").addClass("menu-clicked");
              $(this).siblings("h5").find("a").attr("aria-expanded", true);
            } else {
              $(this).siblings("h5").removeClass("menu-clicked");
              $(this).siblings("h5").find("a").attr("aria-expanded", false);
            }
          }
        });

        $(".mega_menu_simple_menu .wsmenu-click02").click(function () {
          if (jQuery(window).width() <= 768) {
            $(this).children(".wsmenu-arrow").toggleClass("wsmenu-rotate");
            $(this).siblings(".wsmenu-submenu-sub").slideToggle("slow");
            $(this).siblings(".wsmenu-submenu-sub-sub").slideToggle("slow");

            if ($(this).find("i").hasClass("wsmenu-rotate")) {
              $(this).siblings("a").addClass("menu-clicked").attr("aria-expanded", true);
            } else {
              $(this).siblings("a").removeClass("menu-clicked").attr("aria-expanded", false);
            }
          }
        });
      });

      $(function () {
        $(window).resize(function () {
          if ($(window).width() > 768) {
            $(".wsmenu-sub-list ul").slideDown();
          }
        });
      });

      /*for overflow of the menu*/
      $(function () {
        $(".multi-drop li").each(function (e) {
          if ($("ul", this).length) {
            var elm = $("ul:first", this);
            var off = elm.offset();
            var l = off.left;
            var w = elm.width();
            var docH = $(window).height();
            var docW = $(window).width() - 2;
            var isEntirelyVisible = l + w <= docW;
            if (!isEntirelyVisible) {
              $(this).addClass("edge");
            } else {
              $(this).removeClass("edge");
            }
          }
        });
        $(window).resize(function () {
          $(".multi-drop li").each(function (e) {
            if ($("ul", this).length) {
              $(this).removeClass("edge");
              var elm = $("ul:first", this);
              var off = elm.offset();
              var l = off.left;
              var w = elm.width();
              var docH = $(window).height();
              var docW = $(window).width() - 2;
              var isEntirelyVisible = l + w <= docW;
              if (!isEntirelyVisible && docW > 767) {
                $(this).addClass("edge");
              } else {
                $(this).removeClass("edge");
              }
            }
          });
        });
      });

      $(function () {
        $(".mega_menu > li.mega_menu_container").each(function (e) {
          if ($("ul", this).length) {
            $(this).children().removeClass("over_left_menu");
            var elm = $("ul:first", this);
            var off = elm.offset();
            var l = off.left;
            var w = elm.width();
            var docH = $(window).height();
            var docW = $(window).width() - 2;
            var isEntirelyVisible = l + w <= docW;
            if (!isEntirelyVisible && docW > 767) {
              $(this).children().addClass("over_left_menu");
            } else {
              $(this).children().removeClass("over_left_menu");
            }
          }
        });

        $(window).resize(function () {
          $(".mega_menu > li.mega_menu_container").each(function (e) {
            if ($("ul", this).length) {
              $(this).children().removeClass("over_left_menu");
              var elm = $("ul:first", this);
              var off = elm.offset();
              var l = off.left;
              var w = elm.width();
              var docH = $(window).height();
              var docW = $(window).width() - 2;
              var isEntirelyVisible = l + w <= docW;
              if (!isEntirelyVisible && docW > 767) {
                $(this).children().addClass("over_left_menu");
              } else {
                $(this).children().removeClass("over_left_menu");
              }
            }
          });
        });

        $(".multi-drop li.mega_menu_simple_container").each(function (e) {
          if ($("ul", this).length) {
            var elm = $("ul:first", this);
            var off = elm.offset();
            var l = off.left;
            var w = elm.width();
            var docH = $(window).height();
            var docW = $(window).width() - 2;
            var isEntirelyVisible = l + w <= docW;
            if (!isEntirelyVisible) {
              $(this).addClass("edge");
            } else {
              $(this).removeClass("edge");
            }
          }
        });

        $(window).resize(function () {
          $(".multi-drop li.mega_menu_simple_container").each(function (e) {
            if ($("ul", this).length) {
              $(this).removeClass("edge");
              var elm = $("ul:first", this);
              var off = elm.offset();
              var l = off.left;
              var w = elm.width();
              var docH = $(window).height();
              var docW = $(window).width() - 2;
              var isEntirelyVisible = l + w <= docW;
              if (!isEntirelyVisible && docW > 767) {
                $(this).addClass("edge");
              } else {
                $(this).removeClass("edge");
              }
            }
          });
        });
      });

      /* sticky menu */
      if ($(".enabled-sticky-menu").length) {
        var headerDiv = "#header";
        var menuOverlay = document.querySelector(".test-wsmenu .promo-bar-active");
        var contentPaddingTop$ = parseInt($("#content").css("paddingTop"), 10);
        var header_position = $(headerDiv).position().top;
        $(window).on("scroll touchmove", function () {
          var scroll = $(window).scrollTop();
          if (
            scroll > header_position &&
            $(".wsmenucontainer").hasClass("wsoffcanvasopener") == false
          ) {
            if ($(headerDiv).not(".sticky").length) {
              $(headerDiv).addClass("sticky");
              menuOverlay?.classList.add("menu-scrolled");
              var headerHeight$ = $(headerDiv).outerHeight();
              $("#content").css("paddingTop", contentPaddingTop$ + headerHeight$ + "px");
              $(".mobile-portrait-search").css("top", contentPaddingTop$ + headerHeight$ + "px");
            }
          } else {
            if ($(headerDiv).hasClass("sticky")) {
              $(headerDiv).removeClass("sticky");
              if(menuOverlay){
              menuOverlay.classList.remove("menu-scrolled");
              }
              $("#content").css("paddingTop", contentPaddingTop$ + "px");
              $(".mobile-portrait-search").css("top", 0);
            }
          }
        });

        $("#wsnavtoggle").click(function () {
          $(headerDiv).removeClass("sticky");
        });
        $(".overlapblackbg").click(function () {
          if ($(window).scrollTop() >= header_position) {
            $(headerDiv).addClass("sticky");
          } else {
            $(headerDiv).removeClass("sticky");
          }
        });
      }
    });
  }

  return HeaderSection;
})();

theme.HeaderSection.prototype = _.assignIn({}, theme.HeaderSection.prototype, {
  onSelect: function () {
    if (!$(".enabled-sticky-menu").length) {
      $(window).unbind("scroll");
      $(window).unbind("touchmove");
    }
  },
});

theme.FeaturedImagesSection = {};

theme.FeaturedImagesSection = (function () {
  function FeaturedImagesSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
  }

  return FeaturedImagesSection;
})();

theme.FeaturedImagesSection.prototype = _.assignIn({}, theme.FeaturedImagesSection.prototype, {
  onSelect: function () {
    $(".animated").addClass("animation-done");
  },
});

theme.BlogSection = {};

theme.BlogSection = (function () {
  function BlogSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
  }

  return BlogSection;
})();

theme.BlogSection.prototype = _.assignIn({}, theme.BlogSection.prototype, {
  onSelect: function () {
    $(".animated").addClass("animation-done");
  },
});

theme.VideoSection = {};

theme.VideoSection = (function () {
  function VideoSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id")),
      videoType = $container.data("videotype");

    var itemMinHeight = $container.find(".video__inner").outerHeight();
    $container.find(".home-video").css("min-height", itemMinHeight);
    $container.find(".video-overlay").css("min-height", itemMinHeight);
    $container.find(".centered-video-content").css("min-height", itemMinHeight);

    $(window).resize(function () {
      var itemMinHeight = $container.find(".video__inner").outerHeight();
      $container.find(".home-video").css("min-height", itemMinHeight);
      $container.find(".video-overlay").css("min-height", itemMinHeight);
      $container.find(".centered-video-content").css("min-height", itemMinHeight);
    });

    if (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      if (videoType == "youtube") {
        var player;
        player = new YT.Player("video-iframe-" + sectionId, {
          events: {
            onStateChange: onPlayerChange,
          },
        });

        function onPlayerChange(evt) {
          switch (evt.data) {
            case 0: // ended
              setAsFinished();
              break;
          }
        }

        function setAsFinished() {
          $("#video-iframe-" + sectionId)
            .closest(".videoWrapper")
            .hide();
          $("#video-iframe-" + sectionId)
            .closest(".video__inner")
            .removeClass("showEmbeddedVideo")
            .find(".video_section_text")
            .show();
        }

        $(".play-video-btn-" + sectionId).on("touchend", function (ev) {
          $(this).closest(".video_section_text").hide();
          $(this)
            .closest(".video__inner")
            .addClass("showEmbeddedVideo")
            .find(".videoWrapper")
            .show();
        });

        $(".close-video-btn-" + sectionId).on("touchend", function (ev) {
          $(this).closest(".videoWrapper").hide();
          $(this)
            .closest(".video__inner")
            .removeClass("showEmbeddedVideo")
            .find(".video_section_text")
            .show();
          player.stopVideo();
        });
      } else if (videoType == "vimeo") {
        var player = new Vimeo.Player("video-iframe-" + sectionId);
        $(".play-video-btn-" + sectionId).on("touchend", function (ev) {
          $(this).closest(".video_section_text").hide();
          $(this)
            .closest(".video__inner")
            .addClass("showEmbeddedVideo")
            .find(".videoWrapper")
            .show();
          player.play();
        });

        $(".close-video-btn-" + sectionId).on("touchend", function (ev) {
          $(this).closest(".videoWrapper").hide();
          $(this)
            .closest(".video__inner")
            .removeClass("showEmbeddedVideo")
            .find(".video_section_text")
            .show();
          player.unload();
        });

        player.on("ended", function () {
          $("#video-iframe-" + sectionId)
            .closest(".videoWrapper")
            .hide();
          $("#video-iframe-" + sectionId)
            .closest(".video__inner")
            .removeClass("showEmbeddedVideo")
            .find(".video_section_text")
            .show();
        });
      }
    } else {
      if (videoType == "youtube") {
        var player;
        player = new YT.Player("video-iframe-" + sectionId, {
          events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerChange,
          },
        });

        function onPlayerChange(evt) {
          switch (evt.data) {
            case 0: // ended
              setAsFinished();
              break;
          }
        }
        function onPlayerReady(event) {
          setupListener();
        }
        function setAsFinished() {
          $("#video-iframe-" + sectionId)
            .closest(".videoWrapper")
            .hide();
          $("#video-iframe-" + sectionId)
            .closest(".video__inner")
            .removeClass("showEmbeddedVideo")
            .find(".video_section_text")
            .show();
        }

        function setupListener() {
          $(".play-video-btn-" + sectionId).on("click touchend", function (ev) {
            $(this).closest(".video_section_text").hide();
            $(this)
              .closest(".video__inner")
              .addClass("showEmbeddedVideo")
              .find(".videoWrapper")
              .show();
            player.playVideo();
          });

          $(".close-video-btn-" + sectionId).on("click", function (ev) {
            $(this).closest(".videoWrapper").hide();
            $(this)
              .closest(".video__inner")
              .removeClass("showEmbeddedVideo")
              .find(".video_section_text")
              .show();
            player.stopVideo();
          });
        }
      } else if (videoType == "vimeo") {
        var player = new Vimeo.Player("video-iframe-" + sectionId);
        $(".play-video-btn-" + sectionId).on("click", function (ev) {
          $(this).closest(".video_section_text").hide();
          $(this)
            .closest(".video__inner")
            .addClass("showEmbeddedVideo")
            .find(".videoWrapper")
            .show();
          player.play();
        });

        $(".close-video-btn-" + sectionId).on("click", function (ev) {
          $(this).closest(".videoWrapper").hide();
          $(this)
            .closest(".video__inner")
            .removeClass("showEmbeddedVideo")
            .find(".video_section_text")
            .show();
          player.unload();
        });

        player.on("ended", function () {
          $("#video-iframe-" + sectionId)
            .closest(".videoWrapper")
            .hide();
          $("#video-iframe-" + sectionId)
            .closest(".video__inner")
            .removeClass("showEmbeddedVideo")
            .find(".video_section_text")
            .show();
        });
      }
    }

    if ($("#hero-video-" + sectionId + " .fullvid").length) {
      $("#hero-video-" + sectionId).prepend('<div class="vidcover"></div>');

      $(window)
        .resize(function () {
          var theWidth = $(window).width();
          var theHeight = $(window).height();
          var newWidth = theHeight * 1.77777778;
          var newHeight = theWidth / 1.77777778;

          if (theWidth > 1280 && newHeight > theHeight) {
            $("#hero-video-" + sectionId + "  .fullvid").css({
              width: theWidth,
              height: newHeight,
            });
          }

          if (theHeight > 720 && newWidth > theWidth) {
            $("#hero-video-" + sectionId + "  .fullvid").css({
              height: theHeight,
              width: newWidth,
            });
          }

          $("#hero-video-" + sectionId + " .vidcover").css({ height: theHeight, width: theWidth });
        })
        .resize();
    }

    //  $currentVideo.magnificPopup({
    //       type: 'iframe',
    //       mainClass: 'mfp-fade',
    //       removalDelay: 160,
    //       closeBtnInside: false,
    //       preloader: false,
    //       fixedContentPos: false,
    //       iframe: {
    //         patterns: {
    //           youtube: {
    //             src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0&showinfo=0'
    //           }
    //         }
    //       }
    //     });
  }

  return VideoSection;
})();

theme.VideoSection.prototype = _.assignIn({}, theme.VideoSection.prototype, {
  onSelect: function () {},
});

theme.TextSection = {};

theme.TextSection = (function () {
  function TextSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
  }

  return TextSection;
})();

theme.TextSection.prototype = _.assignIn({}, theme.TextSection.prototype, {
  onSelect: function () {
    $(".animated").addClass("animation-done");
  },
});

theme.SlideshowSection = (function () {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var Slideshow = (this.Slideshow = $("#flexslider-" + sectionId));
    var slideShowSpeed = Slideshow.data("animationspeed") * 1000;

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) &&
      Slideshow.find(".slides li").length > 1
    ) {
      var animationVar = "slide";
    } else {
      var animationVar = "fade";
    }

    Slideshow.flexslider({
      animation: animationVar, //String: Select your animation type, "fade" or "slide"
      //Boolean: Create navigation for previous/next navigation? (true/false)
      slideshowSpeed: slideShowSpeed, //Integer: Set the speed of the slideshow cycling, in milliseconds
      animationSpeed: 600, //Integer: Set the speed of animations, in milliseconds
      // pauseOnHover: false, //Boolean: Pause the slideshow when hovering over slider, then resume when no longer hovering
      directionNav: true,
      controlNav: false,
      pauseOnHover: true,
      pauseOnAction: true,
      start: function (slider) {
        slider.removeClass("loading");
      },
    });
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
  onBlockSelect: function (evt) {
    // Ignore the cloned version
    var Slideshow = this.Slideshow;
    var $slide = Slideshow.find("#slide-" + evt.detail.blockId);
    var slideIndex = $slide.data("index");

    // Go to selected slide, pause autoplay
    Slideshow.flexslider(slideIndex);
    Slideshow.flexslider("pause");
  },
  onBlockDeselect: function () {
    var Slideshow = this.Slideshow;
    // Resume autoplay
    Slideshow.flexslider("play");
  },
});

theme.BlogPageSection = {};

theme.BlogPageSection = (function () {
  function BlogPageSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var $container = $(".masonry");

    $container.imagesLoaded(function () {
      $container.masonry({
        itemSelector: ".masonry-post",
        columnWidth: ".masonry-post",
        transitionDuration: 0,
      });
    });
  }

  return BlogPageSection;
})();

theme.BlogPageSection.prototype = _.assignIn({}, theme.BlogPageSection.prototype, {
  onSelect: function () {
    $(".animated").addClass("animation-done");
  },
});

theme.ArticlePageSection = {};

theme.ArticlePageSection = (function () {
  function ArticlePageSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
  }

  return ArticlePageSection;
})();

theme.ArticlePageSection.prototype = _.assignIn({}, theme.ArticlePageSection.prototype, {
  onSelect: function () {
    $(".animated").addClass("animation-done");
  },
});

theme.CollectionPageSection = {};

theme.CollectionPageSection = (function () {
  function CollectionPageSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var starsValue = (this.reviewsStars = $container.attr("data-reviews-stars"));

    $container.find('form[action*="/cart/add"]').submit(function (e) {});

    $(".offcanvas_filter_toggle").on("click", function () {
      $("#content").toggleClass("opened_sidebar");
    });
    $(".overlapblackbg_sidebar").on("click", function () {
      $("#content").removeClass("opened_sidebar");
    });
    $(".close_mobile_off_canvas").on("click", function () {
      $("#content").removeClass("opened_sidebar");
    });

    if ($(".load-more__icon").length) {
      enableInfiniteScroll(starsValue);
    }

    $(".second_level_drop_link").on("click", function (e) {
      var el = $(this);

      var data_collapsed = el.hasClass("collapsed");
      var data_url = el.data("link-url");
      if (e.target == this && !data_collapsed) {
        window.location.href = data_url;
      } else {
        el.addClass("second_level_drop_link_active");
        setTimeout(function () {
          $(".second_level_drop_link")
            .not(".second_level_drop_link_active")
            .each(function () {
              $(this)
                .addClass("collapsed")
                .attr("aria-expanded", "false")
                .closest(".panel-heading")
                .next(".panel-collapse")
                .attr("aria-expanded", false)
                .animate(
                  {
                    height: "0px",
                  },
                  400,
                  function () {
                    $(this).removeClass("in");
                  }
                );
            });
          el.removeClass("second_level_drop_link_active");
        }, 100);
      }
    });

    $(".third_level_drop_link").on("click", function (e) {
      var el = $(this);

      var data_collapsed = el.hasClass("collapsed");
      var data_url = el.data("link-url");

      if (e.target == this && !data_collapsed) {
        window.location.href = data_url;
      }
    });
  }

  return CollectionPageSection;
})();

theme.CollectionPageSection.prototype = _.assignIn({}, theme.CollectionPageSection.prototype, {
  onSelect: function () {
    var starsValue = this.reviewsStars;

    // Close pop-up if open //
    var magnificPopup = $.magnificPopup.instance;
    if (typeof magnificPopup !== "undefined") {
      magnificPopup.close();
    }
    // Build quick view //
    enabledQuickView();
    setTimeout(function () {
      $(".quick-view-panel").each(function () {
        var selectID = $(this).data("id");
        var select = "product-select-" + selectID;
        var product = $(this).data("name");
        var qvpData = $(this).find(".data-qvp").text();
        var qvpJson = JSON.parse(qvpData);

        $(".quick-view-selector-" + qvpJson.id).on("change", function () {
          var $form = $(this).closest("form"),
            productVariantObj = qvpJson.variants;

          var option1 = $form.find("#SingleOptionSelector-0").val() || null,
            option2 = $form.find("#SingleOptionSelector-1").val() || null,
            option3 = $form.find("#SingleOptionSelector-2").val() || null,
            flag = true;
          for (var i = 0, length = productVariantObj.length; i < length; i++) {
            var productVar = productVariantObj[i];
            if (productVar.option1 != null) {
              productVar.option1 = productVar.option1.replace(/\s{2,}/g, " ");
            }
            if (productVar.option2 != null) {
              productVar.option2 = productVar.option2.replace(/\s{2,}/g, " ");
            }
            if (productVar.option3 != null) {
              productVar.option3 = productVar.option3.replace(/\s{2,}/g, " ");
            }

            if (
              option1 == productVar.option1 &&
              option2 == productVar.option2 &&
              option3 == productVar.option3
            ) {
              flag = false;
              $("#product-select-" + qvpJson.id).val(productVar.id);
              app.selectCallback(productVar, qvpJson.id);
              break;
            }
          }
          if (flag) {
            app.selectCallback(null, qvpJson.id);
          }
        });

        for (var i = 0, length = qvpJson.variants.length; i < length; i++) {
          var productVariants = qvpJson.variants[i];

          if (productVariants.available) {
            for (var j = 0, optlength = productVariants.options.length; j < optlength; j++) {
              var variantOption = productVariants.options[j];
              variantOption = handleizeStr(variantOption);
              $(
                ".swatch-product-id-" +
                  qvpJson.id +
                  ' .swatch[data-option-index="' +
                  j +
                  '"] .' +
                  variantOption +
                  ""
              )
                .removeClass("soldout")
                .addClass("available")
                .find(":radio")
                .removeAttr("disabled");
            }
          }
        }
        // BEGIN SWATCHES

        var indexArray = [];
        var productVariantOptions = qvpJson.variants;
        $("[data-id=" + qvpJson.id + "] .single-option-selector option:selected").each(function () {
          indexArray.push($(this).index());
        });
        var form = jQuery("#product-select-" + qvpJson.id).closest("form");
        var variantIndex = jQuery("#product-select-" + qvpJson.id + " option:selected").index();
        if (variantIndex >= 0) {
          var variant = productVariantOptions[variantIndex];
          for (var i = 0, length = variant.options.length; i < length; i++) {
            var num = indexArray[i];
            var radioButtonDiv = form.find(
              '.swatch[data-option-index="' + i + '"] div.swatch-element'
            )[num];
            var radioButton = $(radioButtonDiv).find(":radio");
            if (radioButton.size()) {
              radioButton.get(0).checked = true;
            }
          }
        }

        // END SWATCHES
      });
    }, 1000);

    $("#sortBy")
      // select the current sort order
      .val($("#sortBy").data("sort"))
      .bind("change", function () {
        Shopify.queryParams.sort_by = jQuery(this).val();
        location.search = jQuery.param(Shopify.queryParams);
      });

    $(".change-view").on("click", function () {
      var view = $(this).data("view"),
        url = document.URL,
        hasParams = url.indexOf("?") > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, "view", view);
      } else {
        window.location = url + "?view=" + view;
      }
    });
    if (starsValue == "true") {
      SPR.$(document).ready(function () {
        return (
          SPR.registerCallbacks(),
          SPR.initRatingHandler(),
          SPR.initDomEls(),
          SPR.loadProducts(),
          SPR.loadBadges()
        );
      });
    }
  },
});

theme.CollectionListPageSection = {};

theme.CollectionListPageSection = (function () {
  function CollectionListPageSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));

    if ($(".load-more__icon").length) {
      enableInfiniteScrollList();
    }
  }

  return CollectionListPageSection;
})();

theme.CollectionListPageSection.prototype = _.assignIn(
  {},
  theme.CollectionListPageSection.prototype,
  {
    onSelect: function () {
      $("#sortBy")
        // select the current sort order
        .val($("#sortBy").data("sort"))
        .bind("change", function () {
          Shopify.queryParams.sort_by = jQuery(this).val();
          location.search = jQuery.param(Shopify.queryParams);
        });

      $(".change-view").on("click", function () {
        var view = $(this).data("view"),
          url = document.URL,
          hasParams = url.indexOf("?") > -1;

        if (hasParams) {
          window.location = replaceUrlParam(url, "view", view);
        } else {
          window.location = url + "?view=" + view;
        }
      });
    },
  }
);

theme.ProductPageSection = {};
var changeUrl = false;
theme.ProductPageSection = (function () {
  function ProductPageSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));
    var isFeaturedProduct = $container.data("featured-product") || null;
    var starsValue = (this.reviewsStars = $container.attr("data-reviews-stars"));

    /*PRODUCT FLEXSLIDER*/
    $container.find("#carousel").flexslider({
      animation: "slide",
      controlNav: false,
      animationLoop: false,
      slideshow: false,
      itemWidth: 150,
      itemMargin: 5,
      asNavFor: ".product_images",
    });

    if ($("#carousel").length) {
      var controlNav = false;
    } else {
      var controlNav = "thumbnails";
    }

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ) {
      var animationVar = "slide";
    } else {
      var animationVar = "fade";
    }
    $container.find(".product_images").flexslider({
      startAt: parseInt($(".featured_image", $(this)).data("index"), 10),
      touch: true,
      animationLoop: false,
      pauseOnHover: true,
      controlNav: controlNav,
      directionNav: false,
      animation: animationVar,
      slideshow: false,
      slideshowSpeed: 10 * 1000,
      sync: "#carousel",
    });
    /* END PRODUCT FLEXSLIDER*/

    selectCallback = function (variant, selector) {
      if (variant && changeUrl && isFeaturedProduct != true) {
        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?variant=" +
          variant.id;
        window.history.replaceState({ path: newurl }, "", newurl);
      }
      /* for the variant sku change */
      if ($container.find(".variant-sku")) {
        if (jQuery.type(variant) === "null") {
          $container.find(".variant-sku").empty();
        } else {
          if (variant.sku) {
            $container.find(".variant-sku").html("<b>Sku: </b>" + variant.sku);
          } else {
            $container.find(".variant-sku").empty();
          }
        }
      }
      /* end of variant sku change  */

      var $product = $container.find("#product-" + selector + "-gallery");
      if (
        variant &&
        variant.featured_image &&
        $product.is(":visible") &&
        (changeUrl || isFeaturedProduct == true)
      ) {
        var original_image = $(".flex-active-slide img", $product),
          new_image = variant.featured_image;
        Shopify.Image.switchImage(
          new_image,
          original_image[0],
          function (new_image_src, original_image, element) {
            if (typeof $product.flexslider == "function") {
              $product.flexslider(
                $('[data-image-id="' + variant.featured_image.id + '"]').data("index")
              );
            }
          }
        );
      }

      // BEGIN SWATCHES
      if (variant) {
        var indexArray = [];
        $container
          .find(".main-product-select .single-option-selector option:selected")
          .each(function () {
            indexArray.push($(this).index());
          });
        var form = $container.find("#product-select-" + selector).closest("form");
        for (var i = 0, length = variant.options.length; i < length; i++) {
          var num = indexArray[i];
          var radioButtonDiv = form.find(
            '.swatch[data-option-index="' + i + '"] div.swatch-element'
          )[num];
          var radioButton = $(radioButtonDiv).find(":radio");
          if (radioButton.size()) {
            radioButton.get(0).checked = true;
          }
        }
      }
      // END SWATCHES

      var addToCart = $container.find("#addToCart"),
        productPrice = $container.find("#productPrice"),
        comparePrice = $container.find("#comparePrice"),
        qty = $container.find(".product-page-qty #quantity").val();

      var form = $container.find("#product-select-" + selector).closest("form");
      var smart_checkout_btn = form.find(".shopify-payment-button");

      if ($("#variant-inventory")) {
        if (variant) {
          var main_product_select = $container.find("#product-select-" + selector),
            optionsLength = main_product_select.find("option").length;
          for (var i = 0; i <= optionsLength; i++) {
            var currentOption = main_product_select.find("option:nth-child(" + i + ")");
            if (currentOption.val() == variant.id) {
              var variant_inventory_management = currentOption.attr("data-inventory_management");
              var variant_inventory_policy = currentOption.attr("data-inventory_policy");
              var variant_inventory_quantity = currentOption.attr("data-inventory_quantity");
              break;
            } else {
              var variant_inventory_management = "";
              var variant_inventory_policy = "";
              var variant_inventory_quantity = "";
            }
          }
          if (variant_inventory_management == "shopify" && variant_inventory_policy != "continue") {
            if (variant_inventory_quantity > 0) {
              $container
                .find("#variant-inventory")
                .html("<span class=in-stock>In stock! Usually ships within 24 hours.</span>");
            } else {
              $container
                .find("#variant-inventory")
                .html(
                  "<span class=out-of-stock>Sorry!  This product is currently out of stock.</span>"
                );
            }
          } else {
            $container
              .find("#variant-inventory")
              .html("<span class=in-stock>In stock! Usually ships within 24 hours.</span>");
          }
        } else {
          $container
            .find("#variant-inventory")
            .html(
              "<span class=out-of-stock>Sorry!  This product is currently out of stock.</span>"
            );
        }
      }
      if (variant) {
        if (variant.available) {
          //          if (variant.inventory_management == "shopify" && variant.inventory_policy != "continue" && variant.inventory_quantity < qty) {
          //           // Variant is sold out, disable the submit button
          //           addToCart.val('Sold Out').addClass('disabled').prop('disabled', true);
          //          }
          //         else{
          // We have a valid product variant, so enable the submit button
          if (addToCart.val() == "ADD TO CART") {
            addToCart.removeClass("disabled").prop("disabled", false).val("ADD TO CART");
          } else {
            addToCart.removeClass("disabled").prop("disabled", false).val("Skip, and add to cart");
          }
          smart_checkout_btn.show();
          //         }
        } else {
          // Variant is sold out, disable the submit button
          addToCart.val("Sold Out").addClass("disabled").prop("disabled", true);
          smart_checkout_btn.hide();
        }

        // Regardless of stock, update the product price

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          comparePrice
            .html(Shopify.formatMoney(variant.compare_at_price, app.data.money_format))
            .show();
        } else {
          comparePrice.hide();
        }
      } else {
        // The variant doesn't exist, disable submit button.
        // This may be an error or notice that a specific variant is not available.
        addToCart.val("Unavailable").addClass("disabled").prop("disabled", true);
        smart_checkout_btn.hide();
      }
    };

    /////////// Related products /////////////////
    if (isFeaturedProduct != true) {
      var magnificPopup = $.magnificPopup.instance;
      if (typeof magnificPopup !== "undefined") {
        magnificPopup.close();
      }
      enabledQuickView();
      setTimeout(function () {
        $(".quick-view-panel").each(function () {
          var selectID = $(this).data("id");
          var select = "product-select-" + selectID;
          var product = $(this).data("name");
          var qvpData = $(this).find(".data-qvp").text();
          var qvpJson = JSON.parse(qvpData);

          $(".quick-view-selector-" + qvpJson.id).on("change", function () {
            var $form = $(this).closest("form"),
              productVariantObj = qvpJson.variants;

            var option1 = $form.find("#SingleOptionSelector-0").val() || null,
              option2 = $form.find("#SingleOptionSelector-1").val() || null,
              option3 = $form.find("#SingleOptionSelector-2").val() || null,
              flag = true;
            for (var i = 0, length = productVariantObj.length; i < length; i++) {
              var productVar = productVariantObj[i];

              if (productVar.option1 != null) {
                productVar.option1 = productVar.option1.replace(/\s{2,}/g, " ");
              }
              if (productVar.option2 != null) {
                productVar.option2 = productVar.option2.replace(/\s{2,}/g, " ");
              }
              if (productVar.option3 != null) {
                productVar.option3 = productVar.option3.replace(/\s{2,}/g, " ");
              }

              if (
                option1 == productVar.option1 &&
                option2 == productVar.option2 &&
                option3 == productVar.option3
              ) {
                flag = false;
                $("#product-select-" + qvpJson.id).val(productVar.id);
                app.selectCallback(productVar, qvpJson.id);
                break;
              }
            }
            if (flag) {
              app.selectCallback(null, qvpJson.id);
            }
          });

          for (var i = 0, length = qvpJson.variants.length; i < length; i++) {
            var productVariants = qvpJson.variants[i];

            if (productVariants.available) {
              for (var j = 0, optlength = productVariants.options.length; j < optlength; j++) {
                var variantOption = productVariants.options[j];
                variantOption = handleizeStr(variantOption);
                $(
                  ".swatch-product-id-" +
                    qvpJson.id +
                    ' .swatch[data-option-index="' +
                    j +
                    '"] .' +
                    variantOption +
                    ""
                )
                  .removeClass("soldout")
                  .addClass("available")
                  .find(":radio")
                  .removeAttr("disabled");
              }
            }
          }
          // BEGIN SWATCHES

          var indexArray = [];
          var productVariantOptions = qvpJson.variants;
          $("[data-id=" + qvpJson.id + "] .single-option-selector option:selected").each(
            function () {
              indexArray.push($(this).index());
            }
          );
          var form = jQuery("#product-select-" + qvpJson.id).closest("form");
          var variantIndex = jQuery("#product-select-" + qvpJson.id + " option:selected").index();
          if (variantIndex >= 0) {
            var variant = productVariantOptions[variantIndex];
            for (var i = 0, length = variant.options.length; i < length; i++) {
              var num = indexArray[i];
              var radioButtonDiv = form.find(
                '.swatch[data-option-index="' + i + '"] div.swatch-element'
              )[num];
              var radioButton = $(radioButtonDiv).find(":radio");
              if (radioButton.size()) {
                radioButton.get(0).checked = true;
              }
            }
          }

          // END SWATCHES
        });
      }, 1000);
    }
    /////////////////////////

    var productData = $container.find(".product-json").text();
    var productJSON = JSON.parse(productData);
    var productVariantObj = productJSON.variants;

    var optionSelected = function () {
      var option1 = $(".main-product-select #SingleOptionSelector-0").val() || null,
        option2 = $(".main-product-select #SingleOptionSelector-1").val() || null,
        option3 = $(".main-product-select #SingleOptionSelector-2").val() || null,
        flag = true;
      for (var i = 0, length = productVariantObj.length; i < length; i++) {
        var productVar = productVariantObj[i];
        if (productVar.option1 != null) {
          productVar.option1 = productVar.option1.replace(/\s{2,}/g, " ");
        }
        if (productVar.option2 != null) {
          productVar.option2 = productVar.option2.replace(/\s{2,}/g, " ");
        }
        if (productVar.option3 != null) {
          productVar.option3 = productVar.option3.replace(/\s{2,}/g, " ");
        }

        if (
          option1 == productVar.option1 &&
          option2 == productVar.option2 &&
          option3 == productVar.option3
        ) {
          flag = false;
          $container
            .find("#product-select-" + productJSON.id)
            .val(productVar.id)
            .change();
          selectCallback(productVar, productJSON.id);
          break;
        }
      }
      if (flag) {
        selectCallback(null, productJSON.id);
      }
    };

    $container.find(".main-product-select .single-option-selector").on("change", function () {
      optionSelected();
    });

    $("input[type=button].btn-option-3").on("click", function (event) {
      event.preventDefault();
      $(".btn-option-3").removeClass("selected");
      $(this).addClass("selected");
      optionSelected();
    });

    // Handle button clicks for Finish options (applied via tags)
    $("input[type=button].finish_option").on("click", function (event) {
      event.preventDefault();
      $(".finish_option").removeClass("selected");
      $(this).addClass("selected");
      // Get the clicked finish
      var $clicked_finish = $(this).val();
      // Set the hidden input value
      $("#finish_property_input").val($clicked_finish);
    });

    // Handle button clicks for Perforation options (applied via tags)
    $("input[type=button].perforation_option").on("click", function (event) {
      event.preventDefault();
      $(".perforation_option").removeClass("selected");
      $(this).addClass("selected");
      // Get the clicked perforation_option
      var $clicked_perforation = $(this).val();
      // Set the hidden input value
      $("#perforation_property_input").val($clicked_perforation);
    });

    var selectedOptionsLength = $container.find(
      "#product-select-" + productJSON.id + " option[selected]"
    ).length;
    var optionsLength = $container.find("#product-select-" + productJSON.id).length;
    if (!selectedOptionsLength || optionsLength == 1) {
      selectCallback(productJSON.variants[0], productJSON.id);
    }

    for (var i = 0, length = productJSON.variants.length; i < length; i++) {
      var productVariants = productJSON.variants[i];

      if (productVariants.available) {
        for (var j = 0, optlength = productVariants.options.length; j < optlength; j++) {
          var variantOption = productVariants.options[j];
          variantOption = handleizeStr(variantOption);
          $container
            .find(
              ".swatch-product-id-" +
                productJSON.id +
                ' .swatch[data-option-index="' +
                j +
                '"] .' +
                variantOption +
                ""
            )
            .removeClass("soldout")
            .addClass("available")
            .find(":radio")
            .removeAttr("disabled");
        }
      }
    }

    $product = $("#product-" + productJSON.id);
    // new Shopify.OptionSelectors("product-select-" + productJSON.id+"", { product: productJSON, onVariantSelected: selectCallback });

    // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
    if (productJSON.options.size == 1 && productJSON.options[0] != "Title") {
      $container
        .find(".selector-wrapper:eq(0)")
        .prepend("<label>" + productJSON.options[0] + "</label>");
    }

    // Hide selectors if we only have 1 variant and its title contains 'Default'.
    if (productJSON.variants.size == 1 && productJSON.variants[0].title.indexOf("Default") + 1) {
      $container.find(".selector-wrapper").hide();
    }
    if (isFeaturedProduct != true) {
      var str = window.location.href;
      if (!(str.indexOf("?variant=") + 1)) {
        // Auto-select first available variant on page load. Otherwise the product looks sold out.
        var found_one_in_stock = false;
        for (variant in productJSON.variants) {
          if (productJSON.variants[variant].available && found_one_in_stock == false) {
            found_one_in_stock = true;
            for (option in productJSON.options) {
              var i = Object.keys(productJSON.options).indexOf(option);
              if (i >= 0) {
                $container
                  .find(".main-product-select .single-option-selector:eq(" + i + ")")
                  .val(productJSON.variants[variant].options[i].replace(/\s{2,}/g, " "))
                  .trigger("change");
              }
            }
            changeUrl = true;
          }
        }
      } else {
        $(".main-product-select .single-option-selector").first().trigger("change");
        changeUrl = true;
      }
      initOwlCarousel(sectionId);
    }

    //////////////////////////////////////
    // Qty
    /////////////////////////////////////

    $container.find(".product-page-qty .minus_btn").click(function () {
      var inputEl = jQuery(this).parent().children().next();
      var qty = inputEl.val();
      if (jQuery(this).parent().hasClass("minus_btn")) qty++;
      else qty--;
      if (qty <= 1) qty = 1;
      inputEl.val(qty);
    });

    $container.find(".product-page-qty .plus_btn").click(function () {
      var inputEl = $container.find(".product-page-qty #quantity");
      var qty = inputEl.val() * 1;

      qty++;
      inputEl.val(qty);
    });

    /////////////////////////////////////
    //  Product Image Zoom
    /////////////////////////////////////
    if (
      typeof $.zoom === "function" &&
      $container.find("#image-block").data("zoom") == "disabled"
    ) {
      var imageBlock = $container.find("#image-block");
      if (imageBlock.length) {
        var imageSlideLinks = imageBlock.find("a.image-slide-link");
        if (imageSlideLinks.length) {
          imageSlideLinks.each(function () {
            var t = $(this);
            var url = t[0].href;
            t.zoom({ url: url, touch: false });
          });
        }
      }
    }

    // Initialize popup as usual
    $container.find(".slides").magnificPopup({
      delegate: "a",
      type: "image",
      closeOnContentClick: false,
      closeBtnInside: false,
      mainClass: "mfp-with-zoom mfp-img-mobile",
      image: {
        verticalFit: true,
      },
      gallery: {
        enabled: true,
      },
      zoom: {
        enabled: true,
        duration: 300, // don't foget to change the duration also in CSS
        opener: function (element) {
          return element.find("img");
        },
      },
    });

    /////////////////////////////////////
    //  Swatches
    /////////////////////////////////////

    jQuery(function () {
      $container.find(".swatch :radio").change(function () {
        var optionIndex = jQuery(this).closest(".swatch").attr("data-option-index");
        var optionValue = jQuery(this)
          .val()
          .replace(/\s{2,}/g, " ");
        jQuery(this)
          .closest("form")
          .find(".single-option-selector")
          .eq(optionIndex)
          .val(optionValue)
          .trigger("change");
      });
    });
    ////// end Swatches //////

    $container.find('form[action*="/cart/add"]').submit(function (e) {});
  }

  return ProductPageSection;
})();

theme.ProductPageSection.prototype = _.assignIn({}, theme.ProductPageSection.prototype, {
  onSelect: function () {
    var starsValue = this.reviewsStars;

    if (starsValue == "true") {
      SPR.$(document).ready(function () {
        return (
          SPR.registerCallbacks(),
          SPR.initRatingHandler(),
          SPR.initDomEls(),
          SPR.loadProducts(),
          SPR.loadBadges()
        );
      });
    }
  },
});

// theme.Maps
theme.Maps = (function () {
  var config = {
    zoom: 14,
  };
  var apiStatus = null;
  var mapsToLoad = [];
  if (theme.strings != undefined) {
    var errors = {
      addressNoResults: theme.strings.addressNoResults,
      addressQueryLimit: theme.strings.addressQueryLimit,
      addressError: theme.strings.addressError,
      authError: theme.strings.authError,
    };
  }
  var selectors = {
    section: '[data-section-type="map"]',
    map: "[data-map]",
    mapOverlay: "[data-map-overlay]",
  };

  var classes = {
    mapError: "map-section--load-error",
    errorMsg: "map-section__error errors text-center",
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function () {
    if (Shopify.designMode) {
      $(selectors.section).addClass(classes.mapError);
      $(selectors.map).remove();
      console.log(theme.strings.authError);
    }
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data("api-key");

    if (typeof this.key === "object" || typeof this.key == "undefined") {
      return;
    }

    if (apiStatus === "loaded") {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== "loading") {
        apiStatus = "loading";
        if (typeof window.google === "undefined") {
          $.getScript("https://maps.googleapis.com/maps/api/js?key=" + this.key).then(function () {
            apiStatus = "loaded";
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function (index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data("address-setting");

    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function () {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function (results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true,
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter(),
            });

            google.maps.event.addDomListener(
              window,
              "resize",
              $.debounce(250, function () {
                google.maps.event.trigger(map, "resize");
                map.setCenter(center);
                $map.removeAttr("style");
              })
            );
          }.bind(this)
        )
        .fail(function () {
          var errorMessage;

          switch (status) {
            case "ZERO_RESULTS":
              errorMessage = errors.addressNoResults;
              break;
            case "OVER_QUERY_LIMIT":
              errorMessage = errors.addressQueryLimit;
              break;
            case "REQUEST_DENIED":
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html('<div class="' + classes.errorMsg + '">' + errorMessage + "</div>");
          }
        });
    },

    onUnload: function () {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, "resize");
    },
  });

  return Map;
})();

Shopify.Image = {
  preload: function (e, t) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      this.loadImage(this.getSizedImageUrl(r, t));
    }
  },
  loadImage: function (e) {
    new Image().src = e;
  },
  switchImage: function (e, t, n) {
    if (e && t) {
      var r = this.imageSize(t.src),
        i = this.getSizedImageUrl(e.src, r);
      n ? n(i, e, t) : (t.src = i);
    }
  },
  imageSize: function (e) {
    var t = e.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );
    return null !== t ? t[1] : null;
  },
  getSizedImageUrl: function (e, t) {
    if (null == t) return e;
    if ("master" == t) return this.removeProtocol(e);
    var n = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (null != n) {
      var r = e.split(n[0]),
        i = n[0];
      return this.removeProtocol(r[0] + "_" + t + i);
    }
    return null;
  },
  removeProtocol: function (e) {
    return e.replace(/http(s)?:/, "");
  },
};

var handleizeStr = function (str) {
  return str
    .toLowerCase()
    .replace(/[^\w\u00C0-\u024f]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

var initOwlCarousel = function (sectionId) {
  var featuredProducts = $("#featured-products-section-" + sectionId + "");
  if (featuredProducts.length) {
    featuredProducts.owlCarousel({
      margin: 0,
      nav: true,
      navRewind: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 1000,
      autoplayTimeout: 4000,
      autoplayHoverPause: true,
      loop: false,
      navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
        },
        360: {
          items: 2,
        },
        600: {
          items: 3,
        },
        1000: {
          items: 4,
        },
      },
    });
  }
};

/////////////////////////////////////
//  Double-Tap for Mobile Menu
/////////////////////////////////////

/*
  By Osvaldas Valutis, www.osvaldas.info
  Available for use under the MIT License
*/

(function ($, window, document, undefined) {
  $.fn.doubleTapToGo = function (params) {
    if (
      !("ontouchstart" in window) &&
      !navigator.msMaxTouchPoints &&
      !navigator.userAgent.toLowerCase().match(/windows phone os 7/i)
    )
      return false;

    this.each(function () {
      var curItem = false;

      $(this).on("click", function (e) {
        var item = $(this);
        if (item[0] != curItem[0]) {
          e.preventDefault();
          curItem = item;
        }
      });

      $(document).on("click touchstart MSPointerDown", function (e) {
        var resetItem = true,
          parents = $(e.target).parents();

        for (var i = 0; i < parents.length; i++) if (parents[i] == curItem[0]) resetItem = false;

        if (resetItem) curItem = false;
      });
    });
    return this;
  };
})(jQuery, window, document);

/////////////////////////////////////
//  Bootstrap.min.js
/////////////////////////////////////

/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */
if ("undefined" == typeof jQuery) throw new Error("Bootstrap's JavaScript requires jQuery");
+(function (a) {
  "use strict";
  var b = a.fn.jquery.split(" ")[0].split(".");
  if ((b[0] < 2 && b[1] < 9) || (1 == b[0] && 9 == b[1] && b[2] < 1) || b[0] > 3)
    throw new Error(
      "Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4"
    );
})(jQuery),
  +(function (a) {
    "use strict";
    function b() {
      var a = document.createElement("bootstrap"),
        b = {
          WebkitTransition: "webkitTransitionEnd",
          MozTransition: "transitionend",
          OTransition: "oTransitionEnd otransitionend",
          transition: "transitionend",
        };
      for (var c in b) if (void 0 !== a.style[c]) return { end: b[c] };
      return !1;
    }
    (a.fn.emulateTransitionEnd = function (b) {
      var c = !1,
        d = this;
      a(this).one("bsTransitionEnd", function () {
        c = !0;
      });
      var e = function () {
        c || a(d).trigger(a.support.transition.end);
      };
      return setTimeout(e, b), this;
    }),
      a(function () {
        (a.support.transition = b()),
          a.support.transition &&
            (a.event.special.bsTransitionEnd = {
              bindType: a.support.transition.end,
              delegateType: a.support.transition.end,
              handle: function (b) {
                if (a(b.target).is(this)) return b.handleObj.handler.apply(this, arguments);
              },
            });
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var c = a(this),
          e = c.data("bs.alert");
        e || c.data("bs.alert", (e = new d(this))), "string" == typeof b && e[b].call(c);
      });
    }
    var c = '[data-dismiss="alert"]',
      d = function (b) {
        a(b).on("click", c, this.close);
      };
    (d.VERSION = "3.3.7"),
      (d.TRANSITION_DURATION = 150),
      (d.prototype.close = function (b) {
        function c() {
          g.detach().trigger("closed.bs.alert").remove();
        }
        var e = a(this),
          f = e.attr("data-target");
        f || ((f = e.attr("href")), (f = f && f.replace(/.*(?=#[^\s]*$)/, "")));
        var g = a("#" === f ? [] : f);
        b && b.preventDefault(),
          g.length || (g = e.closest(".alert")),
          g.trigger((b = a.Event("close.bs.alert"))),
          b.isDefaultPrevented() ||
            (g.removeClass("in"),
            a.support.transition && g.hasClass("fade")
              ? g.one("bsTransitionEnd", c).emulateTransitionEnd(d.TRANSITION_DURATION)
              : c());
      });
    var e = a.fn.alert;
    (a.fn.alert = b),
      (a.fn.alert.Constructor = d),
      (a.fn.alert.noConflict = function () {
        return (a.fn.alert = e), this;
      }),
      a(document).on("click.bs.alert.data-api", c, d.prototype.close);
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.button"),
          f = "object" == typeof b && b;
        e || d.data("bs.button", (e = new c(this, f))),
          "toggle" == b ? e.toggle() : b && e.setState(b);
      });
    }
    var c = function (b, d) {
      (this.$element = a(b)), (this.options = a.extend({}, c.DEFAULTS, d)), (this.isLoading = !1);
    };
    (c.VERSION = "3.3.7"),
      (c.DEFAULTS = { loadingText: "loading..." }),
      (c.prototype.setState = function (b) {
        var c = "disabled",
          d = this.$element,
          e = d.is("input") ? "val" : "html",
          f = d.data();
        (b += "Text"),
          null == f.resetText && d.data("resetText", d[e]()),
          setTimeout(
            a.proxy(function () {
              d[e](null == f[b] ? this.options[b] : f[b]),
                "loadingText" == b
                  ? ((this.isLoading = !0), d.addClass(c).attr(c, c).prop(c, !0))
                  : this.isLoading &&
                    ((this.isLoading = !1), d.removeClass(c).removeAttr(c).prop(c, !1));
            }, this),
            0
          );
      }),
      (c.prototype.toggle = function () {
        var a = !0,
          b = this.$element.closest('[data-toggle="buttons"]');
        if (b.length) {
          var c = this.$element.find("input");
          "radio" == c.prop("type")
            ? (c.prop("checked") && (a = !1),
              b.find(".active").removeClass("active"),
              this.$element.addClass("active"))
            : "checkbox" == c.prop("type") &&
              (c.prop("checked") !== this.$element.hasClass("active") && (a = !1),
              this.$element.toggleClass("active")),
            c.prop("checked", this.$element.hasClass("active")),
            a && c.trigger("change");
        } else
          this.$element.attr("aria-pressed", !this.$element.hasClass("active")),
            this.$element.toggleClass("active");
      });
    var d = a.fn.button;
    (a.fn.button = b),
      (a.fn.button.Constructor = c),
      (a.fn.button.noConflict = function () {
        return (a.fn.button = d), this;
      }),
      a(document)
        .on("click.bs.button.data-api", '[data-toggle^="button"]', function (c) {
          var d = a(c.target).closest(".btn");
          b.call(d, "toggle"),
            a(c.target).is('input[type="radio"], input[type="checkbox"]') ||
              (c.preventDefault(),
              d.is("input,button")
                ? d.trigger("focus")
                : d.find("input:visible,button:visible").first().trigger("focus"));
        })
        .on(
          "focus.bs.button.data-api blur.bs.button.data-api",
          '[data-toggle^="button"]',
          function (b) {
            a(b.target)
              .closest(".btn")
              .toggleClass("focus", /^focus(in)?$/.test(b.type));
          }
        );
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.carousel"),
          f = a.extend({}, c.DEFAULTS, d.data(), "object" == typeof b && b),
          g = "string" == typeof b ? b : f.slide;
        e || d.data("bs.carousel", (e = new c(this, f))),
          "number" == typeof b ? e.to(b) : g ? e[g]() : f.interval && e.pause().cycle();
      });
    }
    var c = function (b, c) {
      (this.$element = a(b)),
        (this.$indicators = this.$element.find(".carousel-indicators")),
        (this.options = c),
        (this.paused = null),
        (this.sliding = null),
        (this.interval = null),
        (this.$active = null),
        (this.$items = null),
        this.options.keyboard &&
          this.$element.on("keydown.bs.carousel", a.proxy(this.keydown, this)),
        "hover" == this.options.pause &&
          !("ontouchstart" in document.documentElement) &&
          this.$element
            .on("mouseenter.bs.carousel", a.proxy(this.pause, this))
            .on("mouseleave.bs.carousel", a.proxy(this.cycle, this));
    };
    (c.VERSION = "3.3.7"),
      (c.TRANSITION_DURATION = 600),
      (c.DEFAULTS = { interval: 5e3, pause: "hover", wrap: !0, keyboard: !0 }),
      (c.prototype.keydown = function (a) {
        if (!/input|textarea/i.test(a.target.tagName)) {
          switch (a.which) {
            case 37:
              this.prev();
              break;
            case 39:
              this.next();
              break;
            default:
              return;
          }
          a.preventDefault();
        }
      }),
      (c.prototype.cycle = function (b) {
        return (
          b || (this.paused = !1),
          this.interval && clearInterval(this.interval),
          this.options.interval &&
            !this.paused &&
            (this.interval = setInterval(a.proxy(this.next, this), this.options.interval)),
          this
        );
      }),
      (c.prototype.getItemIndex = function (a) {
        return (this.$items = a.parent().children(".item")), this.$items.index(a || this.$active);
      }),
      (c.prototype.getItemForDirection = function (a, b) {
        var c = this.getItemIndex(b),
          d = ("prev" == a && 0 === c) || ("next" == a && c == this.$items.length - 1);
        if (d && !this.options.wrap) return b;
        var e = "prev" == a ? -1 : 1,
          f = (c + e) % this.$items.length;
        return this.$items.eq(f);
      }),
      (c.prototype.to = function (a) {
        var b = this,
          c = this.getItemIndex((this.$active = this.$element.find(".item.active")));
        if (!(a > this.$items.length - 1 || a < 0))
          return this.sliding
            ? this.$element.one("slid.bs.carousel", function () {
                b.to(a);
              })
            : c == a
            ? this.pause().cycle()
            : this.slide(a > c ? "next" : "prev", this.$items.eq(a));
      }),
      (c.prototype.pause = function (b) {
        return (
          b || (this.paused = !0),
          this.$element.find(".next, .prev").length &&
            a.support.transition &&
            (this.$element.trigger(a.support.transition.end), this.cycle(!0)),
          (this.interval = clearInterval(this.interval)),
          this
        );
      }),
      (c.prototype.next = function () {
        if (!this.sliding) return this.slide("next");
      }),
      (c.prototype.prev = function () {
        if (!this.sliding) return this.slide("prev");
      }),
      (c.prototype.slide = function (b, d) {
        var e = this.$element.find(".item.active"),
          f = d || this.getItemForDirection(b, e),
          g = this.interval,
          h = "next" == b ? "left" : "right",
          i = this;
        if (f.hasClass("active")) return (this.sliding = !1);
        var j = f[0],
          k = a.Event("slide.bs.carousel", { relatedTarget: j, direction: h });
        if ((this.$element.trigger(k), !k.isDefaultPrevented())) {
          if (((this.sliding = !0), g && this.pause(), this.$indicators.length)) {
            this.$indicators.find(".active").removeClass("active");
            var l = a(this.$indicators.children()[this.getItemIndex(f)]);
            l && l.addClass("active");
          }
          var m = a.Event("slid.bs.carousel", { relatedTarget: j, direction: h });
          return (
            a.support.transition && this.$element.hasClass("slide")
              ? (f.addClass(b),
                f[0].offsetWidth,
                e.addClass(h),
                f.addClass(h),
                e
                  .one("bsTransitionEnd", function () {
                    f.removeClass([b, h].join(" ")).addClass("active"),
                      e.removeClass(["active", h].join(" ")),
                      (i.sliding = !1),
                      setTimeout(function () {
                        i.$element.trigger(m);
                      }, 0);
                  })
                  .emulateTransitionEnd(c.TRANSITION_DURATION))
              : (e.removeClass("active"),
                f.addClass("active"),
                (this.sliding = !1),
                this.$element.trigger(m)),
            g && this.cycle(),
            this
          );
        }
      });
    var d = a.fn.carousel;
    (a.fn.carousel = b),
      (a.fn.carousel.Constructor = c),
      (a.fn.carousel.noConflict = function () {
        return (a.fn.carousel = d), this;
      });
    var e = function (c) {
      var d,
        e = a(this),
        f = a(e.attr("data-target") || ((d = e.attr("href")) && d.replace(/.*(?=#[^\s]+$)/, "")));
      if (f.hasClass("carousel")) {
        var g = a.extend({}, f.data(), e.data()),
          h = e.attr("data-slide-to");
        h && (g.interval = !1), b.call(f, g), h && f.data("bs.carousel").to(h), c.preventDefault();
      }
    };
    a(document)
      .on("click.bs.carousel.data-api", "[data-slide]", e)
      .on("click.bs.carousel.data-api", "[data-slide-to]", e),
      a(window).on("load", function () {
        a('[data-ride="carousel"]').each(function () {
          var c = a(this);
          b.call(c, c.data());
        });
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      var c,
        d = b.attr("data-target") || ((c = b.attr("href")) && c.replace(/.*(?=#[^\s]+$)/, ""));
      return a(d);
    }
    function c(b) {
      return this.each(function () {
        var c = a(this),
          e = c.data("bs.collapse"),
          f = a.extend({}, d.DEFAULTS, c.data(), "object" == typeof b && b);
        !e && f.toggle && /show|hide/.test(b) && (f.toggle = !1),
          e || c.data("bs.collapse", (e = new d(this, f))),
          "string" == typeof b && e[b]();
      });
    }
    var d = function (b, c) {
      (this.$element = a(b)),
        (this.options = a.extend({}, d.DEFAULTS, c)),
        (this.$trigger = a(
          '[data-toggle="collapse"][href="#' +
            b.id +
            '"],[data-toggle="collapse"][data-target="#' +
            b.id +
            '"]'
        )),
        (this.transitioning = null),
        this.options.parent
          ? (this.$parent = this.getParent())
          : this.addAriaAndCollapsedClass(this.$element, this.$trigger),
        this.options.toggle && this.toggle();
    };
    (d.VERSION = "3.3.7"),
      (d.TRANSITION_DURATION = 350),
      (d.DEFAULTS = { toggle: !0 }),
      (d.prototype.dimension = function () {
        var a = this.$element.hasClass("width");
        return a ? "width" : "height";
      }),
      (d.prototype.show = function () {
        if (!this.transitioning && !this.$element.hasClass("in")) {
          var b,
            e = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");
          if (!(e && e.length && ((b = e.data("bs.collapse")), b && b.transitioning))) {
            var f = a.Event("show.bs.collapse");
            if ((this.$element.trigger(f), !f.isDefaultPrevented())) {
              e && e.length && (c.call(e, "hide"), b || e.data("bs.collapse", null));
              var g = this.dimension();
              this.$element
                .removeClass("collapse")
                .addClass("collapsing")
                [g](0)
                .attr("aria-expanded", !0),
                this.$trigger.removeClass("collapsed").attr("aria-expanded", !0),
                (this.transitioning = 1);
              var h = function () {
                this.$element.removeClass("collapsing").addClass("collapse in")[g](""),
                  (this.transitioning = 0),
                  this.$element.trigger("shown.bs.collapse");
              };
              if (!a.support.transition) return h.call(this);
              var i = a.camelCase(["scroll", g].join("-"));
              this.$element
                .one("bsTransitionEnd", a.proxy(h, this))
                .emulateTransitionEnd(d.TRANSITION_DURATION)
                [g](this.$element[0][i]);
            }
          }
        }
      }),
      (d.prototype.hide = function () {
        if (!this.transitioning && this.$element.hasClass("in")) {
          var b = a.Event("hide.bs.collapse");
          if ((this.$element.trigger(b), !b.isDefaultPrevented())) {
            var c = this.dimension();
            this.$element[c](this.$element[c]())[0].offsetHeight,
              this.$element
                .addClass("collapsing")
                .removeClass("collapse in")
                .attr("aria-expanded", !1),
              this.$trigger.addClass("collapsed").attr("aria-expanded", !1),
              (this.transitioning = 1);
            var e = function () {
              (this.transitioning = 0),
                this.$element
                  .removeClass("collapsing")
                  .addClass("collapse")
                  .trigger("hidden.bs.collapse");
            };
            return a.support.transition
              ? void this.$element[c](0)
                  .one("bsTransitionEnd", a.proxy(e, this))
                  .emulateTransitionEnd(d.TRANSITION_DURATION)
              : e.call(this);
          }
        }
      }),
      (d.prototype.toggle = function () {
        this[this.$element.hasClass("in") ? "hide" : "show"]();
      }),
      (d.prototype.getParent = function () {
        return a(this.options.parent)
          .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
          .each(
            a.proxy(function (c, d) {
              var e = a(d);
              this.addAriaAndCollapsedClass(b(e), e);
            }, this)
          )
          .end();
      }),
      (d.prototype.addAriaAndCollapsedClass = function (a, b) {
        var c = a.hasClass("in");
        a.attr("aria-expanded", c), b.toggleClass("collapsed", !c).attr("aria-expanded", c);
      });
    var e = a.fn.collapse;
    (a.fn.collapse = c),
      (a.fn.collapse.Constructor = d),
      (a.fn.collapse.noConflict = function () {
        return (a.fn.collapse = e), this;
      }),
      a(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function (d) {
        var e = a(this);
        e.attr("data-target") || d.preventDefault();
        var f = b(e),
          g = f.data("bs.collapse"),
          h = g ? "toggle" : e.data();
        c.call(f, h);
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      var c = b.attr("data-target");
      c ||
        ((c = b.attr("href")), (c = c && /#[A-Za-z]/.test(c) && c.replace(/.*(?=#[^\s]*$)/, "")));
      var d = c && a(c);
      return d && d.length ? d : b.parent();
    }
    function c(c) {
      (c && 3 === c.which) ||
        (a(e).remove(),
        a(f).each(function () {
          var d = a(this),
            e = b(d),
            f = { relatedTarget: this };
          e.hasClass("open") &&
            ((c &&
              "click" == c.type &&
              /input|textarea/i.test(c.target.tagName) &&
              a.contains(e[0], c.target)) ||
              (e.trigger((c = a.Event("hide.bs.dropdown", f))),
              c.isDefaultPrevented() ||
                (d.attr("aria-expanded", "false"),
                e.removeClass("open").trigger(a.Event("hidden.bs.dropdown", f)))));
        }));
    }
    function d(b) {
      return this.each(function () {
        var c = a(this),
          d = c.data("bs.dropdown");
        d || c.data("bs.dropdown", (d = new g(this))), "string" == typeof b && d[b].call(c);
      });
    }
    var e = ".dropdown-backdrop",
      f = '[data-toggle="dropdown"]',
      g = function (b) {
        a(b).on("click.bs.dropdown", this.toggle);
      };
    (g.VERSION = "3.3.7"),
      (g.prototype.toggle = function (d) {
        var e = a(this);
        if (!e.is(".disabled, :disabled")) {
          var f = b(e),
            g = f.hasClass("open");
          if ((c(), !g)) {
            "ontouchstart" in document.documentElement &&
              !f.closest(".navbar-nav").length &&
              a(document.createElement("div"))
                .addClass("dropdown-backdrop")
                .insertAfter(a(this))
                .on("click", c);
            var h = { relatedTarget: this };
            if ((f.trigger((d = a.Event("show.bs.dropdown", h))), d.isDefaultPrevented())) return;
            e.trigger("focus").attr("aria-expanded", "true"),
              f.toggleClass("open").trigger(a.Event("shown.bs.dropdown", h));
          }
          return !1;
        }
      }),
      (g.prototype.keydown = function (c) {
        if (/(38|40|27|32)/.test(c.which) && !/input|textarea/i.test(c.target.tagName)) {
          var d = a(this);
          if ((c.preventDefault(), c.stopPropagation(), !d.is(".disabled, :disabled"))) {
            var e = b(d),
              g = e.hasClass("open");
            if ((!g && 27 != c.which) || (g && 27 == c.which))
              return 27 == c.which && e.find(f).trigger("focus"), d.trigger("click");
            var h = " li:not(.disabled):visible a",
              i = e.find(".dropdown-menu" + h);
            if (i.length) {
              var j = i.index(c.target);
              38 == c.which && j > 0 && j--,
                40 == c.which && j < i.length - 1 && j++,
                ~j || (j = 0),
                i.eq(j).trigger("focus");
            }
          }
        }
      });
    var h = a.fn.dropdown;
    (a.fn.dropdown = d),
      (a.fn.dropdown.Constructor = g),
      (a.fn.dropdown.noConflict = function () {
        return (a.fn.dropdown = h), this;
      }),
      a(document)
        .on("click.bs.dropdown.data-api", c)
        .on("click.bs.dropdown.data-api", ".dropdown form", function (a) {
          a.stopPropagation();
        })
        .on("click.bs.dropdown.data-api", f, g.prototype.toggle)
        .on("keydown.bs.dropdown.data-api", f, g.prototype.keydown)
        .on("keydown.bs.dropdown.data-api", ".dropdown-menu", g.prototype.keydown);
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b, d) {
      return this.each(function () {
        var e = a(this),
          f = e.data("bs.modal"),
          g = a.extend({}, c.DEFAULTS, e.data(), "object" == typeof b && b);
        f || e.data("bs.modal", (f = new c(this, g))),
          "string" == typeof b ? f[b](d) : g.show && f.show(d);
      });
    }
    var c = function (b, c) {
      (this.options = c),
        (this.$body = a(document.body)),
        (this.$element = a(b)),
        (this.$dialog = this.$element.find(".modal-dialog")),
        (this.$backdrop = null),
        (this.isShown = null),
        (this.originalBodyPad = null),
        (this.scrollbarWidth = 0),
        (this.ignoreBackdropClick = !1),
        this.options.remote &&
          this.$element.find(".modal-content").load(
            this.options.remote,
            a.proxy(function () {
              this.$element.trigger("loaded.bs.modal");
            }, this)
          );
    };
    (c.VERSION = "3.3.7"),
      (c.TRANSITION_DURATION = 300),
      (c.BACKDROP_TRANSITION_DURATION = 150),
      (c.DEFAULTS = { backdrop: !0, keyboard: !0, show: !0 }),
      (c.prototype.toggle = function (a) {
        return this.isShown ? this.hide() : this.show(a);
      }),
      (c.prototype.show = function (b) {
        var d = this,
          e = a.Event("show.bs.modal", { relatedTarget: b });
        this.$element.trigger(e),
          this.isShown ||
            e.isDefaultPrevented() ||
            ((this.isShown = !0),
            this.checkScrollbar(),
            this.setScrollbar(),
            this.$body.addClass("modal-open"),
            this.escape(),
            this.resize(),
            this.$element.on(
              "click.dismiss.bs.modal",
              '[data-dismiss="modal"]',
              a.proxy(this.hide, this)
            ),
            this.$dialog.on("mousedown.dismiss.bs.modal", function () {
              d.$element.one("mouseup.dismiss.bs.modal", function (b) {
                a(b.target).is(d.$element) && (d.ignoreBackdropClick = !0);
              });
            }),
            this.backdrop(function () {
              var e = a.support.transition && d.$element.hasClass("fade");
              d.$element.parent().length || d.$element.appendTo(d.$body),
                d.$element.show().scrollTop(0),
                d.adjustDialog(),
                e && d.$element[0].offsetWidth,
                d.$element.addClass("in"),
                d.enforceFocus();
              var f = a.Event("shown.bs.modal", { relatedTarget: b });
              e
                ? d.$dialog
                    .one("bsTransitionEnd", function () {
                      d.$element.trigger("focus").trigger(f);
                    })
                    .emulateTransitionEnd(c.TRANSITION_DURATION)
                : d.$element.trigger("focus").trigger(f);
            }));
      }),
      (c.prototype.hide = function (b) {
        b && b.preventDefault(),
          (b = a.Event("hide.bs.modal")),
          this.$element.trigger(b),
          this.isShown &&
            !b.isDefaultPrevented() &&
            ((this.isShown = !1),
            this.escape(),
            this.resize(),
            a(document).off("focusin.bs.modal"),
            this.$element
              .removeClass("in")
              .off("click.dismiss.bs.modal")
              .off("mouseup.dismiss.bs.modal"),
            this.$dialog.off("mousedown.dismiss.bs.modal"),
            a.support.transition && this.$element.hasClass("fade")
              ? this.$element
                  .one("bsTransitionEnd", a.proxy(this.hideModal, this))
                  .emulateTransitionEnd(c.TRANSITION_DURATION)
              : this.hideModal());
      }),
      (c.prototype.enforceFocus = function () {
        a(document)
          .off("focusin.bs.modal")
          .on(
            "focusin.bs.modal",
            a.proxy(function (a) {
              document === a.target ||
                this.$element[0] === a.target ||
                this.$element.has(a.target).length ||
                this.$element.trigger("focus");
            }, this)
          );
      }),
      (c.prototype.escape = function () {
        this.isShown && this.options.keyboard
          ? this.$element.on(
              "keydown.dismiss.bs.modal",
              a.proxy(function (a) {
                27 == a.which && this.hide();
              }, this)
            )
          : this.isShown || this.$element.off("keydown.dismiss.bs.modal");
      }),
      (c.prototype.resize = function () {
        this.isShown
          ? a(window).on("resize.bs.modal", a.proxy(this.handleUpdate, this))
          : a(window).off("resize.bs.modal");
      }),
      (c.prototype.hideModal = function () {
        var a = this;
        this.$element.hide(),
          this.backdrop(function () {
            a.$body.removeClass("modal-open"),
              a.resetAdjustments(),
              a.resetScrollbar(),
              a.$element.trigger("hidden.bs.modal");
          });
      }),
      (c.prototype.removeBackdrop = function () {
        this.$backdrop && this.$backdrop.remove(), (this.$backdrop = null);
      }),
      (c.prototype.backdrop = function (b) {
        var d = this,
          e = this.$element.hasClass("fade") ? "fade" : "";
        if (this.isShown && this.options.backdrop) {
          var f = a.support.transition && e;
          if (
            ((this.$backdrop = a(document.createElement("div"))
              .addClass("modal-backdrop " + e)
              .appendTo(this.$body)),
            this.$element.on(
              "click.dismiss.bs.modal",
              a.proxy(function (a) {
                return this.ignoreBackdropClick
                  ? void (this.ignoreBackdropClick = !1)
                  : void (
                      a.target === a.currentTarget &&
                      ("static" == this.options.backdrop ? this.$element[0].focus() : this.hide())
                    );
              }, this)
            ),
            f && this.$backdrop[0].offsetWidth,
            this.$backdrop.addClass("in"),
            !b)
          )
            return;
          f
            ? this.$backdrop
                .one("bsTransitionEnd", b)
                .emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION)
            : b();
        } else if (!this.isShown && this.$backdrop) {
          this.$backdrop.removeClass("in");
          var g = function () {
            d.removeBackdrop(), b && b();
          };
          a.support.transition && this.$element.hasClass("fade")
            ? this.$backdrop
                .one("bsTransitionEnd", g)
                .emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION)
            : g();
        } else b && b();
      }),
      (c.prototype.handleUpdate = function () {
        this.adjustDialog();
      }),
      (c.prototype.adjustDialog = function () {
        var a = this.$element[0].scrollHeight > document.documentElement.clientHeight;
        this.$element.css({
          paddingLeft: !this.bodyIsOverflowing && a ? this.scrollbarWidth : "",
          paddingRight: this.bodyIsOverflowing && !a ? this.scrollbarWidth : "",
        });
      }),
      (c.prototype.resetAdjustments = function () {
        this.$element.css({ paddingLeft: "", paddingRight: "" });
      }),
      (c.prototype.checkScrollbar = function () {
        var a = window.innerWidth;
        if (!a) {
          var b = document.documentElement.getBoundingClientRect();
          a = b.right - Math.abs(b.left);
        }
        (this.bodyIsOverflowing = document.body.clientWidth < a),
          (this.scrollbarWidth = this.measureScrollbar());
      }),
      (c.prototype.setScrollbar = function () {
        var a = parseInt(this.$body.css("padding-right") || 0, 10);
        (this.originalBodyPad = document.body.style.paddingRight || ""),
          this.bodyIsOverflowing && this.$body.css("padding-right", a + this.scrollbarWidth);
      }),
      (c.prototype.resetScrollbar = function () {
        this.$body.css("padding-right", this.originalBodyPad);
      }),
      (c.prototype.measureScrollbar = function () {
        var a = document.createElement("div");
        (a.className = "modal-scrollbar-measure"), this.$body.append(a);
        var b = a.offsetWidth - a.clientWidth;
        return this.$body[0].removeChild(a), b;
      });
    var d = a.fn.modal;
    (a.fn.modal = b),
      (a.fn.modal.Constructor = c),
      (a.fn.modal.noConflict = function () {
        return (a.fn.modal = d), this;
      }),
      a(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function (c) {
        var d = a(this),
          e = d.attr("href"),
          f = a(d.attr("data-target") || (e && e.replace(/.*(?=#[^\s]+$)/, ""))),
          g = f.data("bs.modal")
            ? "toggle"
            : a.extend({ remote: !/#/.test(e) && e }, f.data(), d.data());
        d.is("a") && c.preventDefault(),
          f.one("show.bs.modal", function (a) {
            a.isDefaultPrevented() ||
              f.one("hidden.bs.modal", function () {
                d.is(":visible") && d.trigger("focus");
              });
          }),
          b.call(f, g, this);
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.tooltip"),
          f = "object" == typeof b && b;
        (!e && /destroy|hide/.test(b)) ||
          (e || d.data("bs.tooltip", (e = new c(this, f))), "string" == typeof b && e[b]());
      });
    }
    var c = function (a, b) {
      (this.type = null),
        (this.options = null),
        (this.enabled = null),
        (this.timeout = null),
        (this.hoverState = null),
        (this.$element = null),
        (this.inState = null),
        this.init("tooltip", a, b);
    };
    (c.VERSION = "3.3.7"),
      (c.TRANSITION_DURATION = 150),
      (c.DEFAULTS = {
        animation: !0,
        placement: "top",
        selector: !1,
        template:
          '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: !1,
        container: !1,
        viewport: { selector: "body", padding: 0 },
      }),
      (c.prototype.init = function (b, c, d) {
        if (
          ((this.enabled = !0),
          (this.type = b),
          (this.$element = a(c)),
          (this.options = this.getOptions(d)),
          (this.$viewport =
            this.options.viewport &&
            a(
              a.isFunction(this.options.viewport)
                ? this.options.viewport.call(this, this.$element)
                : this.options.viewport.selector || this.options.viewport
            )),
          (this.inState = { click: !1, hover: !1, focus: !1 }),
          this.$element[0] instanceof document.constructor && !this.options.selector)
        )
          throw new Error(
            "`selector` option must be specified when initializing " +
              this.type +
              " on the window.document object!"
          );
        for (var e = this.options.trigger.split(" "), f = e.length; f--; ) {
          var g = e[f];
          if ("click" == g)
            this.$element.on(
              "click." + this.type,
              this.options.selector,
              a.proxy(this.toggle, this)
            );
          else if ("manual" != g) {
            var h = "hover" == g ? "mouseenter" : "focusin",
              i = "hover" == g ? "mouseleave" : "focusout";
            this.$element.on(h + "." + this.type, this.options.selector, a.proxy(this.enter, this)),
              this.$element.on(
                i + "." + this.type,
                this.options.selector,
                a.proxy(this.leave, this)
              );
          }
        }
        this.options.selector
          ? (this._options = a.extend({}, this.options, { trigger: "manual", selector: "" }))
          : this.fixTitle();
      }),
      (c.prototype.getDefaults = function () {
        return c.DEFAULTS;
      }),
      (c.prototype.getOptions = function (b) {
        return (
          (b = a.extend({}, this.getDefaults(), this.$element.data(), b)),
          b.delay && "number" == typeof b.delay && (b.delay = { show: b.delay, hide: b.delay }),
          b
        );
      }),
      (c.prototype.getDelegateOptions = function () {
        var b = {},
          c = this.getDefaults();
        return (
          this._options &&
            a.each(this._options, function (a, d) {
              c[a] != d && (b[a] = d);
            }),
          b
        );
      }),
      (c.prototype.enter = function (b) {
        var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);
        return (
          c ||
            ((c = new this.constructor(b.currentTarget, this.getDelegateOptions())),
            a(b.currentTarget).data("bs." + this.type, c)),
          b instanceof a.Event && (c.inState["focusin" == b.type ? "focus" : "hover"] = !0),
          c.tip().hasClass("in") || "in" == c.hoverState
            ? void (c.hoverState = "in")
            : (clearTimeout(c.timeout),
              (c.hoverState = "in"),
              c.options.delay && c.options.delay.show
                ? void (c.timeout = setTimeout(function () {
                    "in" == c.hoverState && c.show();
                  }, c.options.delay.show))
                : c.show())
        );
      }),
      (c.prototype.isInStateTrue = function () {
        for (var a in this.inState) if (this.inState[a]) return !0;
        return !1;
      }),
      (c.prototype.leave = function (b) {
        var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);
        if (
          (c ||
            ((c = new this.constructor(b.currentTarget, this.getDelegateOptions())),
            a(b.currentTarget).data("bs." + this.type, c)),
          b instanceof a.Event && (c.inState["focusout" == b.type ? "focus" : "hover"] = !1),
          !c.isInStateTrue())
        )
          return (
            clearTimeout(c.timeout),
            (c.hoverState = "out"),
            c.options.delay && c.options.delay.hide
              ? void (c.timeout = setTimeout(function () {
                  "out" == c.hoverState && c.hide();
                }, c.options.delay.hide))
              : c.hide()
          );
      }),
      (c.prototype.show = function () {
        var b = a.Event("show.bs." + this.type);
        if (this.hasContent() && this.enabled) {
          this.$element.trigger(b);
          var d = a.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
          if (b.isDefaultPrevented() || !d) return;
          var e = this,
            f = this.tip(),
            g = this.getUID(this.type);
          this.setContent(),
            f.attr("id", g),
            this.$element.attr("aria-describedby", g),
            this.options.animation && f.addClass("fade");
          var h =
              "function" == typeof this.options.placement
                ? this.options.placement.call(this, f[0], this.$element[0])
                : this.options.placement,
            i = /\s?auto?\s?/i,
            j = i.test(h);
          j && (h = h.replace(i, "") || "top"),
            f
              .detach()
              .css({ top: 0, left: 0, display: "block" })
              .addClass(h)
              .data("bs." + this.type, this),
            this.options.container
              ? f.appendTo(this.options.container)
              : f.insertAfter(this.$element),
            this.$element.trigger("inserted.bs." + this.type);
          var k = this.getPosition(),
            l = f[0].offsetWidth,
            m = f[0].offsetHeight;
          if (j) {
            var n = h,
              o = this.getPosition(this.$viewport);
            (h =
              "bottom" == h && k.bottom + m > o.bottom
                ? "top"
                : "top" == h && k.top - m < o.top
                ? "bottom"
                : "right" == h && k.right + l > o.width
                ? "left"
                : "left" == h && k.left - l < o.left
                ? "right"
                : h),
              f.removeClass(n).addClass(h);
          }
          var p = this.getCalculatedOffset(h, k, l, m);
          this.applyPlacement(p, h);
          var q = function () {
            var a = e.hoverState;
            e.$element.trigger("shown.bs." + e.type),
              (e.hoverState = null),
              "out" == a && e.leave(e);
          };
          a.support.transition && this.$tip.hasClass("fade")
            ? f.one("bsTransitionEnd", q).emulateTransitionEnd(c.TRANSITION_DURATION)
            : q();
        }
      }),
      (c.prototype.applyPlacement = function (b, c) {
        var d = this.tip(),
          e = d[0].offsetWidth,
          f = d[0].offsetHeight,
          g = parseInt(d.css("margin-top"), 10),
          h = parseInt(d.css("margin-left"), 10);
        isNaN(g) && (g = 0),
          isNaN(h) && (h = 0),
          (b.top += g),
          (b.left += h),
          a.offset.setOffset(
            d[0],
            a.extend(
              {
                using: function (a) {
                  d.css({ top: Math.round(a.top), left: Math.round(a.left) });
                },
              },
              b
            ),
            0
          ),
          d.addClass("in");
        var i = d[0].offsetWidth,
          j = d[0].offsetHeight;
        "top" == c && j != f && (b.top = b.top + f - j);
        var k = this.getViewportAdjustedDelta(c, b, i, j);
        k.left ? (b.left += k.left) : (b.top += k.top);
        var l = /top|bottom/.test(c),
          m = l ? 2 * k.left - e + i : 2 * k.top - f + j,
          n = l ? "offsetWidth" : "offsetHeight";
        d.offset(b), this.replaceArrow(m, d[0][n], l);
      }),
      (c.prototype.replaceArrow = function (a, b, c) {
        this.arrow()
          .css(c ? "left" : "top", 50 * (1 - a / b) + "%")
          .css(c ? "top" : "left", "");
      }),
      (c.prototype.setContent = function () {
        var a = this.tip(),
          b = this.getTitle();
        a.find(".tooltip-inner")[this.options.html ? "html" : "text"](b),
          a.removeClass("fade in top bottom left right");
      }),
      (c.prototype.hide = function (b) {
        function d() {
          "in" != e.hoverState && f.detach(),
            e.$element && e.$element.removeAttr("aria-describedby").trigger("hidden.bs." + e.type),
            b && b();
        }
        var e = this,
          f = a(this.$tip),
          g = a.Event("hide.bs." + this.type);
        if ((this.$element.trigger(g), !g.isDefaultPrevented()))
          return (
            f.removeClass("in"),
            a.support.transition && f.hasClass("fade")
              ? f.one("bsTransitionEnd", d).emulateTransitionEnd(c.TRANSITION_DURATION)
              : d(),
            (this.hoverState = null),
            this
          );
      }),
      (c.prototype.fixTitle = function () {
        var a = this.$element;
        (a.attr("title") || "string" != typeof a.attr("data-original-title")) &&
          a.attr("data-original-title", a.attr("title") || "").attr("title", "");
      }),
      (c.prototype.hasContent = function () {
        return this.getTitle();
      }),
      (c.prototype.getPosition = function (b) {
        b = b || this.$element;
        var c = b[0],
          d = "BODY" == c.tagName,
          e = c.getBoundingClientRect();
        null == e.width &&
          (e = a.extend({}, e, { width: e.right - e.left, height: e.bottom - e.top }));
        var f = window.SVGElement && c instanceof window.SVGElement,
          g = d ? { top: 0, left: 0 } : f ? null : b.offset(),
          h = {
            scroll: d
              ? document.documentElement.scrollTop || document.body.scrollTop
              : b.scrollTop(),
          },
          i = d ? { width: a(window).width(), height: a(window).height() } : null;
        return a.extend({}, e, h, i, g);
      }),
      (c.prototype.getCalculatedOffset = function (a, b, c, d) {
        return "bottom" == a
          ? { top: b.top + b.height, left: b.left + b.width / 2 - c / 2 }
          : "top" == a
          ? { top: b.top - d, left: b.left + b.width / 2 - c / 2 }
          : "left" == a
          ? { top: b.top + b.height / 2 - d / 2, left: b.left - c }
          : { top: b.top + b.height / 2 - d / 2, left: b.left + b.width };
      }),
      (c.prototype.getViewportAdjustedDelta = function (a, b, c, d) {
        var e = { top: 0, left: 0 };
        if (!this.$viewport) return e;
        var f = (this.options.viewport && this.options.viewport.padding) || 0,
          g = this.getPosition(this.$viewport);
        if (/right|left/.test(a)) {
          var h = b.top - f - g.scroll,
            i = b.top + f - g.scroll + d;
          h < g.top ? (e.top = g.top - h) : i > g.top + g.height && (e.top = g.top + g.height - i);
        } else {
          var j = b.left - f,
            k = b.left + f + c;
          j < g.left ? (e.left = g.left - j) : k > g.right && (e.left = g.left + g.width - k);
        }
        return e;
      }),
      (c.prototype.getTitle = function () {
        var a,
          b = this.$element,
          c = this.options;
        return (a =
          b.attr("data-original-title") ||
          ("function" == typeof c.title ? c.title.call(b[0]) : c.title));
      }),
      (c.prototype.getUID = function (a) {
        do a += ~~(1e6 * Math.random());
        while (document.getElementById(a));
        return a;
      }),
      (c.prototype.tip = function () {
        if (!this.$tip && ((this.$tip = a(this.options.template)), 1 != this.$tip.length))
          throw new Error(
            this.type + " `template` option must consist of exactly 1 top-level element!"
          );
        return this.$tip;
      }),
      (c.prototype.arrow = function () {
        return (this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow"));
      }),
      (c.prototype.enable = function () {
        this.enabled = !0;
      }),
      (c.prototype.disable = function () {
        this.enabled = !1;
      }),
      (c.prototype.toggleEnabled = function () {
        this.enabled = !this.enabled;
      }),
      (c.prototype.toggle = function (b) {
        var c = this;
        b &&
          ((c = a(b.currentTarget).data("bs." + this.type)),
          c ||
            ((c = new this.constructor(b.currentTarget, this.getDelegateOptions())),
            a(b.currentTarget).data("bs." + this.type, c))),
          b
            ? ((c.inState.click = !c.inState.click), c.isInStateTrue() ? c.enter(c) : c.leave(c))
            : c.tip().hasClass("in")
            ? c.leave(c)
            : c.enter(c);
      }),
      (c.prototype.destroy = function () {
        var a = this;
        clearTimeout(this.timeout),
          this.hide(function () {
            a.$element.off("." + a.type).removeData("bs." + a.type),
              a.$tip && a.$tip.detach(),
              (a.$tip = null),
              (a.$arrow = null),
              (a.$viewport = null),
              (a.$element = null);
          });
      });
    var d = a.fn.tooltip;
    (a.fn.tooltip = b),
      (a.fn.tooltip.Constructor = c),
      (a.fn.tooltip.noConflict = function () {
        return (a.fn.tooltip = d), this;
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.popover"),
          f = "object" == typeof b && b;
        (!e && /destroy|hide/.test(b)) ||
          (e || d.data("bs.popover", (e = new c(this, f))), "string" == typeof b && e[b]());
      });
    }
    var c = function (a, b) {
      this.init("popover", a, b);
    };
    if (!a.fn.tooltip) throw new Error("Popover requires tooltip.js");
    (c.VERSION = "3.3.7"),
      (c.DEFAULTS = a.extend({}, a.fn.tooltip.Constructor.DEFAULTS, {
        placement: "right",
        trigger: "click",
        content: "",
        template:
          '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
      })),
      (c.prototype = a.extend({}, a.fn.tooltip.Constructor.prototype)),
      (c.prototype.constructor = c),
      (c.prototype.getDefaults = function () {
        return c.DEFAULTS;
      }),
      (c.prototype.setContent = function () {
        var a = this.tip(),
          b = this.getTitle(),
          c = this.getContent();
        a.find(".popover-title")[this.options.html ? "html" : "text"](b),
          a
            .find(".popover-content")
            .children()
            .detach()
            .end()
            [this.options.html ? ("string" == typeof c ? "html" : "append") : "text"](c),
          a.removeClass("fade top bottom left right in"),
          a.find(".popover-title").html() || a.find(".popover-title").hide();
      }),
      (c.prototype.hasContent = function () {
        return this.getTitle() || this.getContent();
      }),
      (c.prototype.getContent = function () {
        var a = this.$element,
          b = this.options;
        return (
          a.attr("data-content") ||
          ("function" == typeof b.content ? b.content.call(a[0]) : b.content)
        );
      }),
      (c.prototype.arrow = function () {
        return (this.$arrow = this.$arrow || this.tip().find(".arrow"));
      });
    var d = a.fn.popover;
    (a.fn.popover = b),
      (a.fn.popover.Constructor = c),
      (a.fn.popover.noConflict = function () {
        return (a.fn.popover = d), this;
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(c, d) {
      (this.$body = a(document.body)),
        (this.$scrollElement = a(a(c).is(document.body) ? window : c)),
        (this.options = a.extend({}, b.DEFAULTS, d)),
        (this.selector = (this.options.target || "") + " .nav li > a"),
        (this.offsets = []),
        (this.targets = []),
        (this.activeTarget = null),
        (this.scrollHeight = 0),
        this.$scrollElement.on("scroll.bs.scrollspy", a.proxy(this.process, this)),
        this.refresh(),
        this.process();
    }
    function c(c) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.scrollspy"),
          f = "object" == typeof c && c;
        e || d.data("bs.scrollspy", (e = new b(this, f))), "string" == typeof c && e[c]();
      });
    }
    (b.VERSION = "3.3.7"),
      (b.DEFAULTS = { offset: 10 }),
      (b.prototype.getScrollHeight = function () {
        return (
          this.$scrollElement[0].scrollHeight ||
          Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
        );
      }),
      (b.prototype.refresh = function () {
        var b = this,
          c = "offset",
          d = 0;
        (this.offsets = []),
          (this.targets = []),
          (this.scrollHeight = this.getScrollHeight()),
          a.isWindow(this.$scrollElement[0]) ||
            ((c = "position"), (d = this.$scrollElement.scrollTop())),
          this.$body
            .find(this.selector)
            .map(function () {
              var b = a(this),
                e = b.data("target") || b.attr("href"),
                f = /^#./.test(e) && a(e);
              return (f && f.length && f.is(":visible") && [[f[c]().top + d, e]]) || null;
            })
            .sort(function (a, b) {
              return a[0] - b[0];
            })
            .each(function () {
              b.offsets.push(this[0]), b.targets.push(this[1]);
            });
      }),
      (b.prototype.process = function () {
        var a,
          b = this.$scrollElement.scrollTop() + this.options.offset,
          c = this.getScrollHeight(),
          d = this.options.offset + c - this.$scrollElement.height(),
          e = this.offsets,
          f = this.targets,
          g = this.activeTarget;
        if ((this.scrollHeight != c && this.refresh(), b >= d))
          return g != (a = f[f.length - 1]) && this.activate(a);
        if (g && b < e[0]) return (this.activeTarget = null), this.clear();
        for (a = e.length; a--; )
          g != f[a] && b >= e[a] && (void 0 === e[a + 1] || b < e[a + 1]) && this.activate(f[a]);
      }),
      (b.prototype.activate = function (b) {
        (this.activeTarget = b), this.clear();
        var c = this.selector + '[data-target="' + b + '"],' + this.selector + '[href="' + b + '"]',
          d = a(c).parents("li").addClass("active");
        d.parent(".dropdown-menu").length && (d = d.closest("li.dropdown").addClass("active")),
          d.trigger("activate.bs.scrollspy");
      }),
      (b.prototype.clear = function () {
        a(this.selector).parentsUntil(this.options.target, ".active").removeClass("active");
      });
    var d = a.fn.scrollspy;
    (a.fn.scrollspy = c),
      (a.fn.scrollspy.Constructor = b),
      (a.fn.scrollspy.noConflict = function () {
        return (a.fn.scrollspy = d), this;
      }),
      a(window).on("load.bs.scrollspy.data-api", function () {
        a('[data-spy="scroll"]').each(function () {
          var b = a(this);
          c.call(b, b.data());
        });
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.tab");
        e || d.data("bs.tab", (e = new c(this))), "string" == typeof b && e[b]();
      });
    }
    var c = function (b) {
      this.element = a(b);
    };
    (c.VERSION = "3.3.7"),
      (c.TRANSITION_DURATION = 150),
      (c.prototype.show = function () {
        var b = this.element,
          c = b.closest("ul:not(.dropdown-menu)"),
          d = b.data("target");
        if (
          (d || ((d = b.attr("href")), (d = d && d.replace(/.*(?=#[^\s]*$)/, ""))),
          !b.parent("li").hasClass("active"))
        ) {
          var e = c.find(".active:last a"),
            f = a.Event("hide.bs.tab", { relatedTarget: b[0] }),
            g = a.Event("show.bs.tab", { relatedTarget: e[0] });
          if ((e.trigger(f), b.trigger(g), !g.isDefaultPrevented() && !f.isDefaultPrevented())) {
            var h = a(d);
            this.activate(b.closest("li"), c),
              this.activate(h, h.parent(), function () {
                e.trigger({ type: "hidden.bs.tab", relatedTarget: b[0] }),
                  b.trigger({ type: "shown.bs.tab", relatedTarget: e[0] });
              });
          }
        }
      }),
      (c.prototype.activate = function (b, d, e) {
        function f() {
          g
            .removeClass("active")
            .find("> .dropdown-menu > .active")
            .removeClass("active")
            .end()
            .find('[data-toggle="tab"]')
            .attr("aria-expanded", !1),
            b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", !0),
            h ? (b[0].offsetWidth, b.addClass("in")) : b.removeClass("fade"),
            b.parent(".dropdown-menu").length &&
              b
                .closest("li.dropdown")
                .addClass("active")
                .end()
                .find('[data-toggle="tab"]')
                .attr("aria-expanded", !0),
            e && e();
        }
        var g = d.find("> .active"),
          h =
            e &&
            a.support.transition &&
            ((g.length && g.hasClass("fade")) || !!d.find("> .fade").length);
        g.length && h
          ? g.one("bsTransitionEnd", f).emulateTransitionEnd(c.TRANSITION_DURATION)
          : f(),
          g.removeClass("in");
      });
    var d = a.fn.tab;
    (a.fn.tab = b),
      (a.fn.tab.Constructor = c),
      (a.fn.tab.noConflict = function () {
        return (a.fn.tab = d), this;
      });
    var e = function (c) {
      c.preventDefault(), b.call(a(this), "show");
    };
    a(document)
      .on("click.bs.tab.data-api", '[data-toggle="tab"]', e)
      .on("click.bs.tab.data-api", '[data-toggle="pill"]', e);
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.affix"),
          f = "object" == typeof b && b;
        e || d.data("bs.affix", (e = new c(this, f))), "string" == typeof b && e[b]();
      });
    }
    var c = function (b, d) {
      (this.options = a.extend({}, c.DEFAULTS, d)),
        (this.$target = a(this.options.target)
          .on("scroll.bs.affix.data-api", a.proxy(this.checkPosition, this))
          .on("click.bs.affix.data-api", a.proxy(this.checkPositionWithEventLoop, this))),
        (this.$element = a(b)),
        (this.affixed = null),
        (this.unpin = null),
        (this.pinnedOffset = null),
        this.checkPosition();
    };
    (c.VERSION = "3.3.7"),
      (c.RESET = "affix affix-top affix-bottom"),
      (c.DEFAULTS = { offset: 0, target: window }),
      (c.prototype.getState = function (a, b, c, d) {
        var e = this.$target.scrollTop(),
          f = this.$element.offset(),
          g = this.$target.height();
        if (null != c && "top" == this.affixed) return e < c && "top";
        if ("bottom" == this.affixed)
          return null != c ? !(e + this.unpin <= f.top) && "bottom" : !(e + g <= a - d) && "bottom";
        var h = null == this.affixed,
          i = h ? e : f.top,
          j = h ? g : b;
        return null != c && e <= c ? "top" : null != d && i + j >= a - d && "bottom";
      }),
      (c.prototype.getPinnedOffset = function () {
        if (this.pinnedOffset) return this.pinnedOffset;
        this.$element.removeClass(c.RESET).addClass("affix");
        var a = this.$target.scrollTop(),
          b = this.$element.offset();
        return (this.pinnedOffset = b.top - a);
      }),
      (c.prototype.checkPositionWithEventLoop = function () {
        setTimeout(a.proxy(this.checkPosition, this), 1);
      }),
      (c.prototype.checkPosition = function () {
        if (this.$element.is(":visible")) {
          var b = this.$element.height(),
            d = this.options.offset,
            e = d.top,
            f = d.bottom,
            g = Math.max(a(document).height(), a(document.body).height());
          "object" != typeof d && (f = e = d),
            "function" == typeof e && (e = d.top(this.$element)),
            "function" == typeof f && (f = d.bottom(this.$element));
          var h = this.getState(g, b, e, f);
          if (this.affixed != h) {
            null != this.unpin && this.$element.css("top", "");
            var i = "affix" + (h ? "-" + h : ""),
              j = a.Event(i + ".bs.affix");
            if ((this.$element.trigger(j), j.isDefaultPrevented())) return;
            (this.affixed = h),
              (this.unpin = "bottom" == h ? this.getPinnedOffset() : null),
              this.$element
                .removeClass(c.RESET)
                .addClass(i)
                .trigger(i.replace("affix", "affixed") + ".bs.affix");
          }
          "bottom" == h && this.$element.offset({ top: g - b - f });
        }
      });
    var d = a.fn.affix;
    (a.fn.affix = b),
      (a.fn.affix.Constructor = c),
      (a.fn.affix.noConflict = function () {
        return (a.fn.affix = d), this;
      }),
      a(window).on("load", function () {
        a('[data-spy="affix"]').each(function () {
          var c = a(this),
            d = c.data();
          (d.offset = d.offset || {}),
            null != d.offsetBottom && (d.offset.bottom = d.offsetBottom),
            null != d.offsetTop && (d.offset.top = d.offsetTop),
            b.call(c, d);
        });
      });
  })(jQuery);

/**
 * @preserve
 * Project: Bootstrap Hover Dropdown
 * Author: Cameron Spear
 * Version: v2.0.11
 * Contributors: Mattia Larentis
 * Dependencies: Bootstrap's Dropdown plugin, jQuery
 * Description: A simple plugin to enable Bootstrap dropdowns to active on hover and provide a nice user experience.
 * License: MIT
 * Homepage: http://cameronspear.com/blog/bootstrap-dropdown-on-hover-plugin/
 */
!(function ($, n, e) {
  var o = $();
  ($.fn.dropdownHover = function (e) {
    return "ontouchstart" in document
      ? this
      : ((o = o.add(this.parent())),
        this.each(function () {
          function t(e) {
            o.find(":focus").blur(),
              h.instantlyCloseOthers === !0 && o.removeClass("open"),
              n.clearTimeout(c),
              i.addClass("open"),
              r.trigger(a);
          }
          var r = $(this),
            i = r.parent(),
            d = { delay: 500, instantlyCloseOthers: !0 },
            s = {
              delay: $(this).data("delay"),
              instantlyCloseOthers: $(this).data("close-others"),
            },
            a = "show.bs.dropdown",
            u = "hide.bs.dropdown",
            h = $.extend(!0, {}, d, e, s),
            c;
          i.hover(
            function (n) {
              return i.hasClass("open") || r.is(n.target) ? void t(n) : !0;
            },
            function () {
              c = n.setTimeout(function () {
                i.removeClass("open"), r.trigger(u);
              }, h.delay);
            }
          ),
            r.hover(function (n) {
              return i.hasClass("open") || i.is(n.target) ? void t(n) : !0;
            }),
            i.find(".dropdown-submenu").each(function () {
              var e = $(this),
                o;
              e.hover(
                function () {
                  n.clearTimeout(o),
                    e.children(".dropdown-menu").show(),
                    e.siblings().children(".dropdown-menu").hide();
                },
                function () {
                  var t = e.children(".dropdown-menu");
                  o = n.setTimeout(function () {
                    t.hide();
                  }, h.delay);
                }
              );
            });
        }));
  }),
    $(document).ready(function () {
      $('[data-hover="dropdown"]').dropdownHover();
    });
})(jQuery, this);

/////////////////////////////////////
//  Responsive Grids
/////////////////////////////////////

/**
 * jquery-match-height master by @liabru
 * http://brm.io/jquery-match-height/
 * License: MIT
 */

!(function (t) {
  "use strict";
  "function" == typeof define && define.amd
    ? define(["jquery"], t)
    : "undefined" != typeof module && module.exports
    ? (module.exports = t(require("jquery")))
    : t(jQuery);
})(function (t) {
  var e = -1,
    o = -1,
    a = function (t) {
      return parseFloat(t) || 0;
    },
    i = function (e) {
      var o = 1,
        i = t(e),
        n = null,
        r = [];
      return (
        i.each(function () {
          var e = t(this),
            i = e.offset().top - a(e.css("margin-top")),
            s = r.length > 0 ? r[r.length - 1] : null;
          null === s
            ? r.push(e)
            : Math.floor(Math.abs(n - i)) <= o
            ? (r[r.length - 1] = s.add(e))
            : r.push(e),
            (n = i);
        }),
        r
      );
    },
    n = function (e) {
      var o = { byRow: !0, property: "height", target: null, remove: !1 };
      return "object" == typeof e
        ? t.extend(o, e)
        : ("boolean" == typeof e ? (o.byRow = e) : "remove" === e && (o.remove = !0), o);
    },
    r = (t.fn.matchHeight = function (e) {
      var o = n(e);
      if (o.remove) {
        var a = this;
        return (
          this.css(o.property, ""),
          t.each(r._groups, function (t, e) {
            e.elements = e.elements.not(a);
          }),
          this
        );
      }
      return this.length <= 1 && !o.target
        ? this
        : (r._groups.push({ elements: this, options: o }), r._apply(this, o), this);
    });
  (r.version = "master"),
    (r._groups = []),
    (r._throttle = 80),
    (r._maintainScroll = !1),
    (r._beforeUpdate = null),
    (r._afterUpdate = null),
    (r._rows = i),
    (r._parse = a),
    (r._parseOptions = n),
    (r._apply = function (e, o) {
      var s = n(o),
        h = t(e),
        l = [h],
        c = t(window).scrollTop(),
        p = t("html").outerHeight(!0),
        d = h.parents().filter(":hidden");
      return (
        d.each(function () {
          var e = t(this);
          e.data("style-cache", e.attr("style"));
        }),
        d.css("display", "block"),
        s.byRow &&
          !s.target &&
          (h.each(function () {
            var e = t(this),
              o = e.css("display");
            "inline-block" !== o && "flex" !== o && "inline-flex" !== o && (o = "block"),
              e.data("style-cache", e.attr("style")),
              e.css({
                display: o,
                "padding-top": "0",
                "padding-bottom": "0",
                "margin-top": "0",
                "margin-bottom": "0",
                "border-top-width": "0",
                "border-bottom-width": "0",
                height: "100px",
                overflow: "hidden",
              });
          }),
          (l = i(h)),
          h.each(function () {
            var e = t(this);
            e.attr("style", e.data("style-cache") || "");
          })),
        t.each(l, function (e, o) {
          var i = t(o),
            n = 0;
          if (s.target) n = s.target.outerHeight(!1);
          else {
            if (s.byRow && i.length <= 1) return void i.css(s.property, "");
            i.each(function () {
              var e = t(this),
                o = e.attr("style"),
                a = e.css("display");
              "inline-block" !== a && "flex" !== a && "inline-flex" !== a && (a = "block");
              var i = { display: a };
              (i[s.property] = ""),
                e.css(i),
                e.outerHeight(!1) > n && (n = e.outerHeight(!1)),
                o ? e.attr("style", o) : e.css("display", "");
            });
          }
          i.each(function () {
            var e = t(this),
              o = 0;
            (s.target && e.is(s.target)) ||
              ("border-box" !== e.css("box-sizing") &&
                ((o += a(e.css("border-top-width")) + a(e.css("border-bottom-width"))),
                (o += a(e.css("padding-top")) + a(e.css("padding-bottom")))),
              e.css(s.property, n - o + "px"));
          });
        }),
        d.each(function () {
          var e = t(this);
          e.attr("style", e.data("style-cache") || null);
        }),
        r._maintainScroll && t(window).scrollTop((c / p) * t("html").outerHeight(!0)),
        this
      );
    }),
    (r._applyDataApi = function () {
      var e = {};
      t("[data-match-height], [data-mh]").each(function () {
        var o = t(this),
          a = o.attr("data-mh") || o.attr("data-match-height");
        a in e ? (e[a] = e[a].add(o)) : (e[a] = o);
      }),
        t.each(e, function () {
          this.matchHeight(!0);
        });
    });
  var s = function (e) {
    r._beforeUpdate && r._beforeUpdate(e, r._groups),
      t.each(r._groups, function () {
        r._apply(this.elements, this.options);
      }),
      r._afterUpdate && r._afterUpdate(e, r._groups);
  };
  (r._update = function (a, i) {
    if (i && "resize" === i.type) {
      var n = t(window).width();
      if (n === e) return;
      e = n;
    }
    a
      ? -1 === o &&
        (o = setTimeout(function () {
          s(i), (o = -1);
        }, r._throttle))
      : s(i);
  }),
    t(r._applyDataApi),
    t(window).bind("load", function (t) {
      r._update(!1, t);
    }),
    t(window).bind("resize orientationchange", function (t) {
      r._update(!0, t);
    });
});

/////////////////////////////////////
//  jQuery Waypoints
/////////////////////////////////////

// Generated by CoffeeScript 1.4.0
/*
jQuery Waypoints - v2.0.2
Copyright (c) 2011-2013 Caleb Troughton
Dual licensed under the MIT license and GPL license.
https://github.com/imakewebthings/jquery-waypoints/blob/master/licenses.txt
*/
(function () {
  var t =
      [].indexOf ||
      function (t) {
        for (var e = 0, n = this.length; e < n; e++) {
          if (e in this && this[e] === t) return e;
        }
        return -1;
      },
    e = [].slice;
  (function (t, e) {
    if (typeof define === "function" && define.amd) {
      return define("waypoints", ["jquery"], function (n) {
        return e(n, t);
      });
    } else {
      return e(t.jQuery, t);
    }
  })(this, function (n, r) {
    var i, o, l, s, f, u, a, c, h, d, p, y, v, w, g, m;
    i = n(r);
    c = t.call(r, "ontouchstart") >= 0;
    s = { horizontal: {}, vertical: {} };
    f = 1;
    a = {};
    u = "waypoints-context-id";
    p = "resize.waypoints";
    y = "scroll.waypoints";
    v = 1;
    w = "waypoints-waypoint-ids";
    g = "waypoint";
    m = "waypoints";
    o = (function () {
      function t(t) {
        var e = this;
        this.$element = t;
        this.element = t[0];
        this.didResize = false;
        this.didScroll = false;
        this.id = "context" + f++;
        this.oldScroll = { x: t.scrollLeft(), y: t.scrollTop() };
        this.waypoints = { horizontal: {}, vertical: {} };
        t.data(u, this.id);
        a[this.id] = this;
        t.bind(y, function () {
          var t;
          if (!(e.didScroll || c)) {
            e.didScroll = true;
            t = function () {
              e.doScroll();
              return (e.didScroll = false);
            };
            return r.setTimeout(t, n[m].settings.scrollThrottle);
          }
        });
        t.bind(p, function () {
          var t;
          if (!e.didResize) {
            e.didResize = true;
            t = function () {
              n[m]("refresh");
              return (e.didResize = false);
            };
            return r.setTimeout(t, n[m].settings.resizeThrottle);
          }
        });
      }
      t.prototype.doScroll = function () {
        var t,
          e = this;
        t = {
          horizontal: {
            newScroll: this.$element.scrollLeft(),
            oldScroll: this.oldScroll.x,
            forward: "right",
            backward: "left",
          },
          vertical: {
            newScroll: this.$element.scrollTop(),
            oldScroll: this.oldScroll.y,
            forward: "down",
            backward: "up",
          },
        };
        if (c && (!t.vertical.oldScroll || !t.vertical.newScroll)) {
          n[m]("refresh");
        }
        n.each(t, function (t, r) {
          var i, o, l;
          l = [];
          o = r.newScroll > r.oldScroll;
          i = o ? r.forward : r.backward;
          n.each(e.waypoints[t], function (t, e) {
            var n, i;
            if (r.oldScroll < (n = e.offset) && n <= r.newScroll) {
              return l.push(e);
            } else if (r.newScroll < (i = e.offset) && i <= r.oldScroll) {
              return l.push(e);
            }
          });
          l.sort(function (t, e) {
            return t.offset - e.offset;
          });
          if (!o) {
            l.reverse();
          }
          return n.each(l, function (t, e) {
            if (e.options.continuous || t === l.length - 1) {
              return e.trigger([i]);
            }
          });
        });
        return (this.oldScroll = { x: t.horizontal.newScroll, y: t.vertical.newScroll });
      };
      t.prototype.refresh = function () {
        var t,
          e,
          r,
          i = this;
        r = n.isWindow(this.element);
        e = this.$element.offset();
        this.doScroll();
        t = {
          horizontal: {
            contextOffset: r ? 0 : e.left,
            contextScroll: r ? 0 : this.oldScroll.x,
            contextDimension: this.$element.width(),
            oldScroll: this.oldScroll.x,
            forward: "right",
            backward: "left",
            offsetProp: "left",
          },
          vertical: {
            contextOffset: r ? 0 : e.top,
            contextScroll: r ? 0 : this.oldScroll.y,
            contextDimension: r ? n[m]("viewportHeight") : this.$element.height(),
            oldScroll: this.oldScroll.y,
            forward: "down",
            backward: "up",
            offsetProp: "top",
          },
        };
        return n.each(t, function (t, e) {
          return n.each(i.waypoints[t], function (t, r) {
            var i, o, l, s, f;
            i = r.options.offset;
            l = r.offset;
            o = n.isWindow(r.element) ? 0 : r.$element.offset()[e.offsetProp];
            if (n.isFunction(i)) {
              i = i.apply(r.element);
            } else if (typeof i === "string") {
              i = parseFloat(i);
              if (r.options.offset.indexOf("%") > -1) {
                i = Math.ceil((e.contextDimension * i) / 100);
              }
            }
            r.offset = o - e.contextOffset + e.contextScroll - i;
            if ((r.options.onlyOnScroll && l != null) || !r.enabled) {
              return;
            }
            if (l !== null && l < (s = e.oldScroll) && s <= r.offset) {
              return r.trigger([e.backward]);
            } else if (l !== null && l > (f = e.oldScroll) && f >= r.offset) {
              return r.trigger([e.forward]);
            } else if (l === null && e.oldScroll >= r.offset) {
              return r.trigger([e.forward]);
            }
          });
        });
      };
      t.prototype.checkEmpty = function () {
        if (
          n.isEmptyObject(this.waypoints.horizontal) &&
          n.isEmptyObject(this.waypoints.vertical)
        ) {
          this.$element.unbind([p, y].join(" "));
          return delete a[this.id];
        }
      };
      return t;
    })();
    l = (function () {
      function t(t, e, r) {
        var i, o;
        r = n.extend({}, n.fn[g].defaults, r);
        if (r.offset === "bottom-in-view") {
          r.offset = function () {
            var t;
            t = n[m]("viewportHeight");
            if (!n.isWindow(e.element)) {
              t = e.$element.height();
            }
            return t - n(this).outerHeight();
          };
        }
        this.$element = t;
        this.element = t[0];
        this.axis = r.horizontal ? "horizontal" : "vertical";
        this.callback = r.handler;
        this.context = e;
        this.enabled = r.enabled;
        this.id = "waypoints" + v++;
        this.offset = null;
        this.options = r;
        e.waypoints[this.axis][this.id] = this;
        s[this.axis][this.id] = this;
        i = (o = t.data(w)) != null ? o : [];
        i.push(this.id);
        t.data(w, i);
      }
      t.prototype.trigger = function (t) {
        if (!this.enabled) {
          return;
        }
        if (this.callback != null) {
          this.callback.apply(this.element, t);
        }
        if (this.options.triggerOnce) {
          return this.destroy();
        }
      };
      t.prototype.disable = function () {
        return (this.enabled = false);
      };
      t.prototype.enable = function () {
        this.context.refresh();
        return (this.enabled = true);
      };
      t.prototype.destroy = function () {
        delete s[this.axis][this.id];
        delete this.context.waypoints[this.axis][this.id];
        return this.context.checkEmpty();
      };
      t.getWaypointsByElement = function (t) {
        var e, r;
        r = n(t).data(w);
        if (!r) {
          return [];
        }
        e = n.extend({}, s.horizontal, s.vertical);
        return n.map(r, function (t) {
          return e[t];
        });
      };
      return t;
    })();
    d = {
      init: function (t, e) {
        var r;
        if (e == null) {
          e = {};
        }
        if ((r = e.handler) == null) {
          e.handler = t;
        }
        this.each(function () {
          var t, r, i, s;
          t = n(this);
          i = (s = e.context) != null ? s : n.fn[g].defaults.context;
          if (!n.isWindow(i)) {
            i = t.closest(i);
          }
          i = n(i);
          r = a[i.data(u)];
          if (!r) {
            r = new o(i);
          }
          return new l(t, r, e);
        });
        n[m]("refresh");
        return this;
      },
      disable: function () {
        return d._invoke(this, "disable");
      },
      enable: function () {
        return d._invoke(this, "enable");
      },
      destroy: function () {
        return d._invoke(this, "destroy");
      },
      prev: function (t, e) {
        return d._traverse.call(this, t, e, function (t, e, n) {
          if (e > 0) {
            return t.push(n[e - 1]);
          }
        });
      },
      next: function (t, e) {
        return d._traverse.call(this, t, e, function (t, e, n) {
          if (e < n.length - 1) {
            return t.push(n[e + 1]);
          }
        });
      },
      _traverse: function (t, e, i) {
        var o, l;
        if (t == null) {
          t = "vertical";
        }
        if (e == null) {
          e = r;
        }
        l = h.aggregate(e);
        o = [];
        this.each(function () {
          var e;
          e = n.inArray(this, l[t]);
          return i(o, e, l[t]);
        });
        return this.pushStack(o);
      },
      _invoke: function (t, e) {
        t.each(function () {
          var t;
          t = l.getWaypointsByElement(this);
          return n.each(t, function (t, n) {
            n[e]();
            return true;
          });
        });
        return this;
      },
    };
    n.fn[g] = function () {
      var t, r;
      (r = arguments[0]), (t = 2 <= arguments.length ? e.call(arguments, 1) : []);
      if (d[r]) {
        return d[r].apply(this, t);
      } else if (n.isFunction(r)) {
        return d.init.apply(this, arguments);
      } else if (n.isPlainObject(r)) {
        return d.init.apply(this, [null, r]);
      } else if (!r) {
        return n.error("jQuery Waypoints needs a callback function or handler option.");
      } else {
        return n.error("The " + r + " method does not exist in jQuery Waypoints.");
      }
    };
    n.fn[g].defaults = {
      context: r,
      continuous: true,
      enabled: true,
      horizontal: false,
      offset: 0,
      triggerOnce: false,
    };
    h = {
      refresh: function () {
        return n.each(a, function (t, e) {
          return e.refresh();
        });
      },
      viewportHeight: function () {
        var t;
        return (t = r.innerHeight) != null ? t : i.height();
      },
      aggregate: function (t) {
        var e, r, i;
        e = s;
        if (t) {
          e = (i = a[n(t).data(u)]) != null ? i.waypoints : void 0;
        }
        if (!e) {
          return [];
        }
        r = { horizontal: [], vertical: [] };
        n.each(r, function (t, i) {
          n.each(e[t], function (t, e) {
            return i.push(e);
          });
          i.sort(function (t, e) {
            return t.offset - e.offset;
          });
          r[t] = n.map(i, function (t) {
            return t.element;
          });
          return (r[t] = n.unique(r[t]));
        });
        return r;
      },
      above: function (t) {
        if (t == null) {
          t = r;
        }
        return h._filter(t, "vertical", function (t, e) {
          return e.offset <= t.oldScroll.y;
        });
      },
      below: function (t) {
        if (t == null) {
          t = r;
        }
        return h._filter(t, "vertical", function (t, e) {
          return e.offset > t.oldScroll.y;
        });
      },
      left: function (t) {
        if (t == null) {
          t = r;
        }
        return h._filter(t, "horizontal", function (t, e) {
          return e.offset <= t.oldScroll.x;
        });
      },
      right: function (t) {
        if (t == null) {
          t = r;
        }
        return h._filter(t, "horizontal", function (t, e) {
          return e.offset > t.oldScroll.x;
        });
      },
      enable: function () {
        return h._invoke("enable");
      },
      disable: function () {
        return h._invoke("disable");
      },
      destroy: function () {
        return h._invoke("destroy");
      },
      extendFn: function (t, e) {
        return (d[t] = e);
      },
      _invoke: function (t) {
        var e;
        e = n.extend({}, s.vertical, s.horizontal);
        return n.each(e, function (e, n) {
          n[t]();
          return true;
        });
      },
      _filter: function (t, e, r) {
        var i, o;
        i = a[n(t).data(u)];
        if (!i) {
          return [];
        }
        o = [];
        n.each(i.waypoints[e], function (t, e) {
          if (r(i, e)) {
            return o.push(e);
          }
        });
        o.sort(function (t, e) {
          return t.offset - e.offset;
        });
        return n.map(o, function (t) {
          return t.element;
        });
      },
    };
    n[m] = function () {
      var t, n;
      (n = arguments[0]), (t = 2 <= arguments.length ? e.call(arguments, 1) : []);
      if (h[n]) {
        return h[n].apply(null, t);
      } else {
        return h.aggregate.call(null, n);
      }
    };
    n[m].settings = { resizeThrottle: 100, scrollThrottle: 30 };
    return i.load(function () {
      return n[m]("refresh");
    });
  });
}).call(this);

/*
 * jQuery FlexSlider v2.7.0
 * Copyright 2012 WooThemes
 * Contributing Author: Tyler Smith
 */ !(function ($) {
  var e = !0;
  ($.flexslider = function (t, a) {
    var n = $(t);
    void 0 === a.rtl && "rtl" == $("html").attr("dir") && (a.rtl = !0),
      (n.vars = $.extend({}, $.flexslider.defaults, a));
    var i = n.vars.namespace,
      r = window.navigator && window.navigator.msPointerEnabled && window.MSGesture,
      s =
        ("ontouchstart" in window ||
          r ||
          (window.DocumentTouch && document instanceof DocumentTouch)) &&
        n.vars.touch,
      o = "click touchend MSPointerUp keyup",
      l = "",
      c,
      d = "vertical" === n.vars.direction,
      u = n.vars.reverse,
      v = n.vars.itemWidth > 0,
      p = "fade" === n.vars.animation,
      m = "" !== n.vars.asNavFor,
      f = {};
    $.data(t, "flexslider", n),
      (f = {
        init: function () {
          (n.animating = !1),
            (n.currentSlide = parseInt(n.vars.startAt ? n.vars.startAt : 0, 10)),
            isNaN(n.currentSlide) && (n.currentSlide = 0),
            (n.animatingTo = n.currentSlide),
            (n.atEnd = 0 === n.currentSlide || n.currentSlide === n.last),
            (n.containerSelector = n.vars.selector.substr(0, n.vars.selector.search(" "))),
            (n.slides = $(n.vars.selector, n)),
            (n.container = $(n.containerSelector, n)),
            (n.count = n.slides.length),
            (n.syncExists = $(n.vars.sync).length > 0),
            "slide" === n.vars.animation && (n.vars.animation = "swing"),
            (n.prop = d ? "top" : n.vars.rtl ? "marginRight" : "marginLeft"),
            (n.args = {}),
            (n.manualPause = !1),
            (n.stopped = !1),
            (n.started = !1),
            (n.startTimeout = null),
            (n.transitions =
              !n.vars.video &&
              !p &&
              n.vars.useCSS &&
              (function () {
                var e = document.createElement("div"),
                  t = [
                    "perspectiveProperty",
                    "WebkitPerspective",
                    "MozPerspective",
                    "OPerspective",
                    "msPerspective",
                  ];
                for (var a in t)
                  if (void 0 !== e.style[t[a]])
                    return (
                      (n.pfx = t[a].replace("Perspective", "").toLowerCase()),
                      (n.prop = "-" + n.pfx + "-transform"),
                      !0
                    );
                return !1;
              })()),
            (n.ensureAnimationEnd = ""),
            "" !== n.vars.controlsContainer &&
              (n.controlsContainer =
                $(n.vars.controlsContainer).length > 0 && $(n.vars.controlsContainer)),
            "" !== n.vars.manualControls &&
              (n.manualControls = $(n.vars.manualControls).length > 0 && $(n.vars.manualControls)),
            "" !== n.vars.customDirectionNav &&
              (n.customDirectionNav =
                2 === $(n.vars.customDirectionNav).length && $(n.vars.customDirectionNav)),
            n.vars.randomize &&
              (n.slides.sort(function () {
                return Math.round(Math.random()) - 0.5;
              }),
              n.container.empty().append(n.slides)),
            n.doMath(),
            n.setup("init"),
            n.vars.controlNav && f.controlNav.setup(),
            n.vars.directionNav && f.directionNav.setup(),
            n.vars.keyboard &&
              (1 === $(n.containerSelector).length || n.vars.multipleKeyboard) &&
              $(document).bind("keyup", function (e) {
                var t = e.keyCode;
                if (!n.animating && (39 === t || 37 === t)) {
                  var a = n.vars.rtl
                    ? 37 === t
                      ? n.getTarget("next")
                      : 39 === t && n.getTarget("prev")
                    : 39 === t
                    ? n.getTarget("next")
                    : 37 === t && n.getTarget("prev");
                  n.flexAnimate(a, n.vars.pauseOnAction);
                }
              }),
            n.vars.mousewheel &&
              n.bind("mousewheel", function (e, t, a, i) {
                e.preventDefault();
                var r = t < 0 ? n.getTarget("next") : n.getTarget("prev");
                n.flexAnimate(r, n.vars.pauseOnAction);
              }),
            n.vars.pausePlay && f.pausePlay.setup(),
            n.vars.slideshow && n.vars.pauseInvisible && f.pauseInvisible.init(),
            n.vars.slideshow &&
              (n.vars.pauseOnHover &&
                n.hover(
                  function () {
                    n.manualPlay || n.manualPause || n.pause();
                  },
                  function () {
                    n.manualPause || n.manualPlay || n.stopped || n.play();
                  }
                ),
              (n.vars.pauseInvisible && f.pauseInvisible.isHidden()) ||
                (n.vars.initDelay > 0
                  ? (n.startTimeout = setTimeout(n.play, n.vars.initDelay))
                  : n.play())),
            m && f.asNav.setup(),
            s && n.vars.touch && f.touch(),
            (!p || (p && n.vars.smoothHeight)) &&
              $(window).bind("resize orientationchange focus", f.resize),
            n.find("img").attr("draggable", "false"),
            setTimeout(function () {
              n.vars.start(n);
            }, 200);
        },
        asNav: {
          setup: function () {
            (n.asNav = !0),
              (n.animatingTo = Math.floor(n.currentSlide / n.move)),
              (n.currentItem = n.currentSlide),
              n.slides
                .removeClass(i + "active-slide")
                .eq(n.currentItem)
                .addClass(i + "active-slide"),
              r
                ? ((t._slider = n),
                  n.slides.each(function () {
                    var e = this;
                    (e._gesture = new MSGesture()),
                      (e._gesture.target = e),
                      e.addEventListener(
                        "MSPointerDown",
                        function (e) {
                          e.preventDefault(),
                            e.currentTarget._gesture &&
                              e.currentTarget._gesture.addPointer(e.pointerId);
                        },
                        !1
                      ),
                      e.addEventListener("MSGestureTap", function (e) {
                        e.preventDefault();
                        var t = $(this),
                          a = t.index();
                        $(n.vars.asNavFor).data("flexslider").animating ||
                          t.hasClass("active") ||
                          ((n.direction = n.currentItem < a ? "next" : "prev"),
                          n.flexAnimate(a, n.vars.pauseOnAction, !1, !0, !0));
                      });
                  }))
                : n.slides.on(o, function (e) {
                    e.preventDefault();
                    var t = $(this),
                      a = t.index(),
                      r;
                    (r = n.vars.rtl
                      ? -1 * (t.offset().right - $(n).scrollLeft())
                      : t.offset().left - $(n).scrollLeft()),
                      r <= 0 && t.hasClass(i + "active-slide")
                        ? n.flexAnimate(n.getTarget("prev"), !0)
                        : $(n.vars.asNavFor).data("flexslider").animating ||
                          t.hasClass(i + "active-slide") ||
                          ((n.direction = n.currentItem < a ? "next" : "prev"),
                          n.flexAnimate(a, n.vars.pauseOnAction, !1, !0, !0));
                  });
          },
        },
        controlNav: {
          setup: function () {
            n.manualControls ? f.controlNav.setupManual() : f.controlNav.setupPaging();
          },
          setupPaging: function () {
            var e = "thumbnails" === n.vars.controlNav ? "control-thumbs" : "control-paging",
              t = 1,
              a,
              r;
            if (
              ((n.controlNavScaffold = $('<ol class="' + i + "control-nav " + i + e + '"></ol>')),
              n.pagingCount > 1)
            )
              for (var s = 0; s < n.pagingCount; s++) {
                (r = n.slides.eq(s)),
                  void 0 === r.attr("data-thumb-alt") && r.attr("data-thumb-alt", "");
                var c =
                  "" !== r.attr("data-thumb-alt")
                    ? (c = ' alt="' + r.attr("data-thumb-alt") + '"')
                    : "";
                if (
                  ((a =
                    "thumbnails" === n.vars.controlNav
                      ? '<img src="' + r.attr("data-thumb") + '"' + c + "/>"
                      : '<a href="#">' + t + "</a>"),
                  "thumbnails" === n.vars.controlNav && !0 === n.vars.thumbCaptions)
                ) {
                  var d = r.attr("data-thumbcaption");
                  "" !== d &&
                    void 0 !== d &&
                    (a += '<span class="' + i + 'caption">' + d + "</span>");
                }
                n.controlNavScaffold.append("<li>" + a + "</li>"), t++;
              }
            n.controlsContainer
              ? $(n.controlsContainer).append(n.controlNavScaffold)
              : n.append(n.controlNavScaffold),
              f.controlNav.set(),
              f.controlNav.active(),
              n.controlNavScaffold.delegate("a, img", o, function (e) {
                if ((e.preventDefault(), "" === l || l === e.type)) {
                  var t = $(this),
                    a = n.controlNav.index(t);
                  t.hasClass(i + "active") ||
                    ((n.direction = a > n.currentSlide ? "next" : "prev"),
                    n.flexAnimate(a, n.vars.pauseOnAction));
                }
                "" === l && (l = e.type), f.setToClearWatchedEvent();
              });
          },
          setupManual: function () {
            (n.controlNav = n.manualControls),
              f.controlNav.active(),
              n.controlNav.bind(o, function (e) {
                if ((e.preventDefault(), "" === l || l === e.type)) {
                  var t = $(this),
                    a = n.controlNav.index(t);
                  t.hasClass(i + "active") ||
                    (a > n.currentSlide ? (n.direction = "next") : (n.direction = "prev"),
                    n.flexAnimate(a, n.vars.pauseOnAction));
                }
                "" === l && (l = e.type), f.setToClearWatchedEvent();
              });
          },
          set: function () {
            var e = "thumbnails" === n.vars.controlNav ? "img" : "a";
            n.controlNav = $(
              "." + i + "control-nav li " + e,
              n.controlsContainer ? n.controlsContainer : n
            );
          },
          active: function () {
            n.controlNav
              .removeClass(i + "active")
              .eq(n.animatingTo)
              .addClass(i + "active");
          },
          update: function (e, t) {
            n.pagingCount > 1 && "add" === e
              ? n.controlNavScaffold.append($('<li><a href="#">' + n.count + "</a></li>"))
              : 1 === n.pagingCount
              ? n.controlNavScaffold.find("li").remove()
              : n.controlNav.eq(t).closest("li").remove(),
              f.controlNav.set(),
              n.pagingCount > 1 && n.pagingCount !== n.controlNav.length
                ? n.update(t, e)
                : f.controlNav.active();
          },
        },
        directionNav: {
          setup: function () {
            var e = $(
              '<ul class="' +
                i +
                'direction-nav"><li class="' +
                i +
                'nav-prev"><a class="' +
                i +
                'prev" href="#">' +
                n.vars.prevText +
                '</a></li><li class="' +
                i +
                'nav-next"><a class="' +
                i +
                'next" href="#">' +
                n.vars.nextText +
                "</a></li></ul>"
            );
            n.customDirectionNav
              ? (n.directionNav = n.customDirectionNav)
              : n.controlsContainer
              ? ($(n.controlsContainer).append(e),
                (n.directionNav = $("." + i + "direction-nav li a", n.controlsContainer)))
              : (n.append(e), (n.directionNav = $("." + i + "direction-nav li a", n))),
              f.directionNav.update(),
              n.directionNav.bind(o, function (e) {
                e.preventDefault();
                var t;
                ("" !== l && l !== e.type) ||
                  ((t = $(this).hasClass(i + "next") ? n.getTarget("next") : n.getTarget("prev")),
                  n.flexAnimate(t, n.vars.pauseOnAction)),
                  "" === l && (l = e.type),
                  f.setToClearWatchedEvent();
              });
          },
          update: function () {
            var e = i + "disabled";
            1 === n.pagingCount
              ? n.directionNav.addClass(e).attr("tabindex", "-1")
              : n.vars.animationLoop
              ? n.directionNav.removeClass(e).removeAttr("tabindex")
              : 0 === n.animatingTo
              ? n.directionNav
                  .removeClass(e)
                  .filter("." + i + "prev")
                  .addClass(e)
                  .attr("tabindex", "-1")
              : n.animatingTo === n.last
              ? n.directionNav
                  .removeClass(e)
                  .filter("." + i + "next")
                  .addClass(e)
                  .attr("tabindex", "-1")
              : n.directionNav.removeClass(e).removeAttr("tabindex");
          },
        },
        pausePlay: {
          setup: function () {
            var e = $('<div class="' + i + 'pauseplay"><a href="#"></a></div>');
            n.controlsContainer
              ? (n.controlsContainer.append(e),
                (n.pausePlay = $("." + i + "pauseplay a", n.controlsContainer)))
              : (n.append(e), (n.pausePlay = $("." + i + "pauseplay a", n))),
              f.pausePlay.update(n.vars.slideshow ? i + "pause" : i + "play"),
              n.pausePlay.bind(o, function (e) {
                e.preventDefault(),
                  ("" !== l && l !== e.type) ||
                    ($(this).hasClass(i + "pause")
                      ? ((n.manualPause = !0), (n.manualPlay = !1), n.pause())
                      : ((n.manualPause = !1), (n.manualPlay = !0), n.play())),
                  "" === l && (l = e.type),
                  f.setToClearWatchedEvent();
              });
          },
          update: function (e) {
            "play" === e
              ? n.pausePlay
                  .removeClass(i + "pause")
                  .addClass(i + "play")
                  .html(n.vars.playText)
              : n.pausePlay
                  .removeClass(i + "play")
                  .addClass(i + "pause")
                  .html(n.vars.pauseText);
          },
        },
        touch: function () {
          function e(e) {
            e.stopPropagation(),
              n.animating
                ? e.preventDefault()
                : (n.pause(),
                  t._gesture.addPointer(e.pointerId),
                  (T = 0),
                  (c = d ? n.h : n.w),
                  (f = Number(new Date())),
                  (l =
                    v && u && n.animatingTo === n.last
                      ? 0
                      : v && u
                      ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo
                      : v && n.currentSlide === n.last
                      ? n.limit
                      : v
                      ? (n.itemW + n.vars.itemMargin) * n.move * n.currentSlide
                      : u
                      ? (n.last - n.currentSlide + n.cloneOffset) * c
                      : (n.currentSlide + n.cloneOffset) * c));
          }
          function a(e) {
            e.stopPropagation();
            var a = e.target._slider;
            if (a) {
              var n = -e.translationX,
                i = -e.translationY;
              if (
                ((T += d ? i : n),
                (m = (a.vars.rtl ? -1 : 1) * T),
                (x = d ? Math.abs(T) < Math.abs(-n) : Math.abs(T) < Math.abs(-i)),
                e.detail === e.MSGESTURE_FLAG_INERTIA)
              )
                return void setImmediate(function () {
                  t._gesture.stop();
                });
              (!x || Number(new Date()) - f > 500) &&
                (e.preventDefault(),
                !p &&
                  a.transitions &&
                  (a.vars.animationLoop ||
                    (m =
                      T /
                      ((0 === a.currentSlide && T < 0) || (a.currentSlide === a.last && T > 0)
                        ? Math.abs(T) / c + 2
                        : 1)),
                  a.setProps(l + m, "setTouch")));
            }
          }
          function i(e) {
            e.stopPropagation();
            var t = e.target._slider;
            if (t) {
              if (t.animatingTo === t.currentSlide && !x && null !== m) {
                var a = u ? -m : m,
                  n = a > 0 ? t.getTarget("next") : t.getTarget("prev");
                t.canAdvance(n) &&
                ((Number(new Date()) - f < 550 && Math.abs(a) > 50) || Math.abs(a) > c / 2)
                  ? t.flexAnimate(n, t.vars.pauseOnAction)
                  : p || t.flexAnimate(t.currentSlide, t.vars.pauseOnAction, !0);
              }
              (s = null), (o = null), (m = null), (l = null), (T = 0);
            }
          }
          var s,
            o,
            l,
            c,
            m,
            f,
            g,
            h,
            S,
            x = !1,
            y = 0,
            b = 0,
            T = 0;
          r
            ? ((t.style.msTouchAction = "none"),
              (t._gesture = new MSGesture()),
              (t._gesture.target = t),
              t.addEventListener("MSPointerDown", e, !1),
              (t._slider = n),
              t.addEventListener("MSGestureChange", a, !1),
              t.addEventListener("MSGestureEnd", i, !1))
            : ((g = function (e) {
                n.animating
                  ? e.preventDefault()
                  : (window.navigator.msPointerEnabled || 1 === e.touches.length) &&
                    (n.pause(),
                    (c = d ? n.h : n.w),
                    (f = Number(new Date())),
                    (y = e.touches[0].pageX),
                    (b = e.touches[0].pageY),
                    (l =
                      v && u && n.animatingTo === n.last
                        ? 0
                        : v && u
                        ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo
                        : v && n.currentSlide === n.last
                        ? n.limit
                        : v
                        ? (n.itemW + n.vars.itemMargin) * n.move * n.currentSlide
                        : u
                        ? (n.last - n.currentSlide + n.cloneOffset) * c
                        : (n.currentSlide + n.cloneOffset) * c),
                    (s = d ? b : y),
                    (o = d ? y : b),
                    t.addEventListener("touchmove", h, !1),
                    t.addEventListener("touchend", S, !1));
              }),
              (h = function (e) {
                (y = e.touches[0].pageX),
                  (b = e.touches[0].pageY),
                  (m = d ? s - b : (n.vars.rtl ? -1 : 1) * (s - y)),
                  (x = d ? Math.abs(m) < Math.abs(y - o) : Math.abs(m) < Math.abs(b - o));
                var t = 500;
                (!x || Number(new Date()) - f > 500) &&
                  (e.preventDefault(),
                  !p &&
                    n.transitions &&
                    (n.vars.animationLoop ||
                      (m /=
                        (0 === n.currentSlide && m < 0) || (n.currentSlide === n.last && m > 0)
                          ? Math.abs(m) / c + 2
                          : 1),
                    n.setProps(l + m, "setTouch")));
              }),
              (S = function (e) {
                if (
                  (t.removeEventListener("touchmove", h, !1),
                  n.animatingTo === n.currentSlide && !x && null !== m)
                ) {
                  var a = u ? -m : m,
                    i = a > 0 ? n.getTarget("next") : n.getTarget("prev");
                  n.canAdvance(i) &&
                  ((Number(new Date()) - f < 550 && Math.abs(a) > 50) || Math.abs(a) > c / 2)
                    ? n.flexAnimate(i, n.vars.pauseOnAction)
                    : p || n.flexAnimate(n.currentSlide, n.vars.pauseOnAction, !0);
                }
                t.removeEventListener("touchend", S, !1),
                  (s = null),
                  (o = null),
                  (m = null),
                  (l = null);
              }),
              t.addEventListener("touchstart", g, !1));
        },
        resize: function () {
          !n.animating &&
            n.is(":visible") &&
            (v || n.doMath(),
            p
              ? f.smoothHeight()
              : v
              ? (n.slides.width(n.computedW), n.update(n.pagingCount), n.setProps())
              : d
              ? (n.viewport.height(n.h), n.setProps(n.h, "setTotal"))
              : (n.vars.smoothHeight && f.smoothHeight(),
                n.newSlides.width(n.computedW),
                n.setProps(n.computedW, "setTotal")));
        },
        smoothHeight: function (e) {
          if (!d || p) {
            var t = p ? n : n.viewport;
            e
              ? t.animate({ height: n.slides.eq(n.animatingTo).innerHeight() }, e)
              : t.innerHeight(n.slides.eq(n.animatingTo).innerHeight());
          }
        },
        sync: function (e) {
          var t = $(n.vars.sync).data("flexslider"),
            a = n.animatingTo;
          switch (e) {
            case "animate":
              t.flexAnimate(a, n.vars.pauseOnAction, !1, !0);
              break;
            case "play":
              t.playing || t.asNav || t.play();
              break;
            case "pause":
              t.pause();
              break;
          }
        },
        uniqueID: function (e) {
          return (
            e
              .filter("[id]")
              .add(e.find("[id]"))
              .each(function () {
                var e = $(this);
                e.attr("id", e.attr("id") + "_clone");
              }),
            e
          );
        },
        pauseInvisible: {
          visProp: null,
          init: function () {
            var e = f.pauseInvisible.getHiddenProp();
            if (e) {
              var t = e.replace(/[H|h]idden/, "") + "visibilitychange";
              document.addEventListener(t, function () {
                f.pauseInvisible.isHidden()
                  ? n.startTimeout
                    ? clearTimeout(n.startTimeout)
                    : n.pause()
                  : n.started
                  ? n.play()
                  : n.vars.initDelay > 0
                  ? setTimeout(n.play, n.vars.initDelay)
                  : n.play();
              });
            }
          },
          isHidden: function () {
            var e = f.pauseInvisible.getHiddenProp();
            return !!e && document[e];
          },
          getHiddenProp: function () {
            var e = ["webkit", "moz", "ms", "o"];
            if ("hidden" in document) return "hidden";
            for (var t = 0; t < e.length; t++)
              if (e[t] + "Hidden" in document) return e[t] + "Hidden";
            return null;
          },
        },
        setToClearWatchedEvent: function () {
          clearTimeout(c),
            (c = setTimeout(function () {
              l = "";
            }, 3e3));
        },
      }),
      (n.flexAnimate = function (e, t, a, r, o) {
        if (
          (n.vars.animationLoop ||
            e === n.currentSlide ||
            (n.direction = e > n.currentSlide ? "next" : "prev"),
          m && 1 === n.pagingCount && (n.direction = n.currentItem < e ? "next" : "prev"),
          !n.animating && (n.canAdvance(e, o) || a) && n.is(":visible"))
        ) {
          if (m && r) {
            var l = $(n.vars.asNavFor).data("flexslider");
            if (
              ((n.atEnd = 0 === e || e === n.count - 1),
              l.flexAnimate(e, !0, !1, !0, o),
              (n.direction = n.currentItem < e ? "next" : "prev"),
              (l.direction = n.direction),
              Math.ceil((e + 1) / n.visible) - 1 === n.currentSlide || 0 === e)
            )
              return (
                (n.currentItem = e),
                n.slides
                  .removeClass(i + "active-slide")
                  .eq(e)
                  .addClass(i + "active-slide"),
                !1
              );
            (n.currentItem = e),
              n.slides
                .removeClass(i + "active-slide")
                .eq(e)
                .addClass(i + "active-slide"),
              (e = Math.floor(e / n.visible));
          }
          if (
            ((n.animating = !0),
            (n.animatingTo = e),
            t && n.pause(),
            n.vars.before(n),
            n.syncExists && !o && f.sync("animate"),
            n.vars.controlNav && f.controlNav.active(),
            v ||
              n.slides
                .removeClass(i + "active-slide")
                .eq(e)
                .addClass(i + "active-slide"),
            (n.atEnd = 0 === e || e === n.last),
            n.vars.directionNav && f.directionNav.update(),
            e === n.last && (n.vars.end(n), n.vars.animationLoop || n.pause()),
            p)
          )
            s
              ? (n.slides.eq(n.currentSlide).css({ opacity: 0, zIndex: 1 }),
                n.slides.eq(e).css({ opacity: 1, zIndex: 2 }),
                n.wrapup(c))
              : (n.slides
                  .eq(n.currentSlide)
                  .css({ zIndex: 1 })
                  .animate({ opacity: 0 }, n.vars.animationSpeed, n.vars.easing),
                n.slides
                  .eq(e)
                  .css({ zIndex: 2 })
                  .animate({ opacity: 1 }, n.vars.animationSpeed, n.vars.easing, n.wrapup));
          else {
            var c = d ? n.slides.filter(":first").height() : n.computedW,
              g,
              h,
              S;
            v
              ? ((g = n.vars.itemMargin),
                (S = (n.itemW + g) * n.move * n.animatingTo),
                (h = S > n.limit && 1 !== n.visible ? n.limit : S))
              : (h =
                  0 === n.currentSlide &&
                  e === n.count - 1 &&
                  n.vars.animationLoop &&
                  "next" !== n.direction
                    ? u
                      ? (n.count + n.cloneOffset) * c
                      : 0
                    : n.currentSlide === n.last &&
                      0 === e &&
                      n.vars.animationLoop &&
                      "prev" !== n.direction
                    ? u
                      ? 0
                      : (n.count + 1) * c
                    : u
                    ? (n.count - 1 - e + n.cloneOffset) * c
                    : (e + n.cloneOffset) * c),
              n.setProps(h, "", n.vars.animationSpeed),
              n.transitions
                ? ((n.vars.animationLoop && n.atEnd) ||
                    ((n.animating = !1), (n.currentSlide = n.animatingTo)),
                  n.container.unbind("webkitTransitionEnd transitionend"),
                  n.container.bind("webkitTransitionEnd transitionend", function () {
                    clearTimeout(n.ensureAnimationEnd), n.wrapup(c);
                  }),
                  clearTimeout(n.ensureAnimationEnd),
                  (n.ensureAnimationEnd = setTimeout(function () {
                    n.wrapup(c);
                  }, n.vars.animationSpeed + 100)))
                : n.container.animate(n.args, n.vars.animationSpeed, n.vars.easing, function () {
                    n.wrapup(c);
                  });
          }
          n.vars.smoothHeight && f.smoothHeight(n.vars.animationSpeed);
        }
      }),
      (n.wrapup = function (e) {
        p ||
          v ||
          (0 === n.currentSlide && n.animatingTo === n.last && n.vars.animationLoop
            ? n.setProps(e, "jumpEnd")
            : n.currentSlide === n.last &&
              0 === n.animatingTo &&
              n.vars.animationLoop &&
              n.setProps(e, "jumpStart")),
          (n.animating = !1),
          (n.currentSlide = n.animatingTo),
          n.vars.after(n);
      }),
      (n.animateSlides = function () {
        !n.animating && e && n.flexAnimate(n.getTarget("next"));
      }),
      (n.pause = function () {
        clearInterval(n.animatedSlides),
          (n.animatedSlides = null),
          (n.playing = !1),
          n.vars.pausePlay && f.pausePlay.update("play"),
          n.syncExists && f.sync("pause");
      }),
      (n.play = function () {
        n.playing && clearInterval(n.animatedSlides),
          (n.animatedSlides =
            n.animatedSlides || setInterval(n.animateSlides, n.vars.slideshowSpeed)),
          (n.started = n.playing = !0),
          n.vars.pausePlay && f.pausePlay.update("pause"),
          n.syncExists && f.sync("play");
      }),
      (n.stop = function () {
        n.pause(), (n.stopped = !0);
      }),
      (n.canAdvance = function (e, t) {
        var a = m ? n.pagingCount - 1 : n.last;
        return (
          !!t ||
          !(!m || n.currentItem !== n.count - 1 || 0 !== e || "prev" !== n.direction) ||
          ((!m || 0 !== n.currentItem || e !== n.pagingCount - 1 || "next" === n.direction) &&
            !(e === n.currentSlide && !m) &&
            (!!n.vars.animationLoop ||
              ((!n.atEnd || 0 !== n.currentSlide || e !== a || "next" === n.direction) &&
                (!n.atEnd || n.currentSlide !== a || 0 !== e || "next" !== n.direction))))
        );
      }),
      (n.getTarget = function (e) {
        return (
          (n.direction = e),
          "next" === e
            ? n.currentSlide === n.last
              ? 0
              : n.currentSlide + 1
            : 0 === n.currentSlide
            ? n.last
            : n.currentSlide - 1
        );
      }),
      (n.setProps = function (e, t, a) {
        var i = (function () {
          var a = e || (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo;
          return (
            (function () {
              if (v)
                return "setTouch" === t
                  ? e
                  : u && n.animatingTo === n.last
                  ? 0
                  : u
                  ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo
                  : n.animatingTo === n.last
                  ? n.limit
                  : a;
              switch (t) {
                case "setTotal":
                  return u
                    ? (n.count - 1 - n.currentSlide + n.cloneOffset) * e
                    : (n.currentSlide + n.cloneOffset) * e;
                case "setTouch":
                  return e;
                case "jumpEnd":
                  return u ? e : n.count * e;
                case "jumpStart":
                  return u ? n.count * e : e;
                default:
                  return e;
              }
            })() *
              (n.vars.rtl ? 1 : -1) +
            "px"
          );
        })();
        n.transitions &&
          ((i = d
            ? "translate3d(0," + i + ",0)"
            : "translate3d(" + (n.vars.rtl ? -1 : 1) * parseInt(i) + "px,0,0)"),
          (a = void 0 !== a ? a / 1e3 + "s" : "0s"),
          n.container.css("-" + n.pfx + "-transition-duration", a),
          n.container.css("transition-duration", a)),
          (n.args[n.prop] = i),
          (n.transitions || void 0 === a) && n.container.css(n.args),
          n.container.css("transform", i);
      }),
      (n.setup = function (e) {
        if (p)
          n.vars.rtl
            ? n.slides.css({
                width: "100%",
                float: "right",
                marginLeft: "-100%",
                position: "relative",
              })
            : n.slides.css({
                width: "100%",
                float: "left",
                marginRight: "-100%",
                position: "relative",
              }),
            "init" === e &&
              (s
                ? n.slides
                    .css({
                      opacity: 0,
                      display: "block",
                      webkitTransition: "opacity " + n.vars.animationSpeed / 1e3 + "s ease",
                      zIndex: 1,
                    })
                    .eq(n.currentSlide)
                    .css({ opacity: 1, zIndex: 2 })
                : 0 == n.vars.fadeFirstSlide
                ? n.slides
                    .css({ opacity: 0, display: "block", zIndex: 1 })
                    .eq(n.currentSlide)
                    .css({ zIndex: 2 })
                    .css({ opacity: 1 })
                : n.slides
                    .css({ opacity: 0, display: "block", zIndex: 1 })
                    .eq(n.currentSlide)
                    .css({ zIndex: 2 })
                    .animate({ opacity: 1 }, n.vars.animationSpeed, n.vars.easing)),
            n.vars.smoothHeight && f.smoothHeight();
        else {
          var t, a;
          "init" === e &&
            ((n.viewport = $('<div class="' + i + 'viewport"></div>')
              .css({ overflow: "hidden", position: "relative" })
              .appendTo(n)
              .append(n.container)),
            (n.cloneCount = 0),
            (n.cloneOffset = 0),
            u &&
              ((a = $.makeArray(n.slides).reverse()),
              (n.slides = $(a)),
              n.container.empty().append(n.slides))),
            n.vars.animationLoop &&
              !v &&
              ((n.cloneCount = 2),
              (n.cloneOffset = 1),
              "init" !== e && n.container.find(".clone").remove(),
              n.container
                .append(
                  f.uniqueID(n.slides.first().clone().addClass("clone")).attr("aria-hidden", "true")
                )
                .prepend(
                  f.uniqueID(n.slides.last().clone().addClass("clone")).attr("aria-hidden", "true")
                )),
            (n.newSlides = $(n.vars.selector, n)),
            (t = u ? n.count - 1 - n.currentSlide + n.cloneOffset : n.currentSlide + n.cloneOffset),
            d && !v
              ? (n.container
                  .height(200 * (n.count + n.cloneCount) + "%")
                  .css("position", "absolute")
                  .width("100%"),
                setTimeout(
                  function () {
                    n.newSlides.css({ display: "block" }),
                      n.doMath(),
                      n.viewport.height(n.h),
                      n.setProps(t * n.h, "init");
                  },
                  "init" === e ? 100 : 0
                ))
              : (n.container.width(200 * (n.count + n.cloneCount) + "%"),
                n.setProps(t * n.computedW, "init"),
                setTimeout(
                  function () {
                    n.doMath(),
                      n.vars.rtl,
                      n.newSlides.css({
                        width: n.computedW,
                        marginRight: n.computedM,
                        float: "left",
                        display: "block",
                      }),
                      n.vars.smoothHeight && f.smoothHeight();
                  },
                  "init" === e ? 100 : 0
                ));
        }
        v ||
          n.slides
            .removeClass(i + "active-slide")
            .eq(n.currentSlide)
            .addClass(i + "active-slide"),
          n.vars.init(n);
      }),
      (n.doMath = function () {
        var e = n.slides.first(),
          t = n.vars.itemMargin,
          a = n.vars.minItems,
          i = n.vars.maxItems;
        (n.w = void 0 === n.viewport ? n.width() : n.viewport.width()),
          (n.h = e.height()),
          (n.boxPadding = e.outerWidth() - e.width()),
          v
            ? ((n.itemT = n.vars.itemWidth + t),
              (n.itemM = t),
              (n.minW = a ? a * n.itemT : n.w),
              (n.maxW = i ? i * n.itemT - t : n.w),
              (n.itemW =
                n.minW > n.w
                  ? (n.w - t * (a - 1)) / a
                  : n.maxW < n.w
                  ? (n.w - t * (i - 1)) / i
                  : n.vars.itemWidth > n.w
                  ? n.w
                  : n.vars.itemWidth),
              (n.visible = Math.floor(n.w / n.itemW)),
              (n.move = n.vars.move > 0 && n.vars.move < n.visible ? n.vars.move : n.visible),
              (n.pagingCount = Math.ceil((n.count - n.visible) / n.move + 1)),
              (n.last = n.pagingCount - 1),
              (n.limit =
                1 === n.pagingCount
                  ? 0
                  : n.vars.itemWidth > n.w
                  ? n.itemW * (n.count - 1) + t * (n.count - 1)
                  : (n.itemW + t) * n.count - n.w - t))
            : ((n.itemW = n.w), (n.itemM = t), (n.pagingCount = n.count), (n.last = n.count - 1)),
          (n.computedW = n.itemW - n.boxPadding),
          (n.computedM = n.itemM);
      }),
      (n.update = function (e, t) {
        n.doMath(),
          v ||
            (e < n.currentSlide
              ? (n.currentSlide += 1)
              : e <= n.currentSlide && 0 !== e && (n.currentSlide -= 1),
            (n.animatingTo = n.currentSlide)),
          n.vars.controlNav &&
            !n.manualControls &&
            (("add" === t && !v) || n.pagingCount > n.controlNav.length
              ? f.controlNav.update("add")
              : (("remove" === t && !v) || n.pagingCount < n.controlNav.length) &&
                (v && n.currentSlide > n.last && ((n.currentSlide -= 1), (n.animatingTo -= 1)),
                f.controlNav.update("remove", n.last))),
          n.vars.directionNav && f.directionNav.update();
      }),
      (n.addSlide = function (e, t) {
        var a = $(e);
        (n.count += 1),
          (n.last = n.count - 1),
          d && u
            ? void 0 !== t
              ? n.slides.eq(n.count - t).after(a)
              : n.container.prepend(a)
            : void 0 !== t
            ? n.slides.eq(t).before(a)
            : n.container.append(a),
          n.update(t, "add"),
          (n.slides = $(n.vars.selector + ":not(.clone)", n)),
          n.setup(),
          n.vars.added(n);
      }),
      (n.removeSlide = function (e) {
        var t = isNaN(e) ? n.slides.index($(e)) : e;
        (n.count -= 1),
          (n.last = n.count - 1),
          isNaN(e)
            ? $(e, n.slides).remove()
            : d && u
            ? n.slides.eq(n.last).remove()
            : n.slides.eq(e).remove(),
          n.doMath(),
          n.update(t, "remove"),
          (n.slides = $(n.vars.selector + ":not(.clone)", n)),
          n.setup(),
          n.vars.removed(n);
      }),
      f.init();
  }),
    $(window)
      .blur(function (t) {
        e = !1;
      })
      .focus(function (t) {
        e = !0;
      }),
    ($.flexslider.defaults = {
      namespace: "flex-",
      selector: ".slides > li",
      animation: "fade",
      easing: "swing",
      direction: "horizontal",
      reverse: !1,
      animationLoop: !0,
      smoothHeight: !1,
      startAt: 0,
      slideshow: !0,
      slideshowSpeed: 7e3,
      animationSpeed: 600,
      initDelay: 0,
      randomize: !1,
      fadeFirstSlide: !0,
      thumbCaptions: !1,
      pauseOnAction: !0,
      pauseOnHover: !1,
      pauseInvisible: !0,
      useCSS: !0,
      touch: !0,
      video: !1,
      controlNav: !0,
      directionNav: !0,
      prevText: "Previous",
      nextText: "Next",
      keyboard: !0,
      multipleKeyboard: !1,
      mousewheel: !1,
      pausePlay: !1,
      pauseText: "Pause",
      playText: "Play",
      controlsContainer: "",
      manualControls: "",
      customDirectionNav: "",
      sync: "",
      asNavFor: "",
      itemWidth: 0,
      itemMargin: 0,
      minItems: 1,
      maxItems: 0,
      move: 0,
      allowOneSlide: !0,
      start: function () {},
      before: function () {},
      after: function () {},
      end: function () {},
      added: function () {},
      removed: function () {},
      init: function () {},
      rtl: !1,
    }),
    ($.fn.flexslider = function (e) {
      if ((void 0 === e && (e = {}), "object" == typeof e))
        return this.each(function () {
          var t = $(this),
            a = e.selector ? e.selector : ".slides > li",
            n = t.find(a);
          (1 === n.length && !1 === e.allowOneSlide) || 0 === n.length
            ? (n.fadeIn(400), e.start && e.start(t))
            : void 0 === t.data("flexslider") && new $.flexslider(this, e);
        });
      var t = $(this).data("flexslider");
      switch (e) {
        case "play":
          t.play();
          break;
        case "pause":
          t.pause();
          break;
        case "stop":
          t.stop();
          break;
        case "next":
          t.flexAnimate(t.getTarget("next"), !0);
          break;
        case "prev":
        case "previous":
          t.flexAnimate(t.getTarget("prev"), !0);
          break;
        default:
          "number" == typeof e && t.flexAnimate(e, !0);
      }
    });
})(jQuery);

/////////////////////////////////////
//  Cookie
/////////////////////////////////////

/*! jquery.cookie v1.4.0 | MIT */
!(function (a) {
  "function" == typeof define && define.amd ? define(["jquery"], a) : a(jQuery);
})(function (a) {
  function b(a) {
    return h.raw ? a : encodeURIComponent(a);
  }
  function c(a) {
    return h.raw ? a : decodeURIComponent(a);
  }
  function d(a) {
    return b(h.json ? JSON.stringify(a) : String(a));
  }
  function e(a) {
    0 === a.indexOf('"') && (a = a.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
    try {
      a = decodeURIComponent(a.replace(g, " "));
    } catch (b) {
      return;
    }
    try {
      return h.json ? JSON.parse(a) : a;
    } catch (b) {}
  }
  function f(b, c) {
    var d = h.raw ? b : e(b);
    return a.isFunction(c) ? c(d) : d;
  }
  var g = /\+/g,
    h = (a.cookie = function (e, g, i) {
      if (void 0 !== g && !a.isFunction(g)) {
        if (((i = a.extend({}, h.defaults, i)), "number" == typeof i.expires)) {
          var j = i.expires,
            k = (i.expires = new Date());
          k.setDate(k.getDate() + j);
        }
        return (document.cookie = [
          b(e),
          "=",
          d(g),
          i.expires ? "; expires=" + i.expires.toUTCString() : "",
          i.path ? "; path=" + i.path : "",
          i.domain ? "; domain=" + i.domain : "",
          i.secure ? "; secure" : "",
        ].join(""));
      }
      for (
        var l = e ? void 0 : {},
          m = document.cookie ? document.cookie.split("; ") : [],
          n = 0,
          o = m.length;
        o > n;
        n++
      ) {
        var p = m[n].split("="),
          q = c(p.shift()),
          r = p.join("=");
        if (e && e === q) {
          l = f(r, g);
          break;
        }
        e || void 0 === (r = f(r)) || (l[q] = r);
      }
      return l;
    });
  (h.defaults = {}),
    (a.removeCookie = function (b, c) {
      return void 0 !== a.cookie(b) ? (a.cookie(b, "", a.extend({}, c, { expires: -1 })), !0) : !1;
    });
});

/////////////////////////////////////
//  Content Specific Functions
/////////////////////////////////////

jQuery(function ($) {
  "use strict";

  function header() {
    var windowHeight = $(window).height();
    var windowWidth = $(window).width();

    if (windowWidth < 1200) {
      /////////////////////////////////////
      //  Disable Mobile Animated
      /////////////////////////////////////

      $("html").removeClass("noIE");
    }

    /////////////////////////////////////
    //  Home slider
    /////////////////////////////////////

    var slider = $(".home-slider .slides");
    var slider2 = $(".home-slider .slides li");
  }

  header();

  $(window).resize(function () {
    header();
  });

  /////////////////////////////////////
  //  animate elements when they are in viewport
  /////////////////////////////////////

  $(".noIE .animated").waypoint(
    function () {
      var animation = $(this).data("animation");
      $(this).addClass("animation-done").addClass(animation);
    },
    {
      triggerOnce: true,
      offset: "70%",
    }
  );

  /////////////////////////////////////
  //  Sidebar Accordion
  /////////////////////////////////////

  $(".sidebar h5").click(function (e) {
    e.preventDefault();

    $(this).parent().find(".tgl_c").slideToggle(300);
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(this).addClass("active");
    }
  });
});

$(window).load(function () {
  /////////////////////////////////////
  //  Equal-Height Grid Items
  /////////////////////////////////////

  $(".main_box").matchHeight();
  $(".template-index .view-grid .main_box > .box_1").matchHeight();
  $(".template-index .product_c.popularGrid .main_box .desc").matchHeight();
  $(
    ".template-collection #content .main_box .desc, div#content.categoryPageContent .main_box .desc"
  ).matchHeight();
  $("#footer #Subscribe span.fa").removeClass("fa-check");
  $("#footer #Subscribe span.fa").addClass("fa-angle-right");
});

/////////////////////////////////////
//  Persist Menu Drop-Downs
/////////////////////////////////////

$(window).load(function () {
  $(document).on("click", ".navbar .dropdown-menu", function (e) {
    e.stopPropagation();
  });
});

/////////////////////////////////////
//  Quick View
/////////////////////////////////////
app.selectCallback = function (variant, selector) {
  // find the matching product panel
  var productPanel = $('div.quick-view-panel[data-id="' + selector + '"]');

  // check that the panel exists
  if (productPanel.length === 0) {
    console.log("Can not find product panel");
    return;
  }

  // check that data is what we expect, and if the panel is open
  if (variant && variant.featured_image && productPanel.is(":visible")) {
    var original_image = $(".slides img", productPanel),
      new_image = variant.featured_image;
    Shopify.Image.switchImage(new_image, original_image[0]);
  }

  if (variant) {
    var indexArray = [];
    $("[data-id='" + selector + "'] .single-option-selector option:selected").each(function () {
      indexArray.push($(this).index());
    });

    var form = jQuery("#product-select-" + selector).closest("form");
    for (var i = 0, length = variant.options.length; i < length; i++) {
      var num = indexArray[i];
      var radioButtonDiv = form.find('.swatch[data-option-index="' + i + '"] div.swatch-element')[
        num
      ];
      var radioButton = $(radioButtonDiv).find(":radio");
      if (radioButton.size()) {
        radioButton.get(0).checked = true;
      }
    }
  }

  var addToCart = productPanel.find("#addToCart"); // find the add to cart button
  var productPrice = productPanel.find(".product-info-price .money"); // find the price
  var comparePrice = productPanel.find("#comparePrice"); // find the compare price (not currently used in quick view)
  var smart_checkout_btn_qv = productPanel.find(".shopify-payment-button");

  if (variant) {
    if (variant.available) {
      // We have a valid product variant, so enable the submit button
      addToCart.removeClass("disabled").prop("disabled", false).val("Skip, and add to cart");
      smart_checkout_btn_qv.show();
    } else {
      // Variant is sold out, disable the submit button
      addToCart.val("Sold Out").addClass("disabled").prop("disabled", true);
      smart_checkout_btn_qv.hide();
    }

    // Also update and show the product's compare price if necessary
    if (comparePrice.length) {
      if (variant.compare_at_price > variant.price) {
        // Regardless of stock, update the product price
        comparePrice
          .html(Shopify.formatMoney(variant.compare_at_price, app.data.money_format))
          .show();
      } else {
        comparePrice.hide();
      }
    }
  } else {
    addToCart.val("Unavailable").addClass("disabled").prop("disabled", true);
    smart_checkout_btn_qv.hide();
  }
}; // END app.selectCallback()

function enabledQuickView() {
  jQuery(function () {
    // check to make sure the popup script is available
    if (typeof $().magnificPopup !== "function") {
      return;
    }

    // make sure the themes global object is available
    if (typeof app === "undefined") {
      return;
    }

    // check that we are on the right kind of template
    app.data.quickViewBtns = $("a.quick-view-btn"); /* find all the the quick view launch buttons */
    if (app.data.quickViewBtns.length) {
      // setup the quickview popup action
      app.data.quickViewBtns.magnificPopup({
        type: "inline",
        midClick: true,
        mainClass: "mfp-move-from-top",
        removalDelay: 1000,
        callbacks: {
          open: function () {
            var mp = $.magnificPopup.instance;
            var cur = mp.st.el;
            var href = $(cur).attr("href");
            var select = $(".mfp-move-from-top").find("#SingleOptionSelector-0");
            if (select.length) {
              select.trigger("change");
            }
          },
        },
      });
    }
  });

  /////////////////////////////////////
  //  Swatches
  /////////////////////////////////////

  jQuery(function () {
    jQuery(".swatch :radio").change(function () {
      var optionIndex = jQuery(this).closest(".swatch").attr("data-option-index");
      var optionValue = jQuery(this)
        .val()
        .replace(/\s{2,}/g, " ");
      jQuery(this)
        .closest("form")
        .find(".single-option-selector")
        .eq(optionIndex)
        .val(optionValue)
        .trigger("change");
    });
  });
}

/*!
  Zoom 1.7.13
  license: MIT
  http://www.jacklmoore.com/zoom
*/
(function (o) {
  var t = {
    url: !1,
    callback: !1,
    target: !1,
    duration: 120,
    on: "mouseover",
    touch: !0,
    onZoomIn: !1,
    onZoomOut: !1,
    magnify: 1,
  };
  (o.zoom = function (t, n, e, i) {
    var u,
      c,
      a,
      m,
      l,
      r,
      s,
      f = o(t).css("position"),
      h = o(n);
    return (
      (t.style.position = /(absolute|fixed)/.test(f) ? f : "relative"),
      (t.style.overflow = "hidden"),
      (e.style.width = e.style.height = ""),
      o(e)
        .addClass("zoomImg")
        .css({
          position: "absolute",
          top: 0,
          left: 0,
          opacity: 0,
          width: e.width * i,
          height: e.height * i,
          border: "none",
          maxWidth: "none",
          maxHeight: "none",
        })
        .appendTo(t),
      {
        init: function () {
          (c = o(t).outerWidth()),
            (u = o(t).outerHeight()),
            n === t ? ((m = c), (a = u)) : ((m = h.outerWidth()), (a = h.outerHeight())),
            (l = (e.width - c) / m),
            (r = (e.height - u) / a),
            (s = h.offset());
        },
        move: function (o) {
          var t = o.pageX - s.left,
            n = o.pageY - s.top;
          (n = Math.max(Math.min(n, a), 0)),
            (t = Math.max(Math.min(t, m), 0)),
            (e.style.left = t * -l + "px"),
            (e.style.top = n * -r + "px");
        },
      }
    );
  }),
    (o.fn.zoom = function (n) {
      return this.each(function () {
        var e,
          i = o.extend({}, t, n || {}),
          u = i.target || this,
          c = this,
          a = o(c),
          m = document.createElement("img"),
          l = o(m),
          r = "mousemove.zoom",
          s = !1,
          f = !1;
        (i.url || ((e = a.find("img")), e[0] && (i.url = e.data("src") || e.attr("src")), i.url)) &&
          ((function () {
            var o = u.style.position,
              t = u.style.overflow;
            a.one("zoom.destroy", function () {
              a.off(".zoom"), (u.style.position = o), (u.style.overflow = t), l.remove();
            });
          })(),
          (m.onload = function () {
            function t(t) {
              e.init(),
                e.move(t),
                l
                  .stop()
                  .fadeTo(
                    o.support.opacity ? i.duration : 0,
                    1,
                    o.isFunction(i.onZoomIn) ? i.onZoomIn.call(m) : !1
                  );
            }
            function n() {
              l.stop().fadeTo(i.duration, 0, o.isFunction(i.onZoomOut) ? i.onZoomOut.call(m) : !1);
            }
            var e = o.zoom(u, c, m, i.magnify);
            "grab" === i.on
              ? a.on("mousedown.zoom", function (i) {
                  1 === i.which &&
                    (o(document).one("mouseup.zoom", function () {
                      n(), o(document).off(r, e.move);
                    }),
                    t(i),
                    o(document).on(r, e.move),
                    i.preventDefault());
                })
              : "click" === i.on
              ? a.on("click.zoom", function (i) {
                  return s
                    ? void 0
                    : ((s = !0),
                      t(i),
                      o(document).on(r, e.move),
                      o(document).one("click.zoom", function () {
                        n(), (s = !1), o(document).off(r, e.move);
                      }),
                      !1);
                })
              : "toggle" === i.on
              ? a.on("click.zoom", function (o) {
                  s ? n() : t(o), (s = !s);
                })
              : "mouseover" === i.on &&
                (e.init(), a.on("mouseenter.zoom", t).on("mouseleave.zoom", n).on(r, e.move)),
              i.touch &&
                a
                  .on("touchstart.zoom", function (o) {
                    o.preventDefault(),
                      f
                        ? ((f = !1), n())
                        : ((f = !0),
                          t(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0]));
                  })
                  .on("touchmove.zoom", function (o) {
                    o.preventDefault(),
                      e.move(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0]);
                  }),
              o.isFunction(i.callback) && i.callback.call(m);
          }),
          (m.src = i.url));
      });
    }),
    (o.fn.zoom.defaults = t);
})(window.jQuery);

(function ($) {
  $.fn.hoverIntent = function (handlerIn, handlerOut, selector) {
    var cfg = {
      interval: 100,
      sensitivity: 6,
      timeout: 300,
    };
    if (typeof handlerIn === "object") {
      cfg = $.extend(cfg, handlerIn);
    } else {
      if ($.isFunction(handlerOut)) {
        cfg = $.extend(cfg, {
          over: handlerIn,
          out: handlerOut,
          selector: selector,
        });
      } else {
        cfg = $.extend(cfg, {
          over: handlerIn,
          out: handlerIn,
          selector: handlerOut,
        });
      }
    }
    var cX, cY, pX, pY;
    var track = function (ev) {
      cX = ev.pageX;
      cY = ev.pageY;
    };
    var compare = function (ev, ob) {
      ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
      if (Math.sqrt((pX - cX) * (pX - cX) + (pY - cY) * (pY - cY)) < cfg.sensitivity) {
        $(ob).off("mousemove.hoverIntent", track);
        ob.hoverIntent_s = true;
        return cfg.over.apply(ob, [ev]);
      } else {
        pX = cX;
        pY = cY;
        ob.hoverIntent_t = setTimeout(function () {
          compare(ev, ob);
        }, cfg.interval);
      }
    };
    var delay = function (ev, ob) {
      ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
      ob.hoverIntent_s = false;
      return cfg.out.apply(ob, [ev]);
    };
    var handleHover = function (e) {
      var ev = $.extend({}, e);
      var ob = this;
      if (ob.hoverIntent_t) {
        ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
      }
      if (e.type === "mouseenter") {
        pX = ev.pageX;
        pY = ev.pageY;
        $(ob).on("mousemove.hoverIntent", track);
        if (!ob.hoverIntent_s) {
          ob.hoverIntent_t = setTimeout(function () {
            compare(ev, ob);
          }, cfg.interval);
        }
      } else {
        $(ob).off("mousemove.hoverIntent", track);
        if (ob.hoverIntent_s) {
          ob.hoverIntent_t = setTimeout(function () {
            delay(ev, ob);
          }, cfg.timeout);
        }
      }
    };
    return this.on(
      {
        "mouseenter.hoverIntent": handleHover,
        "mouseleave.hoverIntent": handleHover,
      },
      cfg.selector
    );
  };
})(jQuery);

jQuery("#currencies").change(function () {
  cookieCurrency = $(this).val();
});

if (jQuery(window).width() > 991) {
  var product_grid_height = 0;
  var grid_height;
  var prod_height;
  var total = jQuery("#content .home_product .product_grid").length;
  jQuery("#content .home_product .product_grid").each(function (e) {
    grid_height = $(this).height();
    if (grid_height > product_grid_height) {
      product_grid_height = grid_height;
    }

    if (e == total - 1) {
      jQuery("#content .home_product .product_grid").css("height", product_grid_height + "px");
    }
  });
} else {
  jQuery("#content .home_product .product_grid").css("height", "auto");
}
$(window).resize(function () {
  if (jQuery(window).width() > 991) {
    var product_grid_height = 0;
    var grid_height;
    var total = jQuery("#content .home_product .product_grid").length;
    jQuery("#content .home_product .product_grid").each(function (e) {
      grid_height = $(this).height();
      if (grid_height > product_grid_height) {
        product_grid_height = grid_height;
      }
      if (e == total - 1) {
        prod_height = product_grid_height + "px";
        jQuery("#content .home_product .product_grid").css("height", prod_height);
      }
    });
  } else {
    jQuery("#content .home_product .product_grid").css("height", "auto");
  }
});

function enabledQuickViewAfterScroll() {
  jQuery(function () {
    // check to make sure the popup script is available
    if (typeof $().magnificPopup !== "function") {
      return;
    }

    // make sure the themes global object is available
    if (typeof app === "undefined") {
      return;
    }

    // check that we are on the right kind of template
    app.data.quickViewBtnsInfinite = $(
      ".just_loaded_elements a.quick-view-btn"
    ); /* find all the the quick view launch buttons */
    if (app.data.quickViewBtns.length) {
      // setup the quickview popup action
      app.data.quickViewBtnsInfinite.magnificPopup({
        type: "inline",
        midClick: true,
        mainClass: "mfp-move-from-top",
        removalDelay: 1000,
        callbacks: {
          open: function () {
            var mp = $.magnificPopup.instance;
            var cur = mp.st.el;
            var href = $(cur).attr("href");
            var select = $(".mfp-move-from-top").find("#SingleOptionSelector-0");
            if (select.length) {
              select.trigger("change");
            }
          },
        },
      });
    }

    $(".just_loaded_elements .swatch :radio").change(function () {
      var optionIndex = jQuery(this).closest(".swatch").attr("data-option-index");
      var optionValue = jQuery(this)
        .val()
        .replace(/\s{2,}/g, " ");
      jQuery(this)
        .closest("form")
        .find(".single-option-selector")
        .eq(optionIndex)
        .val(optionValue)
        .trigger("change");
    });
  });

  setTimeout(function () {
    $(".just_loaded_elements .quick-view-panel").each(function () {
      var selectID = $(this).data("id");
      var select = "product-select-" + selectID;
      var product = $(this).data("name");
      var qvpData = $(this).find(".data-qvp").text();
      var qvpJson = JSON.parse(qvpData);

      $(".quick-view-selector-" + qvpJson.id).on("change", function () {
        var $form = $(this).closest("form"),
          productVariantObj = qvpJson.variants;

        var option1 = $form.find("#SingleOptionSelector-0").val() || null,
          option2 = $form.find("#SingleOptionSelector-1").val() || null,
          option3 = $form.find("#SingleOptionSelector-2").val() || null,
          flag = true;
        for (var i = 0, length = productVariantObj.length; i < length; i++) {
          var productVar = productVariantObj[i];

          if (productVar.option1 != null) {
            productVar.option1 = productVar.option1.replace(/\s{2,}/g, " ");
          }
          if (productVar.option2 != null) {
            productVar.option2 = productVar.option2.replace(/\s{2,}/g, " ");
          }
          if (productVar.option3 != null) {
            productVar.option3 = productVar.option3.replace(/\s{2,}/g, " ");
          }

          if (
            option1 == productVar.option1 &&
            option2 == productVar.option2 &&
            option3 == productVar.option3
          ) {
            flag = false;
            $("#product-select-" + qvpJson.id).val(productVar.id);
            app.selectCallback(productVar, qvpJson.id);
            break;
          }
        }
        if (flag) {
          app.selectCallback(null, qvpJson.id);
        }
      });

      for (var i = 0, length = qvpJson.variants.length; i < length; i++) {
        var productVariants = qvpJson.variants[i];

        if (productVariants.available) {
          for (var j = 0, optlength = productVariants.options.length; j < optlength; j++) {
            var variantOption = productVariants.options[j];
            variantOption = handleizeStr(variantOption);
            $(
              ".swatch-product-id-" +
                qvpJson.id +
                ' .swatch[data-option-index="' +
                j +
                '"] .' +
                variantOption +
                ""
            )
              .removeClass("soldout")
              .addClass("available")
              .find(":radio")
              .removeAttr("disabled");
          }
        }
      }
      // BEGIN SWATCHES

      var indexArray = [];
      var productVariantOptions = qvpJson.variants;
      $("[data-id=" + qvpJson.id + "] .single-option-selector option:selected").each(function () {
        indexArray.push($(this).index());
      });
      var form = jQuery("#product-select-" + qvpJson.id).closest("form");
      var variantIndex = jQuery("#product-select-" + qvpJson.id + " option:selected").index();
      if (variantIndex >= 0) {
        var variant = productVariantOptions[variantIndex];
        for (var i = 0, length = variant.options.length; i < length; i++) {
          var num = indexArray[i];
          var radioButtonDiv = form.find(
            '.swatch[data-option-index="' + i + '"] div.swatch-element'
          )[num];
          var radioButton = $(radioButtonDiv).find(":radio");
          if (radioButton.size()) {
            radioButton.get(0).checked = true;
          }
        }
      }

      // END SWATCHES
    });
  }, 1000);
}

function enableInfiniteScroll(starsValue) {
  var infiniteScroll = new Waypoint.Infinite({
    element: $(".collection-grid")[0],
    items: ".collection-grid > .element",
    more: ".load-more__btn",
    onBeforePageLoad: function () {
      $(".load-more__icon").show();
      $(".just_loaded_elements").removeClass("just_loaded_elements");
    },
    loadingClass: "loading-in-progress",
    onAfterPageLoad: function (data) {
      data.each(function () {
        $(this).addClass("just_loaded_elements");
      });
      $(".load-more__icon").hide();
      $(".main_box").matchHeight();
      enabledQuickViewAfterScroll();

      if (starsValue == "true") {
        SPR.$(document).ready(function () {
          return (
            SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          );
        });
      }
    },
  });
}

function enableInfiniteScrollList() {
  var infiniteScroll = new Waypoint.Infinite({
    element: $(".collection-view-list")[0],
    items: ".collection-view-list > .collection-list",
    more: ".load-more__btn",
    onBeforePageLoad: function () {
      $(".load-more__icon").show();
    },
    loadingClass: "loading-in-progress",
    onAfterPageLoad: function (data) {
      $(".load-more__icon").hide();
    },
  });
}

theme.PasswordSection = (function () {
  function PasswordSection(container) {
    $(".js-toggle-login-modal").magnificPopup({
      type: "inline",
      mainClass: "mfp-fade",
      closeOnBgClick: false,
      closeBtnInside: false,
      closeOnContentClick: false,
      tClose: "Close",
      removalDelay: 500,
      callbacks: {
        open: function () {
          window.setTimeout(function () {
            document.getElementById("password").focus();
          }, 50);
        },
        close: function () {
          window.setTimeout(function () {
            document.getElementById("email").focus();
          }, 50);
        },
      },
    });
    if ($(".storefront-password-form .errors").size()) {
      $(".js-toggle-login-modal").click();
    }
  }

  return PasswordSection;
})();

$(document).ready(function () {
  var sections = new theme.Sections();

  sections.register("featured-products-section", theme.FeaturedProductsSection);
  sections.register("featured-collections-section", theme.FeaturedCollectionsSection);
  sections.register("instagram-feed-section", theme.InstagramFeedSection);
  sections.register("slideshow-section", theme.SlideshowSection);
  sections.register("featured-images-section", theme.FeaturedImagesSection);
  sections.register("blog-section", theme.BlogSection);
  sections.register("video-section", theme.VideoSection);
  sections.register("text-section", theme.TextSection);
  sections.register("blog-page-section", theme.BlogPageSection);
  sections.register("article-page-section", theme.ArticlePageSection);
  sections.register("collection-page-section", theme.CollectionPageSection);
  sections.register("collection-list-page-section", theme.CollectionListPageSection);
  sections.register("product-page-section", theme.ProductPageSection);
  sections.register("header-section", theme.HeaderSection);
  sections.register("map", theme.Maps);
  sections.register("password", theme.PasswordSection);

  enabledQuickView();

  //getAccordion("#tabs",768);
});

$(window).load(function () {
  setTimeout(function () {
    if (window.location.hash == "#contact_form") {
      // smooth scroll to the anchor id
      $("html, body").animate(
        {
          scrollTop: "9999px",
        },
        1000,
        "swing"
      );
    }
  }, 500);
});

/* accordion.js */

function getAccordion(element_id, screen) {
  //$(window).resize(function () { location.reload(); });

  if ($(window).width() < screen) {
    var concat = "";
    obj_tabs = $(element_id + " li").toArray();
    obj_cont = $(".tab-content .tab-pane").toArray();
    jQuery.each(obj_tabs, function (n, val) {
      concat += '<div id="' + n + '" class="panel panel-default">';
      concat += '<div class="panel-heading" role="tab" id="heading' + n + '">';
      concat +=
        '<h4 class="panel-title"><a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapse' +
        n +
        '" aria-expanded="false" aria-controls="collapse' +
        n +
        '">' +
        val.innerText +
        "</a></h4>";
      concat += "</div>";
      concat +=
        '<div id="collapse' +
        n +
        '" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading' +
        n +
        '">';
      concat += '<div class="panel-body">' + obj_cont[n].innerHTML + "</div>";
      concat += "</div>";
      concat += "</div>";
    });
    $("#accordion").html(concat);
    $("#accordion").find(".panel-collapse:first").addClass("in");
    $("#accordion").find(".panel-title a:first").attr("aria-expanded", "true");
    $(element_id).remove();
    $(".tab-content").remove();
  }
}

/* BEGIN yotpo review fix */
$(document).ready(function () {
  $("#yotpo_container").on("click", function (e) {
    //[DESKTOP] - Remove old classes & attributes
    $(".yotpo_tab").each(function (index) {
      $(this).removeClass("active");
      $(this).attr("aria-expanded", "false");
    });

    $(".tab-pane").each(function (index) {
      $(this).removeClass("active");
    });

    //[MOBILE] - Remove old classes & attributes
    $("#collapseOne").removeClass("in");
    $("#collapseOne").attr("aria-expanded", "false");
    $("#collapseOne").attr("style", "height: 0px;");

    //[DESKTOP] - Add new classes & attributes
    $("#yotpo_tab2").addClass("active");
    $("#yotpo_tab2").attr("aria-expanded", "true");

    //[MOBILE] - Add new classes & attributes
    $("#collapseTwo").attr("aria-expanded", "true");
    $("#collapseTwo").removeAttr("style");
    $("#collapseTwo").addClass("in");
    $("#tab2").addClass("active");

    //Scroll the review tab into view for the user
    var etop = $("#tab2").offset().top;
    $("html, body").animate(
      {
        scrollTop: etop,
      },
      1000
    );
  });
});
/* END yotpo review fix */

$(function () {
  $(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip({
      html: true,
      placement: "top",
    });
  });
});

/* Fix for the arrow re-sizing after newsletter form submission */
$(function () {
  $(document).ready(function () {
    if ($(".errors").length) {
      $("#footer .f_mid .email_box button").css("top", "33px");
    }
  });
});
